import React from "react";
import {
  Button,
  Col,
  FormLabel,
  Row,
  Table,
  FormControl,
} from "react-bootstrap";
import { AppContext } from "../AppContext.js";
import { ConfigManager } from "../config/ConfigManager.js";
import { NEW_ENTRY } from "../ds/App_Constants.js";
import { BaseBean, NodeData } from "../ds/client_ds.js";
import {
  AccountReceivableApplicableCreditMemoBean,
  AccountReceivableAppliedCreditMemoLineBean,
  AccountReceivableBean,
  AccountReceivableLineBean,
  CreditMemoBean,
  CreditMemoMerchandiseLineBean,
  CreditMemoNonMerchandiseLineBean,
  CreditMemoPrintRequest,
  CreditMemoReturnPaymentDetailBean,
  CreditMemoSalesPersonBean,
  CreditMemoSearchCriteria,
  CustomerBean,
  CustomerReturnBean,
  CustomerReturnSearchCriteria,
  CustomerSearchCriteria,
  FabricStyleBean,
  FabricStyleSearchCriteria,
  FabricStyleSKUBean,
  InvoiceBean,
  InvoiceSearchCriteria,
  PageListBean,
  ReasonBean,
  RestAccountReceivableBeanRequest,
  RestCreditMemoBeanRequest,
  RestCustomerListRequest,
  RestCustomerReturnListRequest,
  RestEntityUnLockRequest,
  RestFabricStyleListBeanRequest,
  RestInvoiceListRequest,
  RestPageListBean,
  RestReadRequest,
  RestSkuBatchInventoryListRequest,
  SKUBatchInventorySearchCriteria,
} from "../ds/ds.js";
import { LogicConstants } from "../ds/LogicConstants.js";
import {
  AddIcon,
  DeleteIcon,
  DropDwnDown,
  DropDwnUp,
} from "../gui_components/Icons.js";
import {
  AlertToolBox,
  DataGridColumnDefinition,
  DatePickerComponent,
  EditableDataGrid,
  InputCheckbox,
  InputTextbox,
  MessageBoxComponent,
  MultiViewPopup,
  NumberFormatInputbox,
  ProgressBar,
  ReasonCaptureComponent,
  ShortCutMenuPopup,
  ShowError,
  DatePickerComponent_adv,
  ColumnDefinition,
} from "../gui_components/UIComponents.js";
import {
  isEmpty,
  isEmptyArray,
  isEmptyString,
  toFormattedDate_v1,
  toCommaSeperatedAmount,
  toDownloadReportAddress,
} from "../gui_components/Util.js";
import {
  PopupCustomerCurrentAgingInq,
  PopupCustomerMostRecentFabricsInq,
  PopupCustomerOnOrderInq,
  PopupCustomerSalesHistoryInq,
  PopupCustomerStatisticsInq,
  PopupCustomerTransactionsInq,
} from "../Inquiry/InquiryUtil.js";
import { CreditMemoLookupHandler } from "../lookup/CreditMemoLookupHandler.js";
import { CustomerLookupHandler } from "../lookup/CustomerLookupHandler.js";
import { CustomerReturnLookupHandler } from "../lookup/CustomerReturnLookupHandler.js";
import { FabricStyleLookupHandler } from "../lookup/FabricStyleLookupHandler.js";
import { GenericAttributeLookupHandler } from "../lookup/GenericAttributeLookupHandler.js";
import { InvoiceLookupHandlers } from "../lookup/InvoiceLookupHandlers.js";
import {
  PopupARModule,
  PopupCustomerModule,
  PopupInvoiceModule,
} from "../modules/ModuleUtil.js";
import { SecurityAccessManager } from "../security/SecurityAccessManager.js";
import { AccountReceivableService } from "../services/AccountReceivableService";
import { CreditMemoService } from "../services/CreditMemoService";
import { CustomerReturnService } from "../services/CustomerReturnService.js";
import { CustomerService } from "../services/CustomerService.js";
import { FabricStyleService } from "../services/FabricStyleService";
import { InventoryService } from "../services/InventoryService.js";
import { InvoiceService } from "../services/InvoiceService";
import { ReportService } from "../services/ReportService.js";
import { CreditMemoModuleToolBar } from "../toolBar/CreditMemoModuleToolBar.js";
import { BaseNodeBar, BaseToolBar, ModuleToolBar } from "./BaseModule.js";
import { ModuleUtils } from "./ModuleUtils.js";
import {
  LayoutList,
  DollarSign,
  FileText,
  Home,
  History,
  AlignStartVertical,
  FolderOpen,
  CircleDollarSign,
} from "lucide-react";
import CustomTable from "../gui_components/CustomTable.js";

class CreditMemoList extends React.Component {
  static contextType = AppContext;
  constructor(props) {
    super(props);
    this.advanceSearchDialogRef = React.createRef();
    this.invoiceLinesRef = React.createRef();
    this.returnToCustomerDialogRef = React.createRef();
    this.applytoInvoiceDialogRef = React.createRef();
    this.creditMemoEntryFormRef = React.createRef();
    this.applytoInvoiceNumberRef = React.createRef();
    this.unapproveReasonDialogRef = React.createRef();
    this.customerReturnRef = React.createRef();
    this.cancelReasonDialogRef = React.createRef();
    this.warningMessageDialogRef = React.createRef();
    this.applytoInvoiceFormSkylightStyles = {
      width: "80%",
      height: "calc(80% - 50px)",
      marginTop: "-150px",
      marginLeft: "-40%",
      overflowX: "none",
      top: "40%",
      overflowY: "scroll",
    };
    this.state = {
      pageTitle: "CreditMemo",
      creditMemo_list: new Array(),
      isCreditMemoListFormOpen: true,
      companyCode: "",
      pageList: new PageListBean(),
      isLoading: false,
      criteria: new CreditMemoSearchCriteria(),
      cmData: new CreditMemoBean(),
      returnPaymentDetail: new CreditMemoReturnPaymentDetailBean(),
      arLines: [],
      currentARLine: new AccountReceivableLineBean(),
      arData: new AccountReceivableBean(),
      isDisableFields: false,
      currentPageNumber: 0,
      totalCount: 0,
      isShowSaveButton: false,
      isShowClearCriteriaButton: false,
      isShowClearErrorButton: false,
      isShowBackButton: false,
      isShowPDFButton: false,
      isShowExcelButton: false,
      isShowApproveButton: false,
      isShowUnApproveButton: false,
      isShowCancelButton: false,
      isShowApplyToInvoiceButton: false,
      isShowRefundButton: false,
      isShowApprovePrintButton: false,
      isShowAdjustButton: false,
      isShowLoadCustomerReturnButton: false,
      error_list: [],
      isCreditMemoEntryFormOpen: false,
      customerData: new CustomerBean(),
      isAdvanceSearch: false,
      creditMemoTypes: [],
      isCustomerDataLoding: false,
      customer_list: [],
      merchandiseLineData: new CreditMemoMerchandiseLineBean(),
      nonMerchandiseLineData: new CreditMemoNonMerchandiseLineBean(),
      adjustNonMerchandiseData: new CreditMemoNonMerchandiseLineBean(),
      invoiceData: new InvoiceBean(),
      selectedARRows: [],
      selectedCRRows: [],
      isInvoiceDataLoding: false,
      invoice_list_for_return: [],
      invoiceLines: [],
      selectedInvoiceLines: [],
      creditCardTypes: [],
      creditSubTypes: [],
      isReLoadRequired: false,
      invoice_list_for_apply: [],
      warehouses: [],
      isShowPopup: false,
      simplePopupContent: [],
      alertMessage: [],
      alertType: "",
      isShowAlert: false,
      isReadOnlyOrDisabled: false,
      isSpecialViewMode: false,
      fabricStyleData: new FabricStyleBean(),
      colorList: [],
      creditReasons: [],
      isShowMerchandiseLinePopup: false,
      simpleMerchandiseLinePopupContent: [],
      merchandiseLineAlertMessage: [],
      merchandiseLineAlertType: "",
      isShowMerchandiseLineAlert: false,
      isShowModuleSearchContainer: false,
      moduleKeyCode: "NEW",
      isResetModule: false,
      disabled: false,
      creditMemoLookupHandler: null,
      invoiceLookupHandler: null,
      isResetView: false,
      isFocus: false,
      isFocusLookup: true,
      isShowInvoiceLookup: false,
      isShowRefundPopup: false,
      selectedNodeKey: "headerView",
      isCreditMemoHistoryFormOpened: false,
      isCreditMemoPaymentFormOpened: false,
      isCommissionFormOpened: false,
      isCommentsAndNotesFormOpened: false,
      isShowNodes: false,
      nodeList: [],
      summaryData: "",
      isShowLoadCustomerReturnButton: false,
      isShowCustomerReturnPopup: false,
      reasonData: new ReasonBean(),
      isShowUnApprovePopup: false,
      commissionData: new CreditMemoSalesPersonBean(),
      salesPersonList: [],
      isShowAdjustPopup: false,
      customerReturnData: new CustomerReturnBean(),
      creditMemoAppliedLines: [],
      isShowARModule: false,
      isShowInvoiceModule: false,
      moduleForPopup: [],
      readARCreditMemoList: [],
      isShowNonMerchandiseLinePopup: false,
      isShowCustomerModule: false,
      isShowCustomerOnOrderInq: false,
      isShowCustomerTransactionsInq: false,
      isShowCustomerStatisticsInq: false,
      isShowCustomerSalesHistoryInq: false,
      isShowCustomerMostRecentFabricsInq: false,
      isCustomerCurrentAgingInq: false,
      isShowAdvanceSearchPopup: false,
      isShowFetchInvoicePopup: false,
      isShowApplyInvoicePopup: false,
      isShowOnHandQtyPopup: false,
      rollLines: [],
      fetchInvoiceLines: [],
      isShowDelete: false,
      isShowMercDelete: false,
      isShowColorLookup: false,
      colorLookupHandler: null,
      reasonData: new ReasonBean(),
      isopenQtyPopup: false,
      already_AppliedAmount_Total_Calc: 0,
      currently_Applied_Amount: 0,
      remaingAmount_Calc: 0,
      isShowAutoCompleteCreditTypeList: false,
      creditTypePageListForAutoCompleteList: new Array(),
      isShowAutoCompleteCreditSubTypeList: false,
      creditSubTypePageListForAutoCompleteList: new Array(),
      isShowAutoCompleteLocationList: false,
      locationPageListForAutoCompleteList: new Array(),
      isShowAutoCompleteCustomerList: false,
      customerPageListForAutoCompleteList: new Array(),
      isShowAutoCompleteFabricList: false,
      fabricPageListForAutoCompleteList: new Array(),
      isShowAutoCompleteCreditsubTypeList: false,
      creditsubTypePageListForAutoCompleteList: new Array(),
      isShowAutoCompleteCreditsubtypeList: false,
      creditsubtypePageListForAutoCompleteList: new Array(),
      isShowAutoCompleCommissionList: false,
      commissionPageListForAutoCompleteList: new Array(),
      isShowAutoCompleReasonList: false,
      reasonPageListForAutoCompleteList: new Array(),
      isShowAutoCompleCustomerReturnList: false,
      customerReturnPageListForAutoCompleteList: new Array(),
      isShowAutoCompleteBillToList: true,
      billToPageListForAutoCompleteList: new Array(),
      isShowBillToLookup: false,
      billToLookupHandler: null,
      billTos: [],
      isShowProgressBarPopup: false,
      progressLoadingText: "",
      disableCMFormFields: false,
      isShowAlertLvl5: false,
      isShowAlertLvl2: false,
      isShowAlertLvl3: false,
      isShowBillToLookup: false,
      billToLookupHandler: null,
      isMaintenanceMode: true,
      isShowCancelReasonPopup: false,
      isShowUnApproveReasonPopup: false,
      showAutoCompleteReasonList: false,
      reasonPageListForAutoCompleteList: new Array(),
      showAutoCompleteUnApproveReasonList: false,
      unApproveReasonPageListForAutoCompleteList: new Array(),
      isDisableHeaderFields: false,
      invoiceWarningMessage: "",
      isShowWarningMsgPopup: false,
      order: "",
      sortField: "",
      is3PL: false,
      isReseted: false,
      isViewMode: false,
      statusTrackList: [],
      creditMemoCommisionList: [],
      merchandiseLinesList: [],
      nonMerchandiseLinesList: [],
      returnPaymentLinesList: [],
      isShowAutoCompleteapplyInvoiceList: false,
    };
  }
  code = NEW_ENTRY;
  isLocked = false;
  componentDidMount() {
    const { appData } = this.context;
    this.companyCode = appData.companyCode;
    if (ConfigManager.isPurchaseBasedOnCustomerFlag()) {
      this.state.is3PL = true;
      this.setState({
        is3PL: true,
      });
    }
    this.report_url = appData.reportURL;
    ModuleUtils.getCreditMemoStatusList();
    let criteria = new CreditMemoSearchCriteria();
    criteria.companyCode = this.companyCode;
    let pageInput = new PageListBean();
    pageInput.pageSize = 50;
    let currentPage = this.state.pageList.currentPage;
    if (currentPage == null || currentPage <= 0) {
      pageInput.currentPage = 1;
    } else {
      pageInput.currentPage = currentPage;
    }
    this.state.pageList = pageInput;
    this.state.criteria = criteria;
    let isReadOnly = this.state.isReadOnlyOrDisabled;
    let isSpecialViewMode = this.state.isSpecialViewMode;
    if (this.props.isSpecialViewMode) {
      isSpecialViewMode = this.props.isSpecialViewMode;
      isReadOnly = this.props.isSpecialViewMode;
    }
    this.setState({
      isReadOnlyOrDisabled: isReadOnly,
      isSpecialViewMode: isSpecialViewMode,
    });
    if (this.props.code !== "" && this.props.code !== undefined) {
      this.code = this.props.code;

      this.editCreditMemo(this.props.code);
      this.setState({
        isResetView: false,
        isMaintenanceMode: false,
        disableCMFormFields: true,
        isViewMode: false,
      });
    } else {
      this.addNewEntry();
      // this.loadCreditMemoPage();
    }
    const { cache } = appData;
    this.cache = cache;
    const attribute_cache = { ...cache };
    // let attribute_cache = JSON.parse(localStorage.getItem("attributeCache"));
    this.sessionBean = JSON.parse(localStorage.getItem("session"));
    ModuleUtils.getCreditMemoStatusList();
    ModuleUtils.getCreditMemoLineStatusList();
    let creditMemoTypes = [];
    creditMemoTypes = attribute_cache.creditMemoTypes;
    let creditMemoTypes_temp = [];
    if (!isEmptyArray(creditMemoTypes)) {
      creditMemoTypes_temp = creditMemoTypes;
      this.state.creditMemoTypes =
        ModuleUtils.isActiveAttribute(creditMemoTypes_temp);
    }
    this.state.creditCardTypes = [];
    let creditCardTypes = attribute_cache.creditCardTypes;
    let creditCardTypes_temp = [];
    if (!isEmptyArray(creditCardTypes)) {
      creditCardTypes.map((ent) => {
        creditCardTypes_temp.push(ent);
        this.state.creditCardTypes =
          ModuleUtils.isActiveAttribute(creditCardTypes_temp);
      });
    }
    this.state.creditSubTypes = [];
    let creditSubTypes = attribute_cache.creditMemoSubTypes;
    let creditSubTypes_temp = [];
    if (!isEmptyArray(creditSubTypes)) {
      creditSubTypes.map((ent) => {
        creditSubTypes_temp.push(ent);
        this.state.creditSubTypes =
          ModuleUtils.isActiveAttribute(creditSubTypes_temp);
      });
    }
    let warehouses = attribute_cache.warehouses;
    let warehouses_temp = [];
    if (warehouses != null || warehouses != undefined) {
      warehouses.map((attr) => {
        warehouses_temp.push(attr);
        this.state.warehouses = ModuleUtils.isActiveAttribute(warehouses_temp);
      });
    }
    this.state.salesPersonList = [];
    let salesPersonList = attribute_cache.salesPersons;
    if (salesPersonList != null || salesPersonList != undefined) {
      salesPersonList.map((ent) => {
        this.state.salesPersonList.push(ent);
      });
    }
    let creditReasons = attribute_cache.creditReasons;
    if (creditReasons != null || creditReasons != undefined) {
      creditReasons.map((attr) => {
        this.state.creditReasons.push(attr);
      });
    }
    this.getCustomerPageList();
    this.initLookupHandlers();
  }
  unlockCreditMemoResponse = (response) => {
    this.setState({ isLoading: false });
    if (!isEmpty(response.data)) {
      if (response.data.isSuccess) {
        if (this.isLocked) {
          this.editCreditMemo(this.code);
        } else {
          this.isLocked = false;
        }
      } else {
        // this.isLocked = false; optional
        if (!this.state.isReseted) this.showErrorMessage(response.data);
      }
    }
  };
  unlockCreditMemoError = (error) => {
    let errList = [];
    errList.push(error.toString());
    this.setState({ error_list: errList, isLoading: false });
  };
  unlockCreditMemo = (creditNumber) => {
    this.setState({ isLoading: true });
    let request = new RestEntityUnLockRequest();
    request.companyCode = this.companyCode;
    request.entityCode = creditNumber;
    if (SecurityAccessManager.CreditMemoMaintenance_IsAccessible()) {
      CreditMemoService.unLockCreditMemoNumber(
        request,
        this.unlockCreditMemoResponse,
        this.unlockCreditMemoError,
      );
    } else {
      let errMsg = "Access Denied";
      let errList = [];
      errList.push(errMsg);

      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
  };
  initLookupHandlers = () => {
    let creditSubTypeLookupHandler = new GenericAttributeLookupHandler(
      this.state.creditSubTypes,
      "Credit Memo SubType",
    );
    this.setState({ creditSubTypeLookupHandler: creditSubTypeLookupHandler });
    if (this.state.is3PL) {
      let fabricLookupHandler = new FabricStyleLookupHandler(
        this.companyCode,
        "Item",
      );
      this.setState({ fabricLookupHandler: fabricLookupHandler });
    } else {
      let fabricLookupHandler = new FabricStyleLookupHandler(
        this.companyCode,
        "FabricStyle",
      );
      this.setState({ fabricLookupHandler: fabricLookupHandler });
    }

    let warehouseLookupHandler = new GenericAttributeLookupHandler(
      this.state.warehouses,
      "Warehouse",
    );
    this.setState({ warehouseLookupHandler: warehouseLookupHandler });
    let customerReturnLookupHandler = new CustomerReturnLookupHandler(
      this.companyCode,
      "CustomerReturn",
    );
    this.setState({ customerReturnLookupHandler: customerReturnLookupHandler });
    let creditMemoLookupHandler = new CreditMemoLookupHandler(
      this.companyCode,
      "CreditMemo",
    );
    this.setState({
      creditMemoLookupHandler: creditMemoLookupHandler,
    });
    let customerLookupHandler = new CustomerLookupHandler(
      this.companyCode,
      "Customer",
    );
    this.setState({ customerLookupHandler: customerLookupHandler });
    let creditMemoTypeLookupHandler = new GenericAttributeLookupHandler(
      this.state.creditMemoTypes,
      "CreditMemoType",
    );
    this.setState({ creditMemoTypeLookupHandler: creditMemoTypeLookupHandler });
  };
  readandValidateInvoiceResponse = (response) => {
    let cmData = this.state.cmData;
    let isValidInvoice = false;
    if (response != null) {
      if (response.data.invoice != null) {
        if (!cmData.isFetched) {
          isValidInvoice = this.validateInvoice(response.data.invoice);
          if (isValidInvoice) {
            this.setState({ invoiceData: response.data.invoice });
            isValidInvoice = true;
          } else {
            cmData.invoiceNumber = "";
            this.setState({ cmData: cmData });
          }
        } else {
          this.setState({ invoiceData: response.data.invoice });
        }
      }
    }
  };
  readandValidateInvoiceError = (error) => {
    ShowError("Error : " + error);
  };
  readandValidateInvoice = (code) => {
    let readrestInput = new RestReadRequest();
    readrestInput.companyCode = this.companyCode;
    readrestInput.code = code;
    if (SecurityAccessManager.CreditMemoMaintenance_IsAccessible()) {
      InvoiceService.readInvoice(
        readrestInput,
        this.readandValidateInvoiceResponse,
        this.readandValidateInvoiceError,
      );
    } else {
      let errMsg = "Access Denied";
      let errList = [];
      errList.push(errMsg);

      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
  };
  onFetchInvoiceClickResponse = (response) => {
    let err_msg = "";
    let err_list = [];
    if (response.data.resultBean != null) {
      if (
        response.data.resultBean.invoiceRollLinesWithPrice != null &&
        !isEmptyArray(response.data.resultBean.invoiceRollLinesWithPrice)
      ) {
        let invLines = response.data.resultBean.invoiceRollLinesWithPrice;
        this.setState({ invoiceLines: invLines });
        this.setState({
          fetchInvoiceLines: invLines,
        });
        if (
          invLines != null &&
          invLines.length > 0 &&
          !isEmptyArray(invLines)
        ) {
          let cmData = this.state.cmData;
          if (!isEmptyArray(cmData.merchandiseLines)) {
            this.setAndShowInvoiceLines(cmData.merchandiseLines, invLines);
          } else {
            this.showInvoiceLines();
          }
        } else {
          err_msg = "No Invoice !! ";
          err_list.push(err_msg);

          this.setState({
            alertMessage: err_list,
            alertType: "danger",
            isShowAlert: true,
          });
        }
      }
    } else {
      err_msg = "Invalid Invoice#!  No Invoice !! ";
      err_list.push(err_msg);
      this.setState({
        alertMessage: err_list,
        alertType: "danger",
        isShowAlert: true,
      });
    }
  };
  onFetchInvoiceClickError = (error) => {
    ShowError("Error : " + error);
  };
  validateInvoice = (invoiceData) => {
    let cmData = this.state.cmData;
    let isValidInvoice = false;
    let err_msg = "";
    let err_list = [];
    if (invoiceData == null || invoiceData == undefined) {
      err_msg = "Invalid data ";
      err_list.push(err_msg);
    } else {
      if (invoiceData.invoiceStatus == LogicConstants.INVOICE_CANCEL_STATUS) {
        err_msg =
          "Invalid Invoice!  Invoice# : " +
          this.state.cmData.invoiceNumber +
          " is Cancelled ";
        err_list.push(err_msg);
      }
      if (
        invoiceData.invoiceStatus == LogicConstants.INVOICE_UNAPPROVE_STATUS
      ) {
        err_msg =
          "Invalid Invoice!  Invoice# : " +
          this.state.cmData.invoiceNumber +
          " is Unapproved ";
        err_list.push(err_msg);
      }
      if (!cmData.isFetched) {
        if (invoiceData.customerCode !== this.state.cmData.customerCode) {
          err_msg = "Invalid Invoice!  Customer is  Mismatched! ";
          err_list.push(err_msg);
        }
      }
      if (isEmptyString(this.state.cmData.invoiceNumber)) {
        err_msg = "Invalid Invoice! ";
        err_list.push(err_msg);
      }
    }
    if (err_list.length > 0) {
      isValidInvoice = false;
      this.setState({
        alertMessage: err_list,
        alertType: "danger",
        isShowAlert: true,
      });
    } else {
      isValidInvoice = true;
      this.setState({ isShowAlert: false });
    }
    return isValidInvoice;
  };
  fetchInvoiceOnClick = () => {
    let invoiceData = this.state.invoiceData;
    let isValid = false;
    isValid = this.validateInvoice(invoiceData);
    if (isValid == true) {
      this.readandValidateInvoiceForCreditMemo();
    }
  };
  getFetchInvoices = () => {
    let creditMemoBean = new CreditMemoBean();
    creditMemoBean.companyCode = this.companyCode;
    creditMemoBean.invoiceNumber = this.state.cmData.invoiceNumber;
    if (SecurityAccessManager.CreditMemoMaintenance_IsAccessible()) {
      CreditMemoService.getRollLinesForInvoiceNumbers(
        creditMemoBean,
        this.onFetchInvoiceClickResponse,
        this.onFetchInvoiceClickError,
      );
    } else {
      let errMsg = "Access Denied";
      let errList = [];
      errList.push(errMsg);

      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
  };
  readandValidateInvoiceForCreditMemo = () => {
    let readrestInput = new RestReadRequest();
    readrestInput.companyCode = this.companyCode;
    readrestInput.code = this.state.cmData.invoiceNumber;
    if (SecurityAccessManager.CreditMemoMaintenance_IsAccessible()) {
      CreditMemoService.getValidCreditMemosForInvoiceNumber(
        readrestInput,
        this.readandValidateCreditMemoInvoiceResponse,
        this.readandValidateCreditMemoInvoiceError,
      );
    } else {
      let errMsg = "Access Denied";
      let errList = [];
      errList.push(errMsg);

      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
  };
  readandValidateCreditMemoInvoiceResponse = (response) => {
    let creditMemoCode = "";
    if (
      response != null &&
      response.data != null &&
      response.data.creditMemoPageList != null
    ) {
      if (!isEmptyArray(response.data.creditMemoPageList.creditMemos)) {
        response.data.creditMemoPageList.creditMemos.map((ln) => {
          creditMemoCode = ln.code;
          // creditMemoCode += ", ";
        });
        let invoiceNumber = this.state.cmData.invoiceNumber;
        let displayMessage =
          " Following CreditMemo(s) already used for return by this Invoice# [ " +
          invoiceNumber +
          " ] CreditMemo [" +
          creditMemoCode +
          "] Do You Want to Continue ?";
        this.setState({ invoiceWarningMessage: displayMessage });
        this.warningMessageForCredit();
      } else {
        this.getFetchInvoices();
      }
    }
  };
  readandValidateCreditMemoInvoiceError = (error) => {
    ShowError("Error : " + error);
  };
  warningMessageForCredit = () => {
    this.setState({ isShowWarningMsgPopup: true });
  };
  onYesButtonClick = () => {
    this.getFetchInvoices();
    this.closeMessageModelCallBack();
  };
  onNoButtonClick = () => {
    this.setState({ isShowFetchInvoicePopup: false });
    this.closeMessageModelCallBack();
  };
  closeMessageModelCallBack = () => {
    this.setState({ isShowWarningMsgPopup: false });
  };

  onNonMerchandiseChange = (e) => {
    let temp_nonMerchandiseLineData = this.state.nonMerchandiseLineData;
    temp_nonMerchandiseLineData[e.target.name] = e.target.value;
    this.setState({ nonMerchandiseLineData: temp_nonMerchandiseLineData });
  };
  onMerchandiseChange = (e) => {
    let temp_merchandiseLineData = this.state.merchandiseLineData;
    temp_merchandiseLineData[e.target.name] = e.target.value;
    if (e.target.name == "price") {
      let lineTotalAmount = 0;
      lineTotalAmount =
        this.state.merchandiseLineData.lineTotalReturnQuantity * e.target.value;
      temp_merchandiseLineData["lineTotalAmount"] = lineTotalAmount;
    } else if (e.target.name == "lineTotalReturnQuantity") {
      let lineTotalAmount = 0;
      lineTotalAmount = this.state.merchandiseLineData.price * e.target.value;
      temp_merchandiseLineData["lineTotalAmount"] = lineTotalAmount;
    }
    this.setState({ merchandiseLineData: temp_merchandiseLineData });
  };
  openNonMerchandiseLineDetailDialog = () => {
    this.setState({ isShowNonMerchandiseLinePopup: true });
  };
  openMerchandiseLineDetailDialog = () => {
    this.setState({ isShowMerchandiseLinePopup: true });
  };
  addorUpdateMerchandiseLine = (e) => {
    if (e.detail == 1) {
      let isValidLine = false;
      isValidLine = this.validateMerchandiseLine();
      if (isValidLine) {
        let temp_merchandiseLineData = this.state.merchandiseLineData;
        let temp_cmData = this.state.cmData;
        let mercLines = temp_cmData.merchandiseLines;
        temp_merchandiseLineData.lineStatus = "O";
        temp_merchandiseLineData.currencyCode =
          temp_cmData.customerCurrencyCode;
        if (isEmptyString(temp_merchandiseLineData.currencyCode)) {
          let currencyCode = ConfigManager.getCurrencyCode();
          temp_merchandiseLineData.currencyCode = currencyCode;
        }
        if (isEmptyArray(mercLines)) {
          let errMsg =
            "NewLine Entry is not allowed! Fetch Invoice Lines After enter the Invoice";
          let errList = [];
          errList.push(errMsg);
          this.setState({
            alertMessage: errList,
            alertType: "danger",
            isShowAlertLvl5: true,
          });
        } else {
          mercLines.map((ln, i) => {
            if (ln.lineNumber == temp_merchandiseLineData.lineNumber) {
              temp_merchandiseLineData.lineNumber = ln.lineNumber;
              temp_merchandiseLineData.isFetched = ln.isFetched;
              mercLines[i] = temp_merchandiseLineData;
            }
          });
          let merchandiseLines = this.state.merchandiseLinesList;
          temp_cmData.merchandiseLines = mercLines;
          merchandiseLines = mercLines;
          this.setState({
            cmData: temp_cmData,
            merchandiseLinesList: merchandiseLines,
            merchandiseLineData: new CreditMemoMerchandiseLineBean(),
          });
          this.calculateTotals();
          this.closeMerchandiseLineAlertModalCallBack();
        }
      }
    }
  };
  addorUpdateNonMerchandiseLine = (e) => {
    if (e.detail == 1) {
      let cmData = this.state.cmData;
      let nonMerchandiseLineData = this.state.nonMerchandiseLineData;
      nonMerchandiseLineData.companyCode = this.companyCode;
      nonMerchandiseLineData.code = cmData.code;
      nonMerchandiseLineData.lineStatus =
        LogicConstants.CREDIT_MEMO_LINE_OPEN_STATUS;
      nonMerchandiseLineData.currencyCode = cmData.customerCurrencyCode;
      if (isEmptyString(nonMerchandiseLineData.currencyCode)) {
        let currencyCode = ConfigManager.getCurrencyCode();
        nonMerchandiseLineData.currencyCode = currencyCode;
      }
      let non_MerchLines = cmData.nonMerchandiseLines;
      let nonMerchandiseLines = this.state.nonMerchandiseLinesList;
      let isValid = false;
      isValid = this.validateNonMerchandiseLine();
      if (isValid) {
        var lineNumber = this.getMaxLineNumberNonMerchandiseLines();
        let isLineFound = false;
        if (!isEmptyArray(non_MerchLines)) {
          non_MerchLines.map((line, i) => {
            if (line.creditSubType == nonMerchandiseLineData.creditSubType) {
              nonMerchandiseLineData.lineNumber = line.lineNumber;
              nonMerchandiseLineData.isFetched = line.isFetched;
              non_MerchLines[i] = nonMerchandiseLineData;
              isLineFound = true;
            } else if (line.lineNumber == nonMerchandiseLineData.lineNumber) {
              nonMerchandiseLineData.isFetched = line.isFetched;
              non_MerchLines[i] = nonMerchandiseLineData;
              isLineFound = true;
            }
          });
        }
        if (!isLineFound) {
          nonMerchandiseLineData.lineNumber = ++lineNumber;
          non_MerchLines.push(nonMerchandiseLineData);
        }
        cmData.nonMerchandiseLines = non_MerchLines;
        nonMerchandiseLines = non_MerchLines;
        this.setState({
          cmData: cmData,
          isDisablePopupFields: true,
          nonMerchandiseLinesList: nonMerchandiseLines,
        });
        this.closeNonMerchandiseLineAlertModalCallBack(false);
        this.calculateTotals();
      }
      this.clearNonMerchandiseLineValues(e);
    }
  };
  validateNonMerchandiseLine = () => {
    let isValidNonMerchandiseLine = false;
    let err_list = [];
    let errorMessage = "";
    let temp_nonMerchandiseLineData = this.state.nonMerchandiseLineData;
    if (temp_nonMerchandiseLineData == null) {
      let errMsg = "Invalid data ";
      errorMessage = errorMessage + errMsg;
      err_list.push(errMsg);
    } else {
      if (isEmptyString(temp_nonMerchandiseLineData.creditSubType)) {
        let errMsg = "CreditSubType is Required";
        errorMessage = errorMessage + errMsg;
        err_list.push(errMsg);
      }
      if (isEmptyString(temp_nonMerchandiseLineData.lineTotalAmount)) {
        let errMsg = "Amount is Required";
        errorMessage = errorMessage + errMsg;
        err_list.push(errMsg);
      }
    }
    if (err_list.length > 0) {
      isValidNonMerchandiseLine = false;
      this.setState({
        alertMessage: err_list,
        alertType: "danger",
        isShowAlertLvl5: true,
      });
    } else {
      isValidNonMerchandiseLine = true;
    }
    return isValidNonMerchandiseLine;
  };
  validateMerchandiseLine = () => {
    let isValidMerchandiseLine = false;
    let err_list = [];
    let errorMessage = "";
    let temp_merchandiseLineData = this.state.merchandiseLineData;
    if (temp_merchandiseLineData == null) {
      let errMsg = "Invalid data ";
      errorMessage = errorMessage + errMsg;
      err_list.push(errMsg);
    } else {
      if (isEmptyString(temp_merchandiseLineData.fabricStyleCode)) {
        let errMsg = "Item is Required";
        errorMessage = errorMessage + errMsg;
        err_list.push(errMsg);
      }
      if (isEmptyString(temp_merchandiseLineData.colorCode)) {
        let errMsg = "Color is Required";
        errorMessage = errorMessage + errMsg;
        err_list.push(errMsg);
      }
      if (isEmptyString(temp_merchandiseLineData.creditSubType)) {
        let errMsg = "CreditSubType is Required";
        errorMessage = errorMessage + errMsg;
        err_list.push(errMsg);
      }
      if (isEmptyString(temp_merchandiseLineData.lineTotalAmount)) {
        let errMsg = "Amount is Required";
        errorMessage = errorMessage + errMsg;
        err_list.push(errMsg);
      }
    }
    if (err_list.length > 0) {
      isValidMerchandiseLine = false;
      this.setState({
        alertMessage: err_list,
        alertType: "danger",
        isShowAlertLvl5: true,
      });
    } else {
      isValidMerchandiseLine = true;
    }
    return isValidMerchandiseLine;
  };
  getNonMerchandiseLine = (lineNumber) => {
    let nonMerchandiseLine = null;
    if (isEmpty(this.state.cmData)) return nonMerchandiseLine;
    else if (isEmptyArray(this.state.cmData.nonMerchandiseLines))
      return nonMerchandiseLine;
    else {
      this.state.cmData.nonMerchandiseLines.map((line) => {
        if (line.lineNumber === lineNumber) {
          nonMerchandiseLine = line;
          return nonMerchandiseLine;
        }
      });
    }
    return nonMerchandiseLine;
  };
  getMerchandiseLine = (lineNumber) => {
    let merchandiseLine = null;
    if (isEmpty(this.state.cmData)) return merchandiseLine;
    else if (isEmptyArray(this.state.cmData.merchandiseLines))
      return merchandiseLine;
    else {
      this.state.cmData.merchandiseLines.map((line) => {
        if (line.lineNumber === lineNumber) {
          merchandiseLine = line;
          return merchandiseLine;
        }
      });
    }
    return merchandiseLine;
  };
  getAccountReceivableLine = () => {
    let accountReceivableLine = null;
    if (isEmpty(this.state.arLines)) return accountReceivableLine;
    else if (isEmpty(this.state.currentARLine)) return accountReceivableLine;
    else if (isEmptyArray(this.state.arLines)) return accountReceivableLine;
    else {
      this.state.arLines.map((line) => {
        if (
          line.accountReceivableNumber ===
            this.state.currentARLine.accountReceivableNumber &&
          line.invoiceNumber === this.state.currentARLine.invoiceNumber
        ) {
          accountReceivableLine = line;
          return accountReceivableLine;
        }
      });
    }
    return accountReceivableLine;
  };
  getMaxLineNumberNonMerchandiseLines = () => {
    let maxLineNumber = 0;
    let cmData = this.state.cmData;
    if (!isEmpty(cmData) && !isEmptyArray(cmData.nonMerchandiseLines)) {
      cmData.nonMerchandiseLines.map((line) => {
        if (line.lineNumber > maxLineNumber) {
          maxLineNumber = line.lineNumber;
        }
      });
    }
    return maxLineNumber;
  };
  getMaxLineNumberMerchandiseLines = () => {
    let maxLineNumber = 0;
    let cmData = this.state.cmData;
    if (!isEmpty(cmData) && !isEmptyArray(cmData.merchandiseLines)) {
      cmData.merchandiseLines.map((line) => {
        if (line.lineNumber > maxLineNumber) {
          maxLineNumber = line.lineNumber;
        }
      });
    }
    return maxLineNumber;
  };
  clearNonMerchandiseLineValues = (e) => {
    if (e.detail == 1) {
      let temp_nonMerchandiseLineData = new CreditMemoNonMerchandiseLineBean();
      this.setState({ nonMerchandiseLineData: temp_nonMerchandiseLineData });
    }
  };
  clearMerchandiseLineValues = (e) => {
    if (e.detail == 1) {
      let temp_MerchandiseLineData = new CreditMemoMerchandiseLineBean();
      this.setState({
        merchandiseLineData: temp_MerchandiseLineData,
        isShowColorLookup: false,
        colorList: [],
      });
    }
  };
  getNonMerchandiseLineDetails = (nonMerchandiseLineData) => {
    let temp_nonMerchandiseLineData = new CreditMemoNonMerchandiseLineBean();
    let cmData = this.state.cmData;
    temp_nonMerchandiseLineData = { ...nonMerchandiseLineData };
    temp_nonMerchandiseLineData.currencyCode = cmData.customerCurrencyCode;
    temp_nonMerchandiseLineData.creditMemoNumber = cmData.code;
    temp_nonMerchandiseLineData.companyCode = cmData.companyCode;
    this.setState({ nonMerchandiseLineData: temp_nonMerchandiseLineData });
  };
  getMerchandiseLineDetails = (merchandiseLineData) => {
    this.getRollLines(
      merchandiseLineData.fabricStyleCode,
      merchandiseLineData.colorCode,
      merchandiseLineData.locationCode,
      merchandiseLineData.skuNumber,
    );
    let temp_MerchandiseLineData = new CreditMemoMerchandiseLineBean();
    let cmData = this.state.cmData;
    temp_MerchandiseLineData = { ...merchandiseLineData };
    temp_MerchandiseLineData.currencyCode = cmData.customerCurrencyCode;
    temp_MerchandiseLineData.creditMemoNumber = cmData.code;
    temp_MerchandiseLineData.companyCode = cmData.companyCode;
    this.setState({ merchandiseLineData: temp_MerchandiseLineData });
  };
  onAddNonMerchandiseLineClick = () => {
    let nonMerchandiseLine = new CreditMemoNonMerchandiseLineBean();
    nonMerchandiseLine.companyCode = this.companyCode;
    let currencyCode = ConfigManager.getCurrencyCode();
    nonMerchandiseLine.currencyCode = currencyCode;
    let temp_CmData = this.state.cmData;
    temp_CmData.nonMerchandiseLines.push(nonMerchandiseLine);
    this.setState({ cmData: temp_CmData });
  };
  getCustomerPageListResponse = (response) => {
    let customer_list = [];
    if (response.data.customerPageList != null) {
      customer_list = response.data.customerPageList.customers;
    }
    this.setState({
      customer_list: customer_list,
      isCustomerDataLoding: false,
    });
  };
  getCustomerPageListError = (error) => {
    ShowError("Error : " + error);
  };
  getCustomerPageList = () => {
    this.setState({ isCustomerDataLoding: true });
    let cust_criteria = new CustomerSearchCriteria();
    cust_criteria.companyCode = this.companyCode;
    let cust_pageList = new RestPageListBean();
    cust_pageList.pageSize = 100;
    let cust_requestInput = new RestCustomerListRequest();
    cust_requestInput.pageInput = cust_pageList;
    cust_requestInput.searchCriteria = cust_criteria;
    if (SecurityAccessManager.CreditMemoMaintenance_IsAccessible()) {
      CustomerService.getCustomerPageList(
        cust_requestInput,
        this.getCustomerPageListResponse,
        this.getCustomerPageListError,
      );
    } else {
      let errMsg = "Access Denied";
      let errList = [];
      errList.push(errMsg);
      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
  };
  showInvoiceLines = () => {
    this.setState({ isShowFetchInvoicePopup: true });
  };
  setAndShowInvoiceLines = (merchandiseLines, invoiceLines) => {
    this.setState({
      invoiceLines: invoiceLines,
      isShowFetchInvoicePopup: true,
    });
  };
  hideInvoiceLines = () => {
    if (this.invoiceLinesRef.current != null)
      this.invoiceLinesRef.current.hide();
  };
  onCMChange = (e) => {
    let temp_cmData = this.state.cmData;
    temp_cmData[e.target.name] = e.target.value;
    this.setState({ cmData: temp_cmData });
  };
  getOpenCreditAmount = () => {
    let openAmount = 0;
    let returnAmount = 0;
    let totalCreditAmount = 0;
    totalCreditAmount = this.state.cmData.totalCreditAmount;
    if (isEmpty(this.state.cmData.returnPaymentDetails)) {
      this.state.cmData.returnPaymentDetails = [];
    }
    this.state.cmData.returnPaymentDetails.map((cm) => {
      let paidReturnAmount = cm.cashAmount + cm.cardAmount + cm.checkAmount;
      returnAmount = returnAmount + paidReturnAmount;
    });
    openAmount =
      totalCreditAmount -
      this.state.cmData.provisionalAppliedAmount -
      this.state.cmData.appliedAmount -
      returnAmount;
    return openAmount;
  };
  isValidatetoReturn = () => {
    let isValid = true;
    let err_list = [];
    let totalCreditAmount = 0;
    totalCreditAmount = this.state.cmData.totalCreditAmount;
    let openAmount = 0;
    let returnAmount = 0;
    openAmount = this.getOpenCreditAmount();
    let totalReturnAmount = 0;
    let returnPaymentDetail = this.state.returnPaymentDetail;
    if (
      !this.isEmptyNumber(returnPaymentDetail.cardAmount) &&
      returnPaymentDetail.cardAmount > 0
    ) {
      totalReturnAmount = totalReturnAmount + returnPaymentDetail.cardAmount;
      if (isEmptyString(returnPaymentDetail.cardNumber)) {
        let errMsg = " CardNumber is Required ";
        err_list.push(errMsg);
      }
    }
    if (
      !this.isEmptyNumber(returnPaymentDetail.checkAmount) &&
      returnPaymentDetail.checkAmount > 0
    ) {
      totalReturnAmount = totalReturnAmount + returnPaymentDetail.checkAmount;
      if (isEmptyString(returnPaymentDetail.checkNumber)) {
        let errMsg = " checkNumber is Required ";
        err_list.push(errMsg);
      }
    }
    if (
      !this.isEmptyNumber(returnPaymentDetail.cashAmount) &&
      returnPaymentDetail.cashAmount > 0
    ) {
      totalReturnAmount = totalReturnAmount + returnPaymentDetail.cashAmount;
    }
    if (totalReturnAmount == 0) {
      let errMsg = "Return Amount Required";
      err_list.push(errMsg);
    } else if (totalReturnAmount > 0 && totalReturnAmount > openAmount) {
      let errMsg =
        " Invalid Return Amount ,Return Amount Exceeds CreditMemo Open Amount";
      err_list.push(errMsg);
    }
    this.setState({
      alertMessage: err_list,
      alertType: "danger",
      isShowAlertLvl2: true,
    });
    if (err_list.length > 0) isValid = false;
    return isValid;
  };
  isValidatetoPostAll = () => {
    let isValid = true;
    let err_list = [];
    let totalCreditAmount = 0;
    totalCreditAmount = this.state.cmData.totalCreditAmount;
    let openAmount = 0;
    let returnAmount = 0;
    if (isEmptyArray(this.state.arLines)) {
      this.state.arLines = [];
      let errMsg = " No Invoice Lines to Pay !";
      err_list.push(errMsg);
    } else if (!isEmptyArray(this.state.arLines)) {
      let isAvaliableToPay = false;
      this.state.arLines.map((ar) => {
        if (!ar.isFetched) {
          isAvaliableToPay = true;
          if (isEmptyString(ar.invoiceNumber)) {
            let errMsg = " Invoice is Required !";
            err_list.push(errMsg);
          }
          if (isEmpty(ar.creditAppliedAmount) || ar.creditAppliedAmount == 0) {
            let errMsg = " AppliedAmount is Required !";
            err_list.push(errMsg);
          }
        }
      });
    }
    if (err_list.length > 0) {
      isValid = false;
      this.setState({
        alertMessage: err_list,
        alertType: "danger",
        isShowAlertLvl2: true,
      });
    }
    return isValid;
  };
  isEmptyNumber = (value) => {
    return (
      !value ||
      value == undefined ||
      value == "" ||
      value == "0" ||
      value == 0 ||
      value.length == 0
    );
  };
  onCustomerCodeChange = (e) => {
    let customerCode = e.target.value;
    this.state.isShowAutoCompleteCustomerList = true;
    let tempData = this.state.cmData;
    let showAutoCompleteList = this.state.isShowAutoCompleteCustomerList;
    if (isEmpty(customerCode)) {
      this.state.isShowAutoCompleteCustomerList = false;
      let showAutoCompleteList = this.state.isShowAutoCompleteCustomerList;
      let tempData = this.state.cmData;
      tempData.customerCode = "";
      let suggestion = [];
      this.setState({
        isShowAutoCompleteList: showAutoCompleteList,
        cmData: tempData,
        customerPageListForAutoCompleteList: suggestion,
      });
      this.customerCleared();
    } else if (
      e.target.name == "customerCode" &&
      showAutoCompleteList === true &&
      customerCode !== ""
    ) {
      // setTimeout(() => {
      this.readCustomerBySearchString(customerCode);
      // }, 200);
    }
    tempData[e.target.name] = customerCode.toUpperCase();
    this.setState({ cmData: tempData });
  };
  readCustomerBySearchString(searchString) {
    let searchCriteria = new CustomerSearchCriteria();
    searchCriteria.companyCode = this.companyCode;
    searchCriteria.customerCodeStartsWith = searchString;
    searchCriteria.customerNameContains = searchString;
    let cust_pageList = new PageListBean();
    cust_pageList.pageSize = 10;
    let cust_requestInput = new RestCustomerListRequest();
    cust_requestInput.pageInput = cust_pageList;
    cust_requestInput.searchCriteria = searchCriteria;
    CustomerService.getCustomerPageList(
      cust_requestInput,
      this.readCustomerBySearchCodeResponse,
      this.readCustomerBySearchCodeError,
    );
  }
  readCustomerBySearchCodeResponse = (response) => {
    let customerData = response.data.customerPageList.customers;
    let simpleAutoCompleteList = new Array();
    if (customerData.length > 0 && customerData != null) {
      customerData.map((customer) => {
        let simpleItemBean = {
          code: customer.code,
          description: customer.description,
        };
        simpleAutoCompleteList.push(simpleItemBean);
      });
    }
    this.setState({
      customerPageListForAutoCompleteList: simpleAutoCompleteList,
    });
  };
  readCustomerBySearchCodeError = (error) => {
    ShowError("Error : " + error);
  };
  customerCodeEnterKeyEventHandler = (e) => {
    let customerCode = e.target.value;
    this.readCustomerByCustomerCode(customerCode);
    // this.state.isShowAutoCompleteCustomerList = false;
    // let showAutoCompleteList = this.state.isShowAutoCompleteCustomerList;
    this.setState({
      customerPageListForAutoCompleteList: new Array(),
      // isShowAutoCompleteList: showAutoCompleteList,
    });
  };
  displayAutoCustomerCompleteList = (showAutoCompleteList) => {
    this.setState({
      isShowAutoCompleteCustomerList: showAutoCompleteList,
    });
  };
  readCustomerByCustomerCodeResponse = (response) => {
    let customerData = response.data.customer;
    let creditMemoCommisionList = this.state.creditMemoCommisionList;
    let cmData = this.state.cmData;
    let commissionList = [];
    let credit_MemoCommisionList = [];
    let commissionData = new CreditMemoSalesPersonBean();
    if (customerData != null) {
      let summary = customerData.accountSummary;
      if (customerData.salesCommissions != null) {
        var lineNumber = this.getCommissionMaxLineNumber();
        customerData.salesCommissions.map((list, i) => {
          commissionData.lineNumber = ++lineNumber;
          commissionData.salesPersonCode = list.salesPersonCode;
          commissionData.commissionDeductionPercentage =
            list.commissionPercentage;
          commissionData.creditMemoNumber = cmData.code;
          commissionData.currencyCode = customerData.currencyCode;
          commissionData.lineStatus = cmData.creditMemoStatus;
          commissionList.push({ ...commissionData });
        });
        cmData.creditMemoSalesPersons = commissionList;
        credit_MemoCommisionList = commissionList;
      }
      this.setState(
        {
          customerData: customerData,
          summaryData: summary,
          cmData: cmData,
          creditMemoCommisionList: credit_MemoCommisionList,
        },
        () => {
          this.customerSelected();
        },
      );
    }
  };
  readCustomerByCustomerCodeError = (error) => {
    ShowError("Error : " + error);
  };
  readCustomerByCustomerCode = (customerCode) => {
    let readrestInput = new RestReadRequest();
    readrestInput.companyCode = this.companyCode;
    readrestInput.code = customerCode;
    readrestInput.isLoadChildren = true;
    if (SecurityAccessManager.CreditMemoMaintenance_IsAccessible()) {
      CustomerService.readCustomerWithChildren(
        readrestInput,
        this.readCustomerByCustomerCodeResponse,
        this.readCustomerByCustomerCodeError,
      );
    } else {
      let errMsg = "Access Denied";
      let errList = [];
      errList.push(errMsg);

      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
  };
  customerCleared() {
    let temp_cmData = this.state.cmData;
    temp_cmData.customerName = "";
    temp_cmData.billToCode = "";
    temp_cmData.invoiceNumber = "";
    this.setState({
      invoiceLookupHandler: null,
      isShowInvoiceLookup: false,
      cmData: temp_cmData,
      invoice_list_for_apply: [],
      isShowBillToLookup: false,
    });
  }
  customerSelected() {
    let temp_cmData = this.state.cmData;
    let customerData = this.state.customerData;
    temp_cmData.customerCode = customerData.code;
    temp_cmData.customerName = customerData.description;
    temp_cmData.customerCurrencyCode = customerData.currencyCode;
    temp_cmData.invoiceNumber = "";
    let billTos = [];
    if (!isEmpty(customerData.billTos)) billTos = customerData.billTos;
    let billToLookupHandler = new GenericAttributeLookupHandler(
      customerData.billTos,
      "Bill To",
      this.state.cmData.customerCode,
    );
    if (!isEmpty(customerData.billTos))
      temp_cmData.billToCode = customerData.billTos[0].code;
    if (isEmptyString(temp_cmData.billToCode)) temp_cmData.billToCode = "B1001";
    this.setState({
      cmData: temp_cmData,
    });
    let invoiceLookupHandler = new InvoiceLookupHandlers(
      this.companyCode,
      "Invoice",
      this.state.cmData.customerCode,
      "Y",
    );
    this.setState({
      invoiceLookupHandler: invoiceLookupHandler,
      isShowInvoiceLookup: true,
      isShowBillToLookup: true,
      billToLookupHandler: billToLookupHandler,
      billTos: billTos,
    });
  }
  loadInvoicesandOpenApplytoInvoiceDialogResponse = (response) => {
    let invoice_list_for_apply = [];
    if (
      !isEmpty(response.data) &&
      !isEmpty(response.data.invoicePageList) &&
      !isEmpty(response.data.invoicePageList.invoice)
    ) {
      response.data.invoicePageList.invoice.map((v) => {
        if (
          v.grandTotalAmount - v.netPaidAmount > 0 &&
          v.invoiceStatus != LogicConstants.INVOICE_CANCEL_STATUS &&
          v.invoiceStatus != LogicConstants.INVOICE_UNAPPROVE_STATUS
        ) {
          invoice_list_for_apply.push(v);
        }
      });
    }
    this.setState({ invoice_list_for_apply: invoice_list_for_apply });
    this.openApplytoInvoiceDialog();
  };
  loadInvoicesandOpenApplytoInvoiceDialogError = (error) => {
    ShowError("Error : " + error);
    this.setState({
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
  };
  loadInvoicesandOpenApplytoInvoiceDialog = () => {
    let inv_criteria = new InvoiceSearchCriteria();
    inv_criteria.companyCode = this.companyCode;
    inv_criteria.customerCode = this.state.cmData.customerCode;
    let inv_pageList = new RestPageListBean();
    let inv_requestInput = new RestInvoiceListRequest();
    inv_requestInput.pageInput = inv_pageList;
    inv_requestInput.searchCriteria = inv_criteria;
    if (SecurityAccessManager.CreditMemoMaintenance_IsAccessible()) {
      InvoiceService.getInvoicePageList(
        inv_requestInput,
        this.loadInvoicesandOpenApplytoInvoiceDialogResponse,
        this.loadInvoicesandOpenApplytoInvoiceDialogError,
      );
    } else {
      let errMsg = "Access Denied";
      let errList = [];
      errList.push(errMsg);
      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
  };
  loadCreditMemoPageResponse = (response) => {
    let creditMemo_list = new Array();
    let pageList = this.state.pageList;
    if (response.data.creditMemoPageList != null) {
      creditMemo_list = response.data.creditMemoPageList.creditMemos;
      pageList.totalCount = response.data.creditMemoPageList.totalCount;
      pageList.currentPage = response.data.creditMemoPageList.currentPage;
    } else {
      creditMemo_list = new Array();
    }
    let loading = false;
    this.setState({
      isLoading: loading,
      creditMemo_list: creditMemo_list,
      pageList: pageList,
      isReLoadRequired: false,
    });
  };
  loadCreditMemoPageError = (error) => {
    ShowError("Error : " + error);
  };
  loadCreditMemoPage = () => {
    let loading = this.state.isLoading;
    loading = true;
    this.setState({ isLoading: loading });
    let criteria = new CreditMemoSearchCriteria();
    criteria = this.state.criteria;
    criteria.companyCode = this.companyCode;
    let pageList = new PageListBean();
    pageList = this.state.pageList;
    let requestInput = new RestCreditMemoBeanRequest();
    requestInput.pageInput = pageList;
    requestInput.searchCriteria = criteria;
    this.setState({
      isLoading: true,
      loadingText: "Loading ..",
    });
    if (SecurityAccessManager.CreditMemoMaintenanceView_IsAccessible()) {
      CreditMemoService.getCreditMemoPageList(
        requestInput,
        this.loadCreditMemoPageResponse,
        this.loadCreditMemoPageError,
      );
    } else {
      let errMsg = "Access Denied";
      let errList = [];
      errList.push(errMsg);
      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
  };
  moduleCaption = "CreditMemo";
  moduleExit = () => {
    let cmData = this.state.cmData;
    if (cmData.code === "NEW") {
      this.props.onModuleExit();
    } else {
      if (this.isLocked) {
        this.isLocked = false;
        if (!this.state.isViewMode) this.unlockCreditMemo(cmData.code);
      } else {
        this.isLocked = false;
      }

      this.props.onModuleExit();
    }
  };
  onCriteriaChange = (e) => {
    let temp_criteria = this.state.criteria;
    temp_criteria[e.target.name] = e.target.value;
    if (e.target.name == "specialSearchText") {
      temp_criteria.specialSearchText = e.target.value;
    }
    this.setState({ criteria: temp_criteria });
  };
  closeEntryFrom = () => {
    this.closeAllNodeViews();
    let pageTitle = this.moduleCaption;
    this.setState({
      isCreditMemoListFormOpen: true,
      isCreditMemoEntryFormOpen: false,
      isShowNewButton: false,
      isShowSaveButton: false,
      isShowClearCriteriaButton: false,
      isShowClearErrorButton: false,
      isShowPDFButton: false,
      isShowExcelButton: false,
      isShowApproveButton: false,
      isShowLoadCustomerReturnButton: false,
      isShowAdjustButton: false,
      isShowBackButton: false,
      isShowApprovePrintButton: false,
      isShowCancelButton: false,
      pageTitle: pageTitle,
      error_list: [],
      isShowModuleSearchContainer: false,
      moduleKeyCode: "NEW",
      disabled: false,
      isResetView: false,
      isShowNodes: false,
      isMaintenanceMode: false,
      isDisableHeaderFields: false,
      isViewMode: false,
      isSpecialViewMode: false,
      disableCMFormFields: false,
    });
  };
  back = () => {
    this.closeEntryFrom();
    if (this.state.isReLoadRequired) {
      this.loadPage(1);
    }
  };
  save = () => {
    this.saveCreditMemo();
  };
  cancelCreditMemoResponse = (response) => {
    let isSuccess = this.handleResponse(response.data);
    if (
      response.data !== null &&
      response.data.creditMemo !== null &&
      isSuccess
    ) {
      let cm = response.data.creditMemo;
      if (cm !== null) {
        this.setState({
          cmData: cm,
          isDisableFields: true,
        });
        // this.unlockCreditMemo(cm.code);
        // this.editCreditMemo(cm.code);
        if (this.isLocked) {
          this.code = cm.code;
          this.unlockCreditMemo(cm.code);
        }
      }
    }
  };
  cancelCreditMemoError = (error) => {
    ShowError("Error : " + error);
  };

  onReasonDescChange = (e) => {
    let reasonData = this.state.reasonData;
    reasonData[e.target.name] = e.target.value;
    this.setState({ reasonData: reasonData });
  };
  onReasonChange = (e) => {
    let code = e.target.value;
    this.state.showAutoCompleteReasonList = true;

    let reasonData = this.state.reasonData;
    let showAutoCompleteList = this.state.showAutoCompleteReasonList;

    if (isEmpty(code)) {
      this.state.showAutoCompleteReasonList = false;
      let showAutoCompleteList = this.state.showAutoCompleteReasonList;
      let reason = this.state.reasonData;
      reason.code = "";
      reason.description = "";
      let suggestion = [];

      this.setState({
        showAutoCompleteReasonList: showAutoCompleteList,
        reasonData: reason,
        reasonPageListForAutoCompleteList: suggestion,
      });
    } else if (showAutoCompleteList === true && code !== "") {
      this.readReasonBySearchString(code);
    }
    if (e.target.name == "code") {
      reasonData["code"] = e.target.value;
      let reasonList = this.state.creditReasons;
      reasonList.map((rsn) => {
        if (rsn.code == e.target.value) {
          reasonData["code"] = rsn.code;
          this.state.showAutoCompleteReasonList = false;
          let showAutoCompleteList = this.state.showAutoCompleteReasonList;
          this.setState({ showAutoCompleteReasonList: showAutoCompleteList });
        }
      });
    }

    this.setState({ reasonData: reasonData });
  };
  readReasonBySearchString(searchString) {
    let reasonData = this.state.creditReasons;
    let simpleAutoCompleteList = new Array();
    if (reasonData.length > 0 && reasonData != null) {
      reasonData.map((reasons) => {
        let simpleItemBean = {
          code: reasons.code,
          description: reasons.description,
        };
        simpleAutoCompleteList.push(simpleItemBean);
      });
    }
    let userInput = searchString;

    let filteredSuggestions = new Array();

    filteredSuggestions = simpleAutoCompleteList.filter(
      (simpleAutoCompleteLocationLists) =>
        simpleAutoCompleteLocationLists.code
          .toLowerCase()
          .indexOf(userInput.toLowerCase()) > -1,
    );
    this.setState({ reasonPageListForAutoCompleteList: filteredSuggestions });
  }
  reasonEnterKeyEventHandler = (e) => {
    let reasonData = this.state.reasonData;
    let code = e.target.value;

    reasonData["code"] = e.target.value;
    let reasonList = this.state.creditReasons;
    let reasonCodeBean = null;
    reasonList.map((rsn) => {
      if (rsn.code == e.target.value) {
        reasonCodeBean = rsn;
      }
    });
    if (!isEmpty(reasonCodeBean)) {
      let reasonData = this.state.reasonData;
      reasonData.code = reasonCodeBean.code;
      this.setState({
        reasonData: reasonData,
        reasonPageListForAutoCompleteList: new Array(),
      });
    }
  };
  displayAutoCompleteReasonList = (showAutoCompleteList) => {
    this.setState({ showAutoCompleteReasonList: showAutoCompleteList });
  };

  closeReasonModelCallBack = () => {
    this.setState({
      isShowCancelReasonPopup: false,
      isShowUnApproveReasonPopup: false,
      reasonData: new ReasonBean(),
      showAutoCompleteReasonList: false,
      reasonPageListForAutoCompleteList: new Array(),
    });
  };
  openReasonCapture = (type) => {
    if (type === 1) {
      this.setState({
        isShowCancelReasonPopup: true,
      });
    } else if (type === 2) {
      this.setState({
        isShowUnApproveReasonPopup: true,
      });
    }
    this.setState({
      showAutoCompleteReasonList: false,
      reasonPageListForAutoCompleteList: new Array(),
    });
  };
  cancelCreditMemo = () => {
    this.openReasonCapture(1);
  };
  onCancelReasonContinue = () => {
    this.saveCancelCreditMemo();
    this.closeReasonModelCallBack();
  };
  saveCancelCreditMemo = () => {
    let request = new RestCreditMemoBeanRequest();
    request.creditMemoBean = this.state.cmData;
    request.specialReason = this.state.reasonData.code;
    if (SecurityAccessManager.CreditMemoMaintenanceCancel_IsAccessible()) {
      CreditMemoService.cancelCreditMemo(
        request,
        this.cancelCreditMemoResponse,
        this.cancelCreditMemoError,
      );
    } else {
      let errMsg = "Access Denied";
      let errList = [];
      errList.push(errMsg);

      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
  };
  approveCreditMemoResponse = (response) => {
    console.log("approve response:",response);
    let isSuccess = this.handleApproveResponse(response.data);
    if (
      !isEmpty(response.data) &&
      !isEmpty(response.data.mainOperationResponse) &&
      !isEmpty(response.data.mainOperationResponse.creditMemo) &&
      isSuccess
    ) {
      let cm = response.data.mainOperationResponse.creditMemo;
      if (!isEmpty(cm)) {
        this.setState({
          cmData: cm,
          isDisableFields: true,
          isReLoadRequired: true,
        });
        // this.unlockCreditMemo(cm.code);
        this.editCreditMemo(cm.code);
        // if (!this.isLocked) {
        //   this.editCreditMemo(cm.code);
        // } else {
        //   this.code = cm.code;
        //   this.unlockCreditMemo(cm.code);
        // }
      }
    }
  };
  approveCreditMemoError = (error) => {
    ShowError("Error : " + error);
  };
  approveCreditMemo = () => {
    let request = new RestCreditMemoBeanRequest();
   
    request.creditMemoBean = this.state.cmData;
    
    let isValid = false;
    isValid = this.validateCreditMemoData(this.state.cmData);
    if (isValid) {
      if (this.state.cmData.isFetched) {
         request.isLockRequired = true; //lockRelease
         console.log("approve request :",request)
        if (
          SecurityAccessManager.CreditMemoMaintenanceApprove_IsAccessible() &&
          SecurityAccessManager.CreditMemoMaintenanceEdit_IsAccessible()
        ) {
          CreditMemoService.updateAndApproveCreditMemo(
            request,
            this.approveCreditMemoResponse,
            this.approveCreditMemoError,
          );
        } else {
          let errMsg = "Access Denied";
          let errList = [];
          errList.push(errMsg);

          this.setState({
            alertMessage: errList,
            alertType: "danger",
            isShowAlert: true,
          });
        }
      } else {
        if (
          SecurityAccessManager.CreditMemoMaintenanceAdd_IsAccessible() &&
          SecurityAccessManager.CreditMemoMaintenanceApprove_IsAccessible()
        ) {
           request.isLockRequired = false; //lockrelease 
           console.log("approve request :",request)
          CreditMemoService.createAndApproveCreditMemo(
            request,
            this.approveCreditMemoResponse,
            this.approveCreditMemoError,
          );
        } else {
          let errMsg = "Access Denied"; 
          let errList = [];
          errList.push(errMsg);
          this.setState({
            alertMessage: errList,
            alertType: "danger",
            isShowAlert: true,
          });
        }
      }
    }
  };
  handleApproveResponse = (response) => {
    let success = false;
    let mainResponseSuccess = false;
    let additionalResponseSuccess = false;
    let errMsg = "";
    let infoMsg = "";
    let errList = [];
    if (response.mainOperationResponse != null) {
      if (response.mainOperationResponse.errors != null) {
        response.mainOperationResponse.errors.map(
          (err) => (
            (errMsg = errMsg + "\n" + err.messageDescription),
            errList.push(err.messageDescription)
          ),
        );
        mainResponseSuccess = false;
      }
      if (response.mainOperationResponse.infos != null) {
        response.mainOperationResponse.infos.map(
          (info) => (infoMsg = infoMsg + "\n" + info.messageDescription),
        );
        mainResponseSuccess = true;
      }
    }
    if (response.additionalOperationResponse != null) {
      if (response.additionalOperationResponse.errors != null) {
        response.additionalOperationResponse.errors.map(
          (err) => (
            (errMsg = errMsg + "\n" + err.messageDescription),
            errList.push(err.messageDescription)
          ),
        );
        additionalResponseSuccess = false;
      }
      if (response.additionalOperationResponse.infos != null) {
        response.additionalOperationResponse.infos.map(
          (info) => (infoMsg = infoMsg + "\n" + info.messageDescription),
        );
        additionalResponseSuccess = true;
      }
    }
    let successMsg = [];
    successMsg.push(infoMsg);
    this.setState({
      alertMessage: successMsg,
      alertType: "success",
      isShowAlert: true,
    });
    this.setState({ error_list: errList });
    success = mainResponseSuccess && additionalResponseSuccess;
    return success;
  };
  unApproveCreditMemoResponse = (response) => {
    let isSuccess = this.handleResponse(response.data);
    if (
      response.data !== null &&
      response.data.creditMemo !== null &&
      isSuccess
    ) {
      let cm = response.data.creditMemo;
      if (cm !== null) {
        this.setState({
          cmData: cm,
          isDisableFields: true,
          isShowUnApprovePopup: false,
        });

        if (this.isLocked) {
          this.code = cm.code;
          this.unlockCreditMemo(cm.code);
        }
      }
    }
  };
  unApproveCreditMemoError = (error) => {
    ShowError("Error : " + error);
  };
  saveUnApproveCreditMemo = () => {
    let request = new RestCreditMemoBeanRequest();
    request.lockCheckRequired = false;
    request.creditMemoBean = this.state.cmData;
    request.specialReason = this.state.reasonData.code;
    if (SecurityAccessManager.CreditMemoMaintenanceUnApprove_IsAccessible()) {
      CreditMemoService.unApproveCreditMemo(
        request,
        this.unApproveCreditMemoResponse,
        this.unApproveCreditMemoError,
      );
    } else {
      let errMsg = "Access Denied";
      let errList = [];
      errList.push(errMsg);

      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
  };
  unApproveCreditMemo = () => {
    this.openReasonCapture(2);
  };
  onUnApproveReasonContinue = () => {
    this.saveUnApproveCreditMemo();
    this.closeReasonModelCallBack();
  };

  applyToInvoiceResponse = (response) => {
    if (!isEmpty(response.data) && !isEmpty(response.data.pageListBean)) {
      let appliedInvoices = response.data.pageListBean.appliedInvoices;
      let tempARLines = [];
      if (!isEmptyArray(appliedInvoices)) {
        appliedInvoices.map((invoice) => {
          let arLine = new AccountReceivableLineBean();
          arLine.companyCode = invoice.companyCode;
          arLine.invoiceNumber = invoice.invoiceNumber;
          arLine.invoiceDate = invoice.invoiceDate;
          arLine.currencyCode = invoice.currencyCode;
          arLine.accountReceivableNumber = invoice.arNumber;
          arLine.arDate = invoice.arDate;
          arLine.creditMemoFlag = false;
          arLine.grantTotalAmount = invoice.grandTotalAmount;
          arLine.openInvoiceAmount = invoice.openAmount;
          let appliedAmt = invoice.appliedAmount;
          arLine.totalAppliedAmount = appliedAmt;
          arLine.creditAppliedAmount = appliedAmt;
          arLine.creditMemoAppliedAmount = invoice.creditMemoAppliedAmount;
          arLine.paidAmount = invoice.paidAmount;
          arLine.currencyExchangeRate = 1;
          arLine.customerPurchaseOrderNumber =
            invoice.customerPurchaseOrderNumber;
          arLine.isFetched = true;
          tempARLines.push(arLine);
        });
      }
      this.setState({ arLines: tempARLines });
    }
    this.loadInvoicesandOpenApplytoInvoiceDialog();
  };
  applyToInvoiceError = (error) => {
    ShowError("Error : " + error);
    this.setState({
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
  };
  applyToInvoice = () => {
    let request = new RestReadRequest();
    request.companyCode = this.companyCode;
    request.code = this.state.cmData.code;
    this.setState({
      isShowProgressBarPopup: true,
      progressLoadingText: "Get Applied Invoice",
    });
    if (
      SecurityAccessManager.CreditMemoMaintenanceApplyToInvoice_IsAccessible()
    ) {
      CreditMemoService.getAppliedInvoicesForCreditMemoList(
        request,
        this.applyToInvoiceResponse,
        this.applyToInvoiceError,
      );
    } else {
      let errMsg = "Access Denied";
      let errList = [];
      errList.push(errMsg);
      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
  };
  openApplytoInvoiceDialog() {
    let invoiceLookupHandler = new InvoiceLookupHandlers(
      this.companyCode,
      "Invoice",
      this.state.cmData.customerCode,
    );
    this.setState({
      invoiceLookupHandler: invoiceLookupHandler,
    });
    this.setState({
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
    this.setState({
      isShowApplyInvoicePopup: true,
    });
  }
  returnToCustomer = () => {
    let returnPaymentDetail = this.state.returnPaymentDetail;
    returnPaymentDetail.companyCode = this.companyCode;
    returnPaymentDetail.creditMemoNumber = this.state.cmData.code;
    this.setState({ isShowRefundPopup: true });
  };
  closeReturnToCustomerDialog() {
    if (this.returnToCustomerDialogRef.current != null) {
      this.returnToCustomerDialogRef.current.hide();
    }
  }
  clearError = () => {
    this.setState({ error_list: [] });
  };
  filter = () => {
    this.loadPage(1);
  };
  advanceSearch = () => {
    this.setState({ isShowAdvanceSearchPopup: true });
  };
  onAdvanceSearchClick = (e) => {
    if (e.detail == 1) {
      this.loadPage(1);
      this.setState({
        isShowAdvanceSearchPopup: false,
        criteria: new CreditMemoSearchCriteria(),
      });
    }
  };
  onAdvSearchChange = (e) => {
    let criteria = this.state.criteria;
    criteria.companyCode = this.companyCode;
    criteria[e.target.name] = e.target.value;
    this.setState({ criteria: criteria });
  };
  addNewEntry = () => {
    let newCreditMemo = new CreditMemoBean();
    newCreditMemo.companyCode = this.companyCode;
    newCreditMemo.code = "NEW";
    newCreditMemo.companyCurrencyCode = "USD";
    newCreditMemo.creditType = "RETURN";
    newCreditMemo.creditMemoStatus = LogicConstants.CREDIT_MEMO_OPEN_STATUS;
    // let date = new Date();
    let currentDate = toFormattedDate_v1(new Date());
    newCreditMemo.creditMemoDate = currentDate;
    newCreditMemo.createdDate = currentDate;
    let customerdata = new CustomerBean();
    let customer_list = new Array();
    customer_list = this.state.customer_list;
    customerdata = customer_list;
    if (!isEmptyString(this.state.moduleKeyCode)) {
      newCreditMemo.code = this.state.moduleKeyCode;
      if (this.state.moduleKeyCode == NEW_ENTRY) {
        this.isLocked = false;
      } else {
        this.isLocked = true;
      }
    } else newCreditMemo.code = "NEW";
    let pageTitle = this.moduleCaption + " - NEW";
    this.setState({
      cmData: newCreditMemo,
      customerdata: customerdata,
      pageTitle: pageTitle,
      isShowPDFButton: false,
      isShowExcelButton: false,
      selectedNodeKey: "headerView",
      statusTrackList: [],
      creditMemoCommisionList: [],
      merchandiseLinesList: [],
      nonMerchandiseLinesList: [],
      returnPaymentLinesList: [],
    });
    this.state.isDisableFields = false;
    this.state.isCollapsible_open = true;
    this.state.cmData = newCreditMemo;
    this.openEntryForm();
  };
  closeAllNodeViews = () => {
    this.setState({
      isShowSaveButton: false,
      isCreditMemoListFormOpen: false,
      isCreditMemoEntryFormOpen: false,
      isCreditMemoHistoryFormOpened: false,
      isCreditMemoPaymentFormOpened: false,
      isCommissionFormOpened: false,
      isCommentsAndNotesFormOpened: false,
    });
  };
  getEmptyView() {
    return <div></div>;
  }
  getNodeList = () => {
    let nodeList = [];
    let cmData = this.state.cmData;
    let headerObject = this.getEmptyView();
    let historyObject = this.getEmptyView();
    let paymentObject = this.getEmptyView();
    let commissionObject = this.getEmptyView();
    let commentsObject = this.getEmptyView();
    let headerNode = new NodeData(
      "headerView",
      "Header",
      headerObject,
      <AlignStartVertical size={16} />,
    );
    let historyNode = new NodeData(
      "historyView",
      "History",
      historyObject,
      <History size={16} />,
    );
    let paymentNode = new NodeData(
      "paymentView",
      "PaymentApplied",
      paymentObject,
      <CircleDollarSign size={16} />,
    );
    let commissionNode = new NodeData(
      "commissionView",
      "Sales Commission",
      commissionObject,
      <DollarSign size={16} />,
    );
    let commentsNode = new NodeData(
      "commentsView",
      "Comments & Notes",
      commentsObject,
      <FileText size={16} />,
    );
    nodeList["headerView"] = headerNode;
    nodeList["commissionView"] = commissionNode;
    nodeList["commentsView"] = commentsNode;
    if (cmData.isFetched == true) {
      nodeList["historyView"] = historyNode;
      nodeList["paymentView"] = paymentNode;
    }
    this.setState({ nodeList: nodeList });
  };
  nodeOnSelect = (selectedNode) => {
    let cmData = this.state.cmData;
    this.setState({ selectedNodeKey: selectedNode });
    if (selectedNode == "headerView") {
      this.setCreditMemoHeaderView();
    } else if (selectedNode == "historyView") {
      this.setCreditMemoHistoryView();
    } else if (selectedNode == "paymentView") {
      this.setCreditMemoPaymentView();
    } else if (selectedNode == "commissionView") {
      if (!isEmptyString(cmData.customerCode)) {
        this.setCreditMemoCommissionView();
      } else {
        let errList = [];
        let errMsg = "Customer Details Not Entered";
        errList.push(errMsg);
        this.setState({
          alertMessage: errList,
          isShowAlert: true,
          alertType: "danger",
        });
      }
    } else if (selectedNode == "commentsView") {
      this.setCreditMemoCommentsView();
    }
  };
  setCreditMemoHeaderView = () => {
    this.closeAllNodeViews();
    this.setState({
      isShowSaveButton: true,
      isCreditMemoListFormOpen: false,
      isCreditMemoEntryFormOpen: true,
      isCreditMemoHistoryFormOpened: false,
      isCreditMemoPaymentFormOpened: false,
      isCommissionFormOpened: false,
      isCommentsAndNotesFormOpened: false,
    });
    if (
      this.state.cmData.creditMemoStatus ===
      LogicConstants.CREDIT_MEMO_CANCEL_STATUS
    ) {
      this.setState({
        isShowSaveButton: false,
      });
    }
  };
  setCreditMemoHistoryView = () => {
    this.closeAllNodeViews();
    this.setState({
      isShowSaveButton: false,
      isCreditMemoListFormOpen: false,
      isCreditMemoEntryFormOpen: false,
      isCreditMemoHistoryFormOpened: true,
      isCreditMemoPaymentFormOpened: false,
      isCommissionFormOpened: false,
      isCommentsAndNotesFormOpened: false,
    });
  };
  setCreditMemoPaymentView = () => {
    this.closeAllNodeViews();
    this.setState({
      isShowSaveButton: false,
      isCreditMemoListFormOpen: false,
      isCreditMemoEntryFormOpen: false,
      isCreditMemoHistoryFormOpened: false,
      isCreditMemoPaymentFormOpened: true,
      isCommissionFormOpened: false,
      isCommentsAndNotesFormOpened: false,
    });
  };
  setCreditMemoCommissionView = () => {
    this.closeAllNodeViews();
    this.setState({
      isShowSaveButton: true,
      isCreditMemoListFormOpen: false,
      isCreditMemoEntryFormOpen: false,
      isCreditMemoHistoryFormOpened: false,
      isCreditMemoPaymentFormOpened: false,
      isCommissionFormOpened: true,
      isCommentsAndNotesFormOpened: false,
    });
    if (
      this.state.cmData.creditMemoStatus ===
      LogicConstants.CREDIT_MEMO_CANCEL_STATUS
    ) {
      this.setState({
        isShowSaveButton: false,
      });
    }
  };
  setCreditMemoCommentsView = () => {
    this.closeAllNodeViews();
    this.setState({
      isShowSaveButton: true,
      isCreditMemoListFormOpen: false,
      isCreditMemoEntryFormOpen: false,
      isCreditMemoHistoryFormOpened: false,
      isCreditMemoPaymentFormOpened: false,
      isCommissionFormOpened: false,
      isCommentsAndNotesFormOpened: true,
    });
  };
  openEntryForm = () => {
    this.clearError();
    this.closeAllNodeViews();
    this.getNodeList();
    let cmData = this.state.cmData;
    this.setState({
      isCreditMemoListFormOpen: false,
      isCreditMemoEntryFormOpen: true,
      isShowSaveButton: true,
      isShowClearCriteriaButton: false,
      isShowClearErrorButton: false,
      isShowBackButton: true,
      isShowPDFButton: false,
      isShowExcelButton: false,
      isShowCancelButton: false,
      isShowApplyToInvoiceButton: false,
      isShowRefundButton: false,
      merchandiseLineData: new CreditMemoMerchandiseLineBean(),
      nonMerchandiseLineData: new CreditMemoNonMerchandiseLineBean(),
      isShowModuleSearchContainer: true,
      isResetView: false,
      isShowNodes: true,
      isShowAutoCompleteCreditTypeList: false,
      creditTypePageListForAutoCompleteList: new Array(),
      isShowAutoCompleteCreditSubTypeList: false,
      creditSubTypePageListForAutoCompleteList: new Array(),
      isShowAutoCompleteLocationList: false,
      locationPageListForAutoCompleteList: new Array(),
      isShowAutoCompleteCustomerList: false,
      customerPageListForAutoCompleteList: new Array(),
      isShowAutoCompleteFabricList: false,
      fabricPageListForAutoCompleteList: new Array(),
      isShowAutoCompleteCreditsubTypeList: false,
      creditsubTypePageListForAutoCompleteList: new Array(),
      isShowAutoCompleteCreditsubtypeList: false,
      creditsubtypePageListForAutoCompleteList: new Array(),
      isShowAutoCompleCommissionList: false,
      commissionPageListForAutoCompleteList: new Array(),
      isShowAutoCompleReasonList: false,
      reasonPageListForAutoCompleteList: new Array(),
      isShowAutoCompleCustomerReturnList: false,
      customerReturnPageListForAutoCompleteList: new Array(),
      isDisableHeaderFields: false,
    });
    if (this.state.isSpecialViewMode == false) {
      this.setState({
        isResetView: true,
        isCreditMemoListFormOpen: false,
        isMaintenanceMode: true,
        disabled: false,
        isDisableNodeFields: false,
        disableCMFormFields: false,
        isDisableHeaderFields: false,
      });
    } else {
      this.setState({
        disableCMFormFields: true,
        disabled: true,
        isDisableHeaderFields: true,
      });
    }
    if (this.state.moduleKeyCode != "NEW") {
      this.setState({ disabled: true });
    }

    if (
      cmData.creditMemoStatus == LogicConstants.CREDIT_MEMO_UNAPPROVE_STATUS
    ) {
      this.setState({
        isShowApproveButton: true,
        isShowApprovePrintButton: true,
        isShowCancelButton: false,
        isShowSaveButton: true,
        disableCMFormFields: false,
        isShowPDFButton: true,
        isShowExcelButton: true,
        isShowUnApproveButton: false,
        isShowLoadCustomerReturnButton: false,
        isShowAdjustButton: false,
        isDisableHeaderFields: false,
      });
    } else if (
      cmData.creditMemoStatus == LogicConstants.CREDIT_MEMO_OPEN_STATUS
    ) {
      if (cmData.isFetched) {
        this.setState({
          isShowApprovePrintButton: true,
          isShowSaveButton: true,
          isShowApproveButton: true,
          isShowLoadCustomerReturnButton: false,
          disableCMFormFields: false,
          isShowCancelButton: true,
          isShowPDFButton: true,
          isShowExcelButton: true,
          isShowUnApproveButton: false,
          isDisableHeaderFields: true,
        });
      } else {
        this.setState({
          isShowCancelButton: false,
          isShowSaveButton: true,
          isShowApproveButton: true,
          isShowBackButton: true,
          disableCMFormFields: false,
          isShowPDFButton: false,
          isShowExcelButton: false,
          isShowUnApproveButton: false,
          isShowApprovePrintButton: true,
          isShowAdjustButton: false,
          isShowLoadCustomerReturnButton: true,
          isDisableHeaderFields: false,
        });
      }
    } else if (
      cmData.creditMemoStatus == LogicConstants.CREDIT_MEMO_CANCEL_STATUS
    ) {
      this.setState({
        isShowCancelButton: false,
        isShowSaveButton: false,
        isShowApproveButton: false,
        isShowBackButton: false,
        disableCMFormFields: true,
        isShowPDFButton: true,
        isShowExcelButton: true,
        isShowUnApproveButton: false,
        isShowApprovePrintButton: false,
        isShowAdjustButton: false,
        isShowLoadCustomerReturnButton: false,
        isDisableHeaderFields: true,
      });
    } else if (
      cmData.creditMemoStatus == LogicConstants.CREDIT_MEMO_APPROVE_STATUS
    ) {
      this.setState({
        isShowCancelButton: true,
        isShowSaveButton: true,
        isShowBackButton: false,
        isShowApproveButton: false,
        isShowUnApproveButton: true,
        isShowApplyToInvoiceButton: true,
        isShowRefundButton: true,
        disableCMFormFields: true,
        isShowPDFButton: true,
        isShowExcelButton: true,
        isShowApprovePrintButton: false,
        isShowAdjustButton: true,
        isShowLoadCustomerReturnButton: false,
        isDisableHeaderFields: true,
      });
    } else if (
      cmData.creditMemoStatus ==
      LogicConstants.CREDIT_MEMO_PARTIALLY_CLOSED_STATUS
    ) {
      this.setState({
        isShowCancelButton: true,
        isShowSaveButton: true,
        isShowBackButton: false,
        isShowApproveButton: false,
        isShowUnApproveButton: false,
        isShowApplyToInvoiceButton: true,
        isShowRefundButton: true,
        disableCMFormFields: true,
        isShowPDFButton: true,
        isShowExcelButton: true,
        isShowApprovePrintButton: false,
        isShowAdjustButton: true,
        isShowLoadCustomerReturnButton: false,
        isDisableHeaderFields: true,
      });
    } else if (
      cmData.creditMemoStatus == LogicConstants.CREDIT_MEMO_FINISHED_STATUS
    ) {
      this.setState({
        isShowCancelButton: false,
        isShowSaveButton: false,
        isShowBackButton: true,
        isShowApproveButton: false,
        disableCMFormFields: true,
        isShowPDFButton: true,
        isShowExcelButton: true,
        isShowUnApproveButton: false,
        isShowApprovePrintButton: false,
        isShowAdjustButton: false,
        isShowLoadCustomerReturnButton: false,
        isDisableHeaderFields: true,
      });
    }
    if (!cmData.isFetched) {
      this.setState({
        isShowDelete: true,
        isShowMercDelete: true,
      });
    } else {
      if (
        cmData.nonMerchandiseLines != null ||
        !isEmptyArray(cmData.nonMerchandiseLines)
      ) {
        if (cmData.creditMemoStatus != LogicConstants.CREDIT_MEMO_OPEN_STATUS) {
          this.setState({
            isShowDelete: false,
          });
        } else {
          this.setState({
            isShowDelete: true,
          });
        }
      }
    }
    if (cmData.isFetched) {
      this.setState({
        isShowMercDelete: false,
      });
    }
    if (this.state.isViewMode) {
      let pageTitle = this.moduleCaption + " - VIEW";
      this.setState({
        isDisabledFields: true,
        disabled: true,
        pageTitle: pageTitle,
        disableCMFormFields: true,
        isDisableHeaderFields: true,
      });
    }
  };
  editCreditMemoResponse = (response) => {
    let errMsg = "";
    if (response.data.lockResponse != null) {
      if (!isEmpty(response.data.lockResponse.errors)) {
        this.showErrorMessage(response.data.lockResponse);
        this.state.isViewMode = true;
      }
    }
    if (response.data.creditMemoResponse != null) {
      if (response.data.creditMemoResponse.errors != null) {
        response.data.creditMemoResponse.errors.map((err) => {
          errMsg = err.messageDescription;
        });
      }
    }
    if (response.data.creditMemoResponse != null) {
      if (errMsg != "CreditMemo [" + this.state.moduleKeyCode + "] Not read!") {
        this.showErrorMessage(response.data.creditMemoResponse);
      }
    }
    if (response.data.dependenciesResponse != null) {
      if (response.data.dependenciesResponse.dependenciesBean != null) {
      }
    }
    if (response.data != null) {
      if (response.data.creditMemoResponse != null) {
        if (response.data.creditMemoResponse.creditMemo != null) {
          const cm = response.data.creditMemoResponse.creditMemo;
          let moduleKeyCode = cm.code;
          let pageTitle = this.moduleCaption + " - EDIT";
          let creditMemoCommision = this.state.creditMemoCommisionList;
          if (cm.creditMemoSalesPersons != null) {
            creditMemoCommision = cm.creditMemoSalesPersons;
          }
          let merchandiseLines = this.state.merchandiseLinesList;
          if (cm.merchandiseLines != null) {
            merchandiseLines = cm.merchandiseLines;
          }
          let nonMerchandiseLines = this.state.nonMerchandiseLinesList;
          if (cm.nonMerchandiseLines != null) {
            nonMerchandiseLines = cm.nonMerchandiseLines;
          }
          let returnPaymentLines = this.state.returnPaymentLinesList;
          if (cm.returnPaymentDetails != null) {
            returnPaymentLines = cm.returnPaymentDetails;
          }
          this.setState({
            cmData: cm,
            pageTitle: pageTitle,
            moduleKeyCode: moduleKeyCode,
            isFocusLookup: false,
            isLoading: false,
            statusTrackList: cm.statusTracks,
            creditMemoCommisionList: creditMemoCommision,
            merchandiseLinesList: merchandiseLines,
            nonMerchandiseLinesList: nonMerchandiseLines,
            returnPaymentLinesList: returnPaymentLines,
          });
          this.isLocked = true;
          this.state.cmData = cm;
          this.openEntryForm();
          this.readArPaymentLinesForCM(cm.code);
          this.readandValidateInvoice(cm.invoiceNumber);
        } else {
          this.addNewEntry();
        }
      }
    }
    this.setState({ isLoading: false });
  };
  editCreditMemoError = (error) => {
    this.showErrorMessage("Error : " + error);
  };
  editCreditMemo = (cmNumber) => {
    let readrestInput = new RestReadRequest();
    readrestInput.companyCode = this.companyCode;
    readrestInput.code = cmNumber;
    let isLockRequired = "NEW" === cmNumber ? false : true;
    readrestInput.isLockRequired = isLockRequired;
    if (SecurityAccessManager.CreditMemoMaintenanceView_IsAccessible()) {
      CreditMemoService.initCreditMemoModule(
        readrestInput,
        this.editCreditMemoResponse,
        this.editCreditMemoError,
      );
    } else {
      let errMsg = "Access Denied";
      let errList = [];
      errList.push(errMsg);
      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
    this.setState({
      // disabled: true,
      isFocus: true,
    });
  };
  validateCreditMemoData = (cmData) => {
    let isValidData = false;
    let err_list = [];
    let errorMessage = "";
    if (cmData == null) {
      let errMsg = "Invalid data ";
      errorMessage = errorMessage + errMsg;
      err_list.push(errMsg);
    } else {
      if (isEmptyString(cmData.customerCode)) {
        let errMsg = "CustomerCode is Required";
        errorMessage = errorMessage + errMsg;
        err_list.push(errMsg);
      }
      if (isEmptyString(cmData.customerName)) {
        let errMsg = "CustomerName is Required";
        errorMessage = errorMessage + errMsg;
        err_list.push(errMsg);
      }
      if (isEmptyString(cmData.totalCreditAmount)) {
        let errMsg = "No Credit Memo Amount Desc";
        errorMessage = errorMessage + errMsg;
        err_list.push(errMsg);
      }
      if (
        isEmptyArray(cmData.nonMerchandiseLines) &&
        isEmptyArray(cmData.merchandiseLines)
      ) {
        let errMsg = "No CreditMemo Lines is Required";
        errorMessage = errorMessage + errMsg;
        err_list.push(errMsg);
      }
    }
    if (err_list.length > 0) {
      isValidData = false;
      this.setState({
        alertMessage: err_list,
        alertType: "danger",
        isShowAlert: true,
      });
    } else {
      isValidData = true;
    }
    return isValidData;
  };
  saveCreditMemoResponse = (response) => {
    let isSuccess = this.handleResponse(response.data);
    if (
      response.data !== null &&
      response.data.creditMemo !== null &&
      isSuccess
    ) {
      let cm = response.data.creditMemo;
      if (cm !== null) {
        let isDisableFields = false;
        if (
          cm.creditMemoStatus === LogicConstants.CREDIT_MEMO_FINISHED_STATUS ||
          cm.creditMemoStatus === LogicConstants.CREDIT_MEMO_CANCEL_STATUS
        ) {
          isDisableFields = true;
        }
        this.setState({
          cmData: cm,
          isDisableFields: isDisableFields,
          isReLoadRequired: true,
        });
        // this.unlockCreditMemo(cm.code);
        // this.editCreditMemo(cm.code);
        if (!this.isLocked) {
          this.editCreditMemo(cm.code);
        } else {
          this.code = cm.code;
          this.unlockCreditMemo(cm.code);
        }
      }
    }
  };
  saveCreditMemoError = (error) => {
    ShowError("Error : " + error);
  };
  saveCreditMemo = () => {
    let cmData = this.state.cmData;
    cmData.companyCurrencyCode = "USD";
    let isValid = false;
    isValid = this.validateCreditMemoData(cmData);
    if (isValid) {
      if (cmData.isFetched) {
        if (SecurityAccessManager.CreditMemoMaintenanceEdit_IsAccessible()) {
          CreditMemoService.updateCreditMemo(
            cmData,
            this.saveCreditMemoResponse,
            this.saveCreditMemoError,
          );
        } else {
          let errMsg = "Access Denied";
          let errList = [];
          errList.push(errMsg);
          this.setState({
            alertMessage: errList,
            alertType: "danger",
            isShowAlert: true,
          });
        }
      } else {
        if (SecurityAccessManager.CreditMemoMaintenanceAdd_IsAccessible()) {
          CreditMemoService.createCreditMemo(
            cmData,
            this.saveCreditMemoResponse,
            this.saveCreditMemoError,
          );
        } else {
          let errMsg = "Access Denied";
          let errList = [];
          errList.push(errMsg);
          this.setState({
            alertMessage: errList,
            alertType: "danger",
            isShowAlert: true,
          });
        }
      }
    }
  };
  getMaxLineNumberReturnPaymentDetail = () => {
    let maxLineNumber = 0;
    let cmData = this.state.cmData;
    if (
      !isEmpty(cmData) &&
      !isEmpty(cmData.returnPaymentDetails) &&
      cmData.returnPaymentDetails.length > 0
    ) {
      cmData.returnPaymentDetails.map((line) => {
        if (line.lineNumber > maxLineNumber) {
          maxLineNumber = line.lineNumber;
        }
      });
    }
    return maxLineNumber;
  };
  onPostALLClick = (e) => {
    if (e.detail == 1) {
      let isValid = false;
      this.setState({
        isShowProgressBarPopup: true,
        progressLoadingText: "Posting",
      });
      isValid = this.isValidatetoPostAll();
      if (isValid) {
        this.savePostAll();
      } else {
        this.setState({
          isShowProgressBarPopup: false,
          progressLoadingText: "",
        });
      }
    }
  };
  onRefundClick = (e) => {
    if (e.detail == 1) {
      let isValid = false;
      isValid = this.isValidatetoReturn();
      if (isValid) {
        this.saveReturntoCustomer();
      }
    }
  };
  validateArLine = (arLine) => {
    let isValid = true;
    let err_list = [];
    let errorMsg = "";
    if (isEmpty(arLine.invoiceNumber)) {
      let errMsg = "InvoiceNumber is Required";
      errorMsg = errorMsg + errMsg;
      err_list.push(errMsg);
    }
    if (arLine.grantTotalAmount <= 0) {
      let errMsg = " GrantTotalAmount is Required";
      errorMsg = errorMsg + errMsg;
      err_list.push(errMsg);
    }
    if (isEmpty(arLine.creditAppliedAmount)) {
      let errMsg = "CreditAppliedAmount is Required";
      errorMsg = errorMsg + errMsg;
      err_list.push(errMsg);
    }
    this.setState({
      alertMessage: err_list,
      alertType: "danger",
      isShowAlertLvl2: true,
    });
    if (err_list.length > 0) isValid = false;
    return isValid;
  };
  onAddorUpdateArLineClick_old = (e) => {
    if (e.detail == 1) {
      let arLine = this.state.currentARLine;
      let isValid = false;
      isValid = this.validateArLine(arLine);
      if (isValid) {
        let tempARLines = [];
        tempARLines = this.state.arLines;
        let existingLine = this.getAccountReceivableLine();
        if (isEmpty(existingLine)) {
          tempARLines.push(arLine);
        } else {
          const index = this.state.arLines.findIndex(
            (line) =>
              line.accountReceivableNumber === arLine.accountReceivableNumber &&
              line.invoiceNumber === arLine.invoiceNumber,
          );
          if (index != -1) {
            tempARLines.splice(index, 1);
            tempARLines.push(arLine);
          }
        }
        // console.log("tempARLines", tempARLines);
        this.setState({
          arLines: tempARLines,
          currentARLine: new AccountReceivableLineBean(),
        });
      }
      this.applytoInvoiceNumberRef.current.clear();
      this.applytoInvoiceNumberRef.current.focus();
      this.onClearArLineClick(e);
    }
  };
  onAddorUpdateArLineClick = (e) => {
    if (e.detail == 1) {
      const arLine = { ...this.state.currentARLine };
      let tempARLines = [];
      if (!isEmptyArray(this.state.arLines))
        tempARLines = [...this.state.arLines];

      let isValid = false;
      isValid = this.validateArLine(arLine);
      if (isValid) {
        let isLineFound = false;
        var lineNumber = this.getAccountReceivableLine();
        if (!isEmptyArray(tempARLines))
          tempARLines.map((line, i) => {
            if (
              line.accountReceivableNumber === arLine.accountReceivableNumber &&
              line.invoiceNumber === arLine.invoiceNumber
            ) {
              // salesCommissionData.lineNumber = line.lineNumber;
              // salesCommissionData.isFetched = line.isFetched;
              tempARLines[i] = arLine;
              isLineFound = true;
            }
          });
        if (!isLineFound) {
          tempARLines.push(arLine);
        }
        this.setState({
          arLines: tempARLines,
          currentARLine: new AccountReceivableLineBean(),
        });
      }
      this.applytoInvoiceNumberRef.current.clear();
      this.applytoInvoiceNumberRef.current.focus();
      this.onClearArLineClick(e);
    }
  };
  setCalculatedValues = (tempARLines) => {
    let cmData = this.state.cmData;
    let already_AppliedAmount_Total_Calc =
      cmData.appliedAmount + cmData.provisionalAppliedAmount;
    let currently_Applied_Amount = 0;
    tempARLines.map((ln) => {
      let amount = 0;
      if (ln.accountReceivableNumber == "NEW") {
        amount += ln.CreditMemoAppliedAmount;
      }
      currently_Applied_Amount = amount;
    });
    let remaingAmount_Calc =
      cmData.totalCreditAmount -
      already_AppliedAmount_Total_Calc -
      currently_Applied_Amount;
    this.setState({
      already_AppliedAmount_Total_Calc: already_AppliedAmount_Total_Calc,
      currently_Applied_Amount: currently_Applied_Amount,
      remaingAmount_Calc: remaingAmount_Calc,
    });
  };
  onClearArLineClick = (e) => {
    if (e.detail == 1) {
      let arLine = new AccountReceivableLineBean();
      arLine.grantTotalAmount = 0;
      this.setState({
        currentARLine: arLine,
      });
    }
  };
  saveReturntoCustomerResponse = (response) => {
    // console.log("cmData refund response:", response);
    let isSuccess = this.handleResponse(response.data);
    if (
      response.data !== null &&
      response.data.creditMemo !== null &&
      isSuccess
    ) {
      let cm = response.data.creditMemo;
      if (!isEmpty(cm)) {
        // this.unlockCreditMemo(cm.code);
        // this.editCreditMemo(cm.code);
        if (this.isLocked) {
          this.code = cm.code;
          this.unlockCreditMemo(cm.code);
        }
      }
      this.setState({
        isShowRefundPopup: false,
        returnPaymentDetail: new CreditMemoReturnPaymentDetailBean(),
      });
    }
  };
  saveReturntoCustomerError = (error) => {
    this.setState({
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
    ShowError("Error : " + error);
  };
  saveReturntoCustomer = () => {
    let cmData = this.state.cmData;
    let returnPaymentDetail = this.state.returnPaymentDetail;
    let maxLineNumber = this.getMaxLineNumberReturnPaymentDetail();
    returnPaymentDetail.lineNumber = maxLineNumber + 1;
    let date = new Date();
    let currentDate = date.toLocaleDateString("sv-SE");
    returnPaymentDetail.creditMemoReturnPaymentDate = currentDate;
    returnPaymentDetail.currencyCode = cmData.customerCurrencyCode;
    let amount = parseFloat(
      returnPaymentDetail.cashAmount +
        returnPaymentDetail.checkAmount +
        returnPaymentDetail.cardAmount,
    );
    cmData.returnAmount = amount;
    cmData.returnPaymentDetails.push(returnPaymentDetail);
    let inputRequest = new RestCreditMemoBeanRequest();
    inputRequest.companyCode = this.companyCode;
    inputRequest.creditMemoBean = cmData;
    // console.log("cmData refund:", cmData);
    if (
      SecurityAccessManager.CreditMemoMaintenanceCustomerRefund_IsAccessible()
    ) {
      CreditMemoService.generateAndAppliedAmountForCreditMemoReturnPayment(
        cmData,
        this.saveReturntoCustomerResponse,
        this.saveReturntoCustomerError,
      );
    } else {
      let errMsg = "Access Denied";
      let errList = [];
      errList.push(errMsg);

      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
  };
  savePostAllResponse = (response) => {
    console.log("inputRequest... response", response);
    let isSuccess = this.handleARResponse(response.data);
    if (
      !isEmpty(response.data) &&
      !isEmpty(response.data.accountReceivable) &&
      isSuccess
    ) {
      this.closeAlertModalCallBack(false);
      this.isLocked = false;
      this.unlockCreditMemo(this.state.cmData.code);
      setTimeout(() => {
        this.setState({
          isShowProgressBarPopup: false,
          progressLoadingText: "",
        });
        this.editCreditMemo(this.state.cmData.code);
      }, 200);
    }
    this.setState({
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
  };
  savePostAllError = (error) => {
    ShowError("Error : " + error);
  };
  savePostAll = () => {
    let arData = this.toAccountReceivableData();
    let cmData = this.state.cmData;
    cmData.autoGeneratedARNumberForInvoiceApply = arData.code;
    arData.lines.map((list) => {
      cmData.invoiceNumber = list.invoiceNumber;
    });
    let inputRequest = new RestAccountReceivableBeanRequest();
    inputRequest.companyCode = this.companyCode;
    inputRequest.creditMemoBean = this.state.cmData;
    inputRequest.accountReceivableBean = arData;
    inputRequest.isLockRequired = true;
    inputRequest.isLoadChildren = true;
    console.log("inputRequest...", inputRequest);
    if (SecurityAccessManager.CreditMemoMaintenance_IsAccessible()) {
      AccountReceivableService.createAccountReceivableFromCreditMemo(
        inputRequest,
        this.savePostAllResponse,
        this.savePostAllError,
      );
    } else {
      let errMsg = "Access Denied";
      let errList = [];
      errList.push(errMsg);

      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
  };

  toAccountReceivableData = () => {

    let cmData = this.state.cmData;
    let arLines = this.state.arLines;

    let date = new Date();
    let currentDate = date.toLocaleDateString("sv-SE");

    let arData = new AccountReceivableBean();

    arData.companyCode = this.companyCode;
    arData.code = "NEW";

    arData.customerCode = cmData.customerCode;
    arData.customerName = cmData.customerName;
    arData.customerCurrencyCode = cmData.customerCurrencyCode;
    arData.companyCurrencyCode = cmData.companyCurrencyCode;
    arData.billToCode = cmData.billToCode;

    arData.accountReceivableDate = currentDate;
    arData.accountReceivableStatus = "O";
    arData.createdDate = currentDate;

    let totalAppliedAmount = 0;

    for (let line of arLines) {

        let arLine = new AccountReceivableLineBean();

        arLine.accountReceivableNumber = arData.code;
        arLine.companyCode = arData.companyCode;
        arLine.invoiceNumber = line.invoiceNumber;
        arLine.currencyCode = arData.companyCurrencyCode;
        arLine.openInvoiceAmount = line.openInvoiceAmount;
        arLine.appliedAmount = line.appliedAmount;
        arLine.creditMemoAppliedAmount = line.creditMemoAppliedAmount;
        arLine.totalAppliedAmount = line.creditMemoAppliedAmount;
        arLine.invoiceDate = line.invoiceDate;
        arLine.customerPurchaseOrderNumber =
            line.customerPurchaseOrderNumber;
        arLine.creditAppliedAmount = line.creditAppliedAmount;

        totalAppliedAmount += Number(line.creditMemoAppliedAmount || 0);

        arData.lines.push(arLine);
    }

    let applicableCreditMemo =
        new AccountReceivableApplicableCreditMemoBean();

    applicableCreditMemo.accountReceivableNumber = arData.code;
    applicableCreditMemo.companyCode = arData.companyCode;
    applicableCreditMemo.creditMemoNumber = cmData.code;
    applicableCreditMemo.currencyCode = arData.customerCurrencyCode;
    applicableCreditMemo.creditmemoCreatedDate = currentDate;
    applicableCreditMemo.creditMemoAmount = cmData.totalCreditAmount;
    applicableCreditMemo.creditMemoAppliedAmount = -totalAppliedAmount;
    applicableCreditMemo.creditMemoProvisionalAppliedAmount =
        cmData.provisionalAppliedAmount;
    applicableCreditMemo.applicableAmount =
        cmData.totalCreditAmount -
        totalAppliedAmount -
        cmData.provisionalAppliedAmount;

    arData.applicableCreditMemos.push(applicableCreditMemo);

    let cmAppliedline =
        new AccountReceivableAppliedCreditMemoLineBean();

    cmAppliedline.companyCode = arData.companyCode;
    cmAppliedline.accountReceivableNumber = arData.code;
    cmAppliedline.creditMemoNumber = cmData.code;
    cmAppliedline.creditMemoAmount = cmData.totalCreditAmount;
    cmAppliedline.creditMemoAppliedAmount = totalAppliedAmount;

    arData.appliedCreditMemoLines.push(cmAppliedline);

    return arData;
};

  toAccountReceivableData_old = () => {
    let arData = this.state.arData;
    arData.companyCode = this.companyCode;
    let cmData = this.state.cmData;
    let arLines = this.state.arLines;
    // console.log("arlines...", arLines);
    let accountData = null;
    let date = new Date();
    let currentDate = date.toLocaleDateString("sv-SE");
    for (let line of arLines) {
      let arData = new AccountReceivableBean();
      arData.companyCode = this.companyCode;
      arData.code = line.accountReceivableNumber;
      arData.customerCode = cmData.customerCode;
      arData.customerName = cmData.customerName;
      arData.customerCurrencyCode = cmData.customerCurrencyCode;
      arData.companyCurrencyCode = cmData.companyCurrencyCode;
      arData.billToCode = cmData.billToCode;
      arData.accountReceivableDate = line.arDate;
      arData.accountReceivableStatus = "O";
      arData.createdDate = currentDate;
      let arLine = new AccountReceivableLineBean();
      arLine.accountReceivableNumber = line.accountReceivableNumber;
      arLine.companyCode = line.companyCode;
      arLine.invoiceNumber = line.invoiceNumber;
      arLine.currencyCode = arData.companyCurrencyCode;
      arLine.openInvoiceAmount = line.openInvoiceAmount;
      arLine.appliedAmount = line.appliedAmount;
      arLine.creditMemoAppliedAmount = line.creditMemoAppliedAmount;
      arLine.totalAppliedAmount = line.creditMemoAppliedAmount;
      arLine.invoiceDate = line.invoiceDate;
      arLine.customerPurchaseOrderNumber = line.customerPurchaseOrderNumber;
      arLine.creditAppliedAmount = line.creditAppliedAmount;
      arData.lines.push(arLine);
      let applicableCreditMemo =
        new AccountReceivableApplicableCreditMemoBean();
      applicableCreditMemo.accountReceivableNumber = arData.code;
      applicableCreditMemo.companyCode = arData.companyCode;
      applicableCreditMemo.creditMemoNumber = cmData.code;
      applicableCreditMemo.currencyCode = arData.customerCurrencyCode;
      applicableCreditMemo.creditmemoCreatedDate = currentDate;
      applicableCreditMemo.creditMemoAmount = cmData.totalCreditAmount;
      applicableCreditMemo.creditMemoAppliedAmount = -cmData.appliedAmount;
      applicableCreditMemo.creditMemoProvisionalAppliedAmount =
        cmData.provisionalAppliedAmount;
      applicableCreditMemo.applicableAmount =
        cmData.totalCreditAmount -
        cmData.appliedAmount -
        cmData.provisionalAppliedAmount;
      arData.applicableCreditMemos.push(applicableCreditMemo);
      let cmAppliedline = new AccountReceivableAppliedCreditMemoLineBean();
      cmAppliedline.companyCode = arData.companyCode;
      cmAppliedline.accountReceivableNumber = arData.code;
      cmAppliedline.creditMemoNumber = cmData.code;
      cmAppliedline.creditMemoAmount = cmData.totalCreditAmount;
      cmAppliedline.creditMemoAppliedAmount = line.creditMemoAppliedAmount;
      arData.appliedCreditMemoLines.push(cmAppliedline);
      accountData = arData;
      this.setState({ arData: accountData });
      // console.log("accountData...", accountData);
    }
    return accountData;
  };

  handleAdjustmentResponse = (response) => {
    let success = false;
    if (response.errors != null) {
      let errMsg = "";
      let errList = [];
      response.errors.map(
        (err) => (
          (errMsg = errMsg + err.messageDescription),
          errList.push(err.messageDescription)
        ),
      );
      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: false,
        isShowAlertLvl3: true,
      });
      success = false;
    }
    if (response.infos != null) {
      let infoMsg = "";
      let successMsg = [];
      response.infos.map(
        (info) => (infoMsg = infoMsg + info.messageDescription),
      );
      successMsg.push(infoMsg);
      this.setState({
        alertMessage: successMsg,
        alertType: "success",
        isShowAlert: true,
        isShowAlertLvl3: false,
      });
      success = true;
    }
    return success;
  };
  handleResponse = (response) => {
    let success = false;
    if (response.errors != null) {
      let errMsg = "";
      let errList = [];
      response.errors.map(
        (err) => (
          (errMsg = errMsg + err.messageDescription),
          errList.push(err.messageDescription)
        ),
      );
      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
        isShowAlertLvl2: true,
      });
      success = false;
    }
    if (response.infos != null) {
      let infoMsg = "";
      let successMsg = [];
      response.infos.map(
        (info) => (infoMsg = infoMsg + info.messageDescription),
      );
      successMsg.push(infoMsg);
      this.setState({
        alertMessage: successMsg,
        alertType: "success",
        isShowAlert: true,
        isShowAlertLvl2: false,
      });
      success = true;
    }
    return success;
  };
  handleARResponse = (response) => {
    let success = false;
    if (response.errors != null) {
      let errMsg = "";
      let errList = [];
      response.errors.map(
        (err) => (
          (errMsg = errMsg + err.messageDescription),
          errList.push(err.messageDescription)
        ),
      );
      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlertLvl2: true,
      });
      success = false;
    }
    let infoMsg = "";
    let infoList = [];
    if (
      !isEmpty(response.accountReceivable) &&
      !isEmptyArray(response.accountReceivable.accountReceivableBeans)
    ) {
      let arNumbers = "";
      response.accountReceivable.accountReceivableBeans.map((ar) => {
        if (!isEmptyString(arNumbers)) arNumbers = arNumbers + ",";
        arNumbers = arNumbers + ar.code;
      });
      if (!isEmptyString(arNumbers)) {
        infoMsg = "Account Receivable(s) " + arNumbers + " Created SuccessFull";
      }

      infoList.push(infoMsg);
      this.setState({
        alertMessage: infoList,
        alertType: "success",
        isShowAlert: true,
      });
      success = true;
    }
    if (!isEmpty(response.infos)) {
      if (isEmptyString(infoMsg)) {
        response.infos.map(
          (info) => (infoMsg = infoMsg + info.messageDescription),
        );
        infoList.push(infoMsg);
        this.setState({
          alertMessage: infoList,
          alertType: "success",
          isShowAlert: true,
        });
      }
      success = true;
    }
    return success;
  };
  getModuleListView = () => {
    let cmData = this.state.cmData;
    if (cmData.code === "NEW") {
      this.closeEntryFrom();
      this.loadCreditMemoPage();
    } else {
      if (this.isLocked) {
        this.isLocked = false;
        if (!this.state.isViewMode) this.unlockCreditMemo(cmData.code);
      } else {
        this.isLocked = false;
      }

      this.closeEntryFrom();
      this.loadCreditMemoPage();
    }
  };
  resetView = () => {
    let cmData = this.state.cmData;
    this.state.isReseted = true;
    if (this.isLocked) {
      this.isLocked = false;
      if (!this.state.isViewMode) this.unlockCreditMemo(cmData.code);
    } else {
      this.isLocked = false;
    }

    let cm_Data = new CreditMemoBean();
    this.setState({
      cmData: cm_Data,
      isResetModule: true,
      moduleKeyCode: "NEW",
      disabled: false,
      isFocus: false,
      isFocusLookup: true,
      isShowAutoCompleteCreditTypeList: false,
      creditTypePageListForAutoCompleteList: new Array(),
      isShowAutoCompleteCreditSubTypeList: false,
      creditSubTypePageListForAutoCompleteList: new Array(),
      isShowAutoCompleteLocationList: false,
      locationPageListForAutoCompleteList: new Array(),
      isShowAutoCompleteCustomerList: false,
      customerPageListForAutoCompleteList: new Array(),
      isShowAutoCompleteFabricList: false,
      fabricPageListForAutoCompleteList: new Array(),
      isShowAutoCompleteCreditsubTypeList: false,
      creditsubTypePageListForAutoCompleteList: new Array(),
      isShowAutoCompleteCreditsubtypeList: false,
      creditsubtypePageListForAutoCompleteList: new Array(),
      isShowAutoCompleCommissionList: false,
      commissionPageListForAutoCompleteList: new Array(),
      isShowAutoCompleReasonList: false,
      reasonPageListForAutoCompleteList: new Array(),
      isShowAutoCompleCustomerReturnList: false,
      customerReturnPageListForAutoCompleteList: new Array(),
      isShowAutoCompleteBillToList: false,
      billToPageListForAutoCompleteList: new Array(),
      customerReturnData: new CustomerReturnBean(),
      selectedNodeKey: "headerView",
      statusTrackList: [],
      creditMemoCommisionList: [],
      merchandiseLinesList: [],
      nonMerchandiseLinesList: [],
      returnPaymentLinesList: [],
    });
    this.state.moduleKeyCode = NEW_ENTRY;
    this.code = NEW_ENTRY;
    this.state.isViewMode = false;
    this.customerCleared();
    this.hideAlertCallBack();
    this.addNewEntry();
  };
  onModuleKeyCodeChange = (e) => {
    let moduleKeyCode = this.state.moduleKeyCode;
    if (e.target.value !== "NEW" && e.target.value !== "undefined") {
      moduleKeyCode = e.target.value;
    }
    this.setState({ moduleKeyCode: moduleKeyCode });
  };
  onModuleKeyCodeWithCriteriaOnChange = (e) => {
    let moduleKeyCode = this.state.moduleKeyCode;
    if (e.target.value !== "NEW" && e.target.value !== "undefined") {
      moduleKeyCode = e.target.value.toUpperCase();
    }
    this.setState({ moduleKeyCode: moduleKeyCode });
  };
  selectButtonClick = (e) => {
    this.editCreditMemo(this.state.moduleKeyCode);
    // this.disable();
  };
  disable = () => {
    this.setState({
      disabled: true,
    });
  };
  _executeAfterModalClose = (e) => {
    let returnPaymentDetail = new CreditMemoReturnPaymentDetailBean();
    this.state.returnPaymentDetail = returnPaymentDetail;
    this.setState({ returnPaymentDetail: returnPaymentDetail });
  };
  _executeAfterApplytoInvoiceClose = (e) => {};
  resetFilteredCM = () => {
    let criteria = new CreditMemoSearchCriteria();
    criteria.companyCode = this.companyCode;
    this.state.isAdvanceSearch = false;
    this.state.criteria = criteria;
    this.setState({ criteria: criteria });
    this.loadPage(1);
  };
  resetFilter = () => {
    let criteria = new CreditMemoSearchCriteria();
    criteria.companyCode = this.companyCode;
    this.state.isAdvanceSearch = false;
    this.state.criteria = criteria;
    this.setState({ criteria: criteria });
    this.loadPage(1);
  };
  loadFirst = () => {
    this.loadPage(1);
  };
  loadPrevious = () => {
    let currentPage = this.state.pageList.currentPage;
    let previousPage = currentPage - 1;
    this.loadPage(previousPage);
  };
  loadNext = () => {
    let currentPage = this.state.pageList.currentPage;
    let nextPage = currentPage + 1;
    this.loadPage(nextPage);
  };
  loadLast = () => {
    let pageSize = this.state.pageList.pageSize;
    let totalCount = this.state.pageList.totalCount;
    let totalPages = totalCount / pageSize;
    totalPages += totalCount % pageSize == 0 ? 0 : 1;
    this.loadPage(totalPages);
  };
  loadPage = (pageNumber) => {
    let criteria = new CreditMemoSearchCriteria();
    criteria = this.state.criteria;
    criteria.companyCode = this.companyCode;
    this.state.criteria = criteria;
    let pageInput = new RestPageListBean();
    pageInput.pageSize = 50;
    pageInput.currentPage = pageNumber;
    this.state.pageList = pageInput;
    this.loadCreditMemoPage();
  };
  onChange = (e) => {
    let temp_cmData = this.state.cmData;
    temp_cmData[e.target.name] = e.target.value;
    if (e.target.name === "invoiceNumber") {
      temp_cmData.merchandiseLines = [];
      this.setState({ merchandiseLinesList: [] });
      // console.log("cm data merchandiselines..");
    }
    this.setState({ cmData: temp_cmData });
  };
  invoiceCodeEnterKeyEventHandler = (e) => {
    this.onInvoiceNumberChange(e.target.value);
  };
  currentARLineChange = (e) => {
    let temp_arLine = this.state.currentARLine;
    let temp_cmData = this.state.cmData;
    temp_arLine[e.target.name] = e.target.value;
    if (e.target.name === "invoiceNumber") this.readInvoiceandSetARLine();
    else if (e.target.name === "creditAppliedAmount") {
      temp_arLine = this.validateandSetAppliedAmount(temp_arLine, e);
    }
    this.setState({ currentARLine: temp_arLine });
  };
  validateandSetAppliedAmount = (temp_arLine, e) => {
    let openCreditAmount = this.getOpenCreditAmount();
    if (e.target.value > openCreditAmount) {
      ShowError(" Invoice Applied Amount is Exceeds CreditMemo Open Amount ");
      temp_arLine["creditAppliedAmount"] = 0;
      temp_arLine["creditMemoAppliedAmount"] = 0;
      temp_arLine["totalAppliedAmount"] = 0;
    } else {
      temp_arLine["creditMemoAppliedAmount"] = e.target.value;
      temp_arLine["totalAppliedAmount"] = e.target.value;
    }
    return temp_arLine;
  };
  readInvoiceandSetARLineResponse = (response) => {
    let temp_arLine = this.state.currentARLine;
    let err_msg = "";
    let err_list = [];
    if (response.data.invoice != null) {
      let isValidInvoice = true;
      if (response.data.invoice.invoiceStatus == "X") {
        err_msg =
          "Invalid Invoice!  Invoice# : " +
          temp_arLine.invoiceNumber +
          " is Cancelled ";
        err_list.push(err_msg);
        isValidInvoice = false;
      } else if (response.data.invoice.invoiceStatus == "U") {
        err_msg =
          "Invalid Invoice!  Invoice# : " +
          temp_arLine.invoiceNumber +
          " is Unapproved ";
        err_list.push(err_msg);
        isValidInvoice = false;
      } else if (response.data.invoice.invoiceStatus == "F") {
        err_msg =
          "Invalid Invoice!  Invoice# : " +
          temp_arLine.invoiceNumber +
          " is Paid ";
        err_list.push(err_msg);
        isValidInvoice = false;
      }
      if (
        response.data.invoice.customerCode !== this.state.cmData.customerCode
      ) {
        err_msg = "Invalid Invoice!  Customer is  Mismatched! ";
        err_list.push(err_msg);
        isValidInvoice = false;
      }
      if (isValidInvoice) {
        let invoice = response.data.invoice;
        // console.log("invoice..", invoice);
        let currentDate = new Date();
        let arLine = new AccountReceivableLineBean();
        arLine.companyCode = invoice.companyCode;
        arLine.invoiceNumber = invoice.code;
        arLine.invoiceDate = invoice.createdDate;
        arLine.currencyCode = invoice.invoiceCurrencyCode;
        arLine.accountReceivableNumber = "NEW";
        arLine.arDate = currentDate.toLocaleDateString("sv-SE");
        arLine.creditMemoFlag = false;
        arLine.grantTotalAmount = parseFloat(invoice.grandTotalAmount);
        let openInvAmount =
          parseFloat(invoice.grandTotalAmount) -
          parseFloat(invoice.netPaidAmount);
        arLine.openInvoiceAmount = parseFloat(openInvAmount);
        arLine.paidAmount = parseFloat(invoice.paidAmount);
        arLine.customerPurchaseOrderNumber =
          invoice.customerPurchaseOrderNumber;
        arLine.creditAppliedAmount = parseFloat(invoice.paidCreditMemoAmount);
        arLine.currencyExchangeRate = 1;
        arLine.standardOpenInvoiceAmount = parseFloat(
          invoice.grandTotalAmount - invoice.paidAmount,
        );
        arLine.standardAppliedAmount = parseFloat(
          arLine.creditMemoAppliedAmount,
        );
        arLine.standardCreditMemoAppliedAmount = parseFloat(
          arLine.creditMemoAppliedAmount,
        );
        arLine.standardTotalAppliedAmount = parseFloat(invoice.paidAmount);
        arLine.appliedAmount = parseFloat(arLine.creditMemoAppliedAmount);
        this.setState({
          invoiceData: response.data.invoice,
          currentARLine: arLine,
        });
      } else {
        this.setState({
          alertMessage: err_list,
          alertType: "danger",
          isShowAlertLvl2: true,
          // isShowAlert: true,
        });
      }
    } else {
      err_msg = "Invalid Invoice#!  No Invoice !! ";
      err_list.push(err_msg);
      this.setState({
        alertMessage: err_list,
        alertType: "danger",
        isShowAlertLvl2: true,
        // isShowAlert: true,
      });
    }
  };
  readInvoiceandSetARLineError = (error) => {
    ShowError("Error : " + error);
  };
  readInvoiceandSetARLine = () => {
    let readrestInput = new RestReadRequest();
    readrestInput.companyCode = this.companyCode;
    let temp_arLine = this.state.currentARLine;
    readrestInput.code = temp_arLine.invoiceNumber;
    if (SecurityAccessManager.CreditMemoMaintenance_IsAccessible()) {
      InvoiceService.readInvoice(
        readrestInput,
        this.readInvoiceandSetARLineResponse,
        this.readInvoiceandSetARLineError,
      );
    } else {
      let errMsg = "Access Denied";
      let errList = [];
      errList.push(errMsg);

      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
  };
  onReturnPaymentDetailsChange = (e) => {
    let temp_cmData = this.state.cmData;
    let temp_returnPaymentDetail = this.state.returnPaymentDetail;
    temp_returnPaymentDetail.customerCode = temp_cmData.customerCode;
    temp_returnPaymentDetail.customerName = temp_cmData.customerName;
    temp_returnPaymentDetail[e.target.name] = e.target.value;
    if (
      e.target.name === "checkAmount" ||
      e.target.name === "cashAmount" ||
      e.target.name === "cardAmount"
    ) {
      if (e.target.name === "checkAmount") {
        temp_returnPaymentDetail.cashAmount = 0;
        temp_returnPaymentDetail.cardAmount = 0;
      } else if (e.target.name === "cashAmount") {
        temp_returnPaymentDetail.checkAmount = 0;
        temp_returnPaymentDetail.cardAmount = 0;
      } else if (e.target.name === "cardAmount") {
        temp_returnPaymentDetail.checkAmount = 0;
        temp_returnPaymentDetail.cashAmount = 0;
      }
    }
    this.setState({ returnPaymentDetail: temp_returnPaymentDetail });
  };
  onInvoiceNumberChange = (value) => {
    this.readandValidateInvoice(value);
  };
  getInvoiceLinecolumnDefinitions = () => {
    let columnList = [];
    columnList.push(
      new DataGridColumnDefinition().setDetails(
        "Invoice#",
        "invoiceNumber",
        0,
        false,
        null,
        false,
        null,
        "1rem",
        "5rem",
      ),
    );
    columnList.push(
      new DataGridColumnDefinition().setDetails(
        "Line",
        "lineNumber",
        0,
        false,
        null,
        false,
        null,
        "1rem",
        "5rem",
      ),
    );
    if (this.state.is3PL) {
      columnList.push(
        new DataGridColumnDefinition().setDetails("Item#", "fabricStyleCode"),
      );
    } else {
      columnList.push(
        new DataGridColumnDefinition().setDetails("Fabric#", "fabricStyleCode"),
      );
    }
    columnList.push(
      new DataGridColumnDefinition().setDetails(
        "Name#",
        "fabricStyleName",
        0,
        false,
        null,
        false,
        null,
        "1rem",
        "20rem",
      ),
    );
    columnList.push(
      new DataGridColumnDefinition().setDetails(
        "Color",
        "colorCode",
        0,
        false,
        null,
        false,
        null,
      ),
    );
    columnList.push(
      new DataGridColumnDefinition().setDetails(
        this.state.is3PL ? "Inventory#" : "RollSKU#",
        "rollSkuNumber",
        0,
        false,
        null,
        false,
        null,
      ),
    );
    columnList.push(
      new DataGridColumnDefinition().setDetails(
        "Roll#",
        "rollNumber",
        0,
        false,
        null,
        false,
        null,
      ),
    );
    columnList.push(
      new DataGridColumnDefinition().setDetails(
        "Box#",
        "boxNumber",
        0,
        false,
        null,
        false,
        null,
      ),
    );
    columnList.push(
      new DataGridColumnDefinition().setDetails(
        "Price",
        "price",
        1,
        false,
        null,
        false,
        null,
      ),
    );
    columnList.push(
      new DataGridColumnDefinition().setDetails(
        "Shipped Qty#",
        "shippedQuantity",
        1,
        false,
        null,
        false,
        null,
      ),
    );
    columnList.push(
      new DataGridColumnDefinition().setDetails(
        "Vendor Lot#",
        "vendorBatchNumber",
        0,
        false,
        null,
        false,
        null,
      ),
    );
    return columnList;
  };
  getSelectedInvoiceLineMaxNumber() {
    let maxLineNumber = 0;
    let invLineFormData = this.state.cmData.merchandiseLines;
    if (invLineFormData.length > 0)
      invLineFormData.map((line) => {
        if (line.lineNumber > maxLineNumber) {
          maxLineNumber = line.lineNumber;
        }
      });
    return maxLineNumber;
  }
  addInvoiceLinesToReturn = (e) => {
    if (e.detail == 1) {
      let selectedInvoiceLines = this.state.selectedInvoiceLines;
      let merchandiseLinesList = this.state.merchandiseLinesList;
      let lines = this.state.invoiceLines;
      if (!selectedInvoiceLines) return;
      let invoiceLines = new Array();
      invoiceLines = selectedInvoiceLines;
      let tempCmData = this.state.cmData;
      let lineNumber = this.getSelectedInvoiceLineMaxNumber();

      invoiceLines.map((line) => {
        let merchandiseLine = new CreditMemoMerchandiseLineBean();
        merchandiseLine.fabricStyleCode = line.fabricStyleCode;
        merchandiseLine.fabricStyleName = line.fabricStyleName;
        merchandiseLine.colorCode = line.colorCode;
        merchandiseLine.lineNumber = ++lineNumber;
        merchandiseLine.widthCode = line.widthCode;
        //merchandiseLine.locationCode = line.locationCode;
		merchandiseLine.locationCode = line.sourceLocationCode;
        merchandiseLine.price = line.price;
        merchandiseLine.sourceSalesOrderNumber = line.sourceSalesOrderNumber;
        merchandiseLine.skuNumber = line.skuNumber;
        merchandiseLine.rollNumber = line.rollNumber;
        merchandiseLine.rollSkuNumber = line.rollSkuNumber;
        merchandiseLine.uomCode = line.invoiceUomCode;
        merchandiseLine.upcCode = line.upcCode;
        merchandiseLine.productDivisionCode = line.productDivisionCode;
        merchandiseLine.productDepartmentCode = line.productDepartmentCode;
        merchandiseLine.currencyCode = tempCmData.customerCurrencyCode;
        merchandiseLine.invoiceNumber = line.invoiceNumber;
        merchandiseLine.isSelected = false;
        merchandiseLine.creditSubType = tempCmData.creditType;
        merchandiseLine.lineStatus = "O";
        merchandiseLine.lineTotalReturnQuantity = line.shippedQuantity;
        merchandiseLine.lineTotalAmount =
          parseFloat(merchandiseLine.lineTotalReturnQuantity) *
          parseFloat(merchandiseLine.price);
        tempCmData.merchandiseLines.push(merchandiseLine);

        merchandiseLinesList.push(merchandiseLine);
      });
      this.setState({
        cmData: tempCmData,
        invoiceLines: lines,
        merchandiseLinesList: merchandiseLinesList,
        selectedInvoiceLines: new Array(),
      });
      this.closeAlertModalCallBack(false);
      this.calculateTotals();
    }
  };

  calculateTotals() {
    if (!isEmpty(this.state.cmData)) {
      let totMerchandiseCreditAmount = 0;
      let totNonMerchandiseCreditAmount = 0;
      let totTaxAmount = 0;
      if (!isEmptyArray(this.state.cmData.merchandiseLines)) {
        this.state.cmData.merchandiseLines.map((line) => {
          let lineTotalAmount =
            parseFloat(line.price) * parseFloat(line.lineTotalReturnQuantity);
          line.lineTotalAmount = lineTotalAmount.toFixed(2);
          totMerchandiseCreditAmount =
            totMerchandiseCreditAmount + parseFloat(line.lineTotalAmount);
          if (
            line.isTaxRequiredFlag &&
            line.lineStatus !== LogicConstants.CREDIT_MEMO_LINE_CANCEL_STATUS
          )
            line.taxAmount = (line.lineTotalAmount * line.taxPercentage) / 100;
          totTaxAmount = totTaxAmount + parseFloat(line.taxAmount);
        });
      }
      if (!isEmptyArray(this.state.cmData.nonMerchandiseLines)) {
        this.state.cmData.nonMerchandiseLines.map((line) => {
          totNonMerchandiseCreditAmount =
            totNonMerchandiseCreditAmount + parseFloat(line.lineTotalAmount);
        });
      }
      this.state.cmData.merchandiseCreditAmount = parseFloat(
        totMerchandiseCreditAmount,
      );
      this.state.cmData.nonMerchandiseCreditAmount = parseFloat(
        totNonMerchandiseCreditAmount,
      );
      let totalCreditAmount =
        this.state.cmData.merchandiseCreditAmount +
        this.state.cmData.nonMerchandiseCreditAmount;
      if (this.state.cmData.isTaxRequiredFlag)
        totalCreditAmount =
          parseFloat(totalCreditAmount) + parseFloat(totTaxAmount);
      this.state.cmData.totalCreditAmount = parseFloat(totalCreditAmount);
    }
  }
  onCheckBoxClick = (e) => {
    let selectedRows = e.selectedRows;
    const selectedInvoiceLines = this.state.selectedInvoiceLines;
    selectedInvoiceLines.map((inv) => {
      selectedRows.map((ln) => {
        if (
          inv.skuNumber === ln.skuNumber &&
          inv.invoiceNumber === ln.invoiceNumber
        ) {
          selectedInvoiceLines.push(ln);
        }
      });
    });

    this.setState({
      selectedInvoiceLines: selectedRows,
    });
  };
  onselectableRowSelected = (row) => {
    let selectedInvoiceLines = this.state.selectedInvoiceLines;
    let isRowSelected = false;
    if (selectedInvoiceLines) {
      selectedInvoiceLines.map((line) => {
        if (
          line.skuNumber == row.skuNumber &&
          line.invoiceNumber == row.invoiceNumber
        ) {
          isRowSelected = true;
        }
      });
    }
    return isRowSelected;
  };
  handleARHyperLinkClick = (e, val, rowData) => {
    if (e.detail == 1) {
      if (rowData.accountReceivableNumber === "NEW") {
        if (!isEmpty(rowData) && !rowData.isFetched) {
          let arLine = { ...rowData };
          this.setState({ currentARLine: arLine });
        }
      } else if (
        rowData.accountReceivableNumber != "NEW" &&
        isEmptyString(rowData.accountReceivableNumber)
      ) {
        this.viewARModule(val);
      }
    }
  };
  closeAlertModalCallBack = (isShowPopup) => {
    isShowPopup = false;
    let returnPaymentDetail = new CreditMemoReturnPaymentDetailBean();
    let cmData = this.state.cmData;
    returnPaymentDetail.companyCode = this.companyCode;
    returnPaymentDetail.creditMemoNumber = cmData.code;
    returnPaymentDetail.currencyCode = cmData.customerCurrencyCode;

    this.setState({
      isShowAdvanceSearchPopup: isShowPopup,
      isShowFetchInvoicePopup: isShowPopup,
      isShowApplyInvoicePopup: isShowPopup,
      isShowOnHandQtyPopup: isShowPopup,
      isShowRefundPopup: isShowPopup,
      isShowUnApprovePopup: isShowPopup,
      isShowAdjustPopup: isShowPopup,
      isShowCustomerReturnPopup: isShowPopup,
      isShowAlertLvl5: isShowPopup,
      isShowAlertLvl2: isShowPopup,
      isShowAlertLvl3: isShowPopup,
      adjustNonMerchandiseData: new CreditMemoNonMerchandiseLineBean(),

      currentARLine: new AccountReceivableLineBean(),
      customerReturnData: new CustomerReturnBean(),
      isShowAutoCompleCustomerReturnList: false,
      customerReturnPageListForAutoCompleteList: new Array(),
      returnPaymentDetail: returnPaymentDetail,
    });
    // this.ClearRefundDetail();
    // this.clearcustomerReturn();
    // this.onClearArLineClick();
    // this.clearAdjustment();
  };
  getRollLines = (fabricCode, colorCode, locationCode, skuNumber) => {
    let searchCriteria = new SKUBatchInventorySearchCriteria();
    searchCriteria.companyCode = this.companyCode;
    searchCriteria.fabricStyleCode = fabricCode;
    searchCriteria.colorCode = colorCode;
    searchCriteria.locationCode = locationCode;
    searchCriteria.skuNumber = skuNumber;
    let pageInput = new RestPageListBean();
    pageInput.pageSize = 20;
    pageInput.currentPage = 1;
    let requestInput = new RestSkuBatchInventoryListRequest();
    requestInput.pageInput = pageInput;
    requestInput.searchCriteria = searchCriteria;
    InventoryService.getSKUBatchInventoriesForRollBased(
      requestInput,
      this.loadSkuBatchInventoryPageResponse,
      this.loadSkuBatchInventoryPageError,
    );
  };
  loadSkuBatchInventoryPageResponse = (response) => {
    let rollLines = [];
    if (response.data.batchInventoryDataResult != null) {
      if (
        response.data.batchInventoryDataResult.batchInventoryDataBean != null
      ) {
        if (
          response.data.batchInventoryDataResult.batchInventoryDataBean
            .inventoryDataDetails != null
        ) {
          rollLines =
            response.data.batchInventoryDataResult.batchInventoryDataBean
              .inventoryDataDetails;
          this.setState({
            rollLines: rollLines,
          });
        }
      }
    }
  };
  loadSkuBatchInventoryPageError = (error) => {
    ShowError("loadSkuBatchInventoryPageError" + error);
  };
  onFabricCodeChange = (e) => {
    let fabricCode = e.target.value;
    this.state.isShowAutoCompleteFabricList = true;
    let tempData = this.state.merchandiseLineData;
    let showAutoCompleteList = this.state.isShowAutoCompleteFabricList;
    if (isEmpty(fabricCode)) {
      this.state.isShowAutoCompleteFabricList = false;
      let showAutoCompleteList = this.state.isShowAutoCompleteFabricList;
      let tempData = this.state.merchandiseLineData;
      tempData.fabricStyleCode = "";
      let suggestion = [];
      this.setState({
        isShowAutoCompleteList: showAutoCompleteList,
        merchandiseLineData: tempData,
        fabricPageListForAutoCompleteList: suggestion,
      });
      this.clearFabricStyleRelated();
    } else if (
      e.target.name == "fabricStyleCode" &&
      showAutoCompleteList === true &&
      fabricCode !== ""
    ) {
      setTimeout(() => {
        this.readFabricBySearchString(e.target.value);
      }, 200);
    }
    tempData[e.target.name] = e.target.value.toUpperCase();
    this.setState({ merchandiseLineData: tempData });
  };
  readFabricBySearchString(searchString) {
    let searchCriteria = new FabricStyleSearchCriteria();
    searchCriteria.companyCode = this.companyCode;
    searchCriteria.fabricStyleCodeStartsWith = searchString;
    searchCriteria.fabricStyleNameStartsWith = searchString;
    let pageList = new RestPageListBean();
    pageList.pageSize = 100;
    let input = new RestFabricStyleListBeanRequest();
    input.companyCode = this.companyCode;
    input.pageInput = pageList;
    input.code = searchString;
    input.searchCriteria = searchCriteria;
    FabricStyleService.getActiveFabricStylesForAutoComplete(
      input,
      this.readByFabricSearchCodeResponse,
      this.readByFabricSearchCodeResponseError,
    );
  }
  readByFabricSearchCodeResponse = (response) => {
    let fabricStyleData = response.data.fabricStylePageList.fabricStyles;
    let simpleAutoCompleteList = new Array();
    if (fabricStyleData.length > 0 && fabricStyleData != null) {
      fabricStyleData.map((fabricStyle) => {
        let simpleItemBean = {
          code: fabricStyle.fabricStyleCode,
          description: fabricStyle.fabricStyleName,
        };
        simpleAutoCompleteList.push(simpleItemBean);
      });
    }
    this.setState({
      fabricPageListForAutoCompleteList: simpleAutoCompleteList,
    });
  };
  readByFabricSearchCodeResponseError = (error) => {
    ShowError("Error : ", error);
  };
  fabricCodeEnterKeyEventHandler = (e) => {
    let fabricCode = e.target.value;
    this.readandsetFabricStyleDetail(fabricCode);
    this.state.isShowAutoCompleteFabricList = false;
    let showAutoCompleteList = this.state.isShowAutoCompleteFabricList;
    this.setState({
      isShowProgressBarPopup: true,
      progressLoadingText: "Reading FabricStyle",
    });
    this.setState({
      fabricPageListForAutoCompleteList: new Array(),
      isShowAutoCompleteList: showAutoCompleteList,
    });
  };
  displayAutoFabricCompleteList = (showAutoCompleteList) => {
    this.setState({
      isShowAutoCompleteFabricList: showAutoCompleteList,
    });
  };
  readandsetFabricStyleDetail = (fabricStyleCode) => {
    let input = new RestReadRequest();
    input.companyCode = this.companyCode;
    input.code = fabricStyleCode;
    input.isLockRequired = false;
    input.isLoadChildren = true;
    if (SecurityAccessManager.CreditMemoMaintenance_IsAccessible()) {
      FabricStyleService.readFabricStyle(
        input,
        this.readandsetFabricStyleDetailResponse,
        this.readandsetFabricStyleDetailError,
      );
    } else {
      let errMsg = "Access Denied";
      let errList = [];
      errList.push(errMsg);
      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
  };
  readandsetFabricStyleDetailResponse = (response) => {
    let fabricStyle = response.data.fabricStyle;
    if (!isEmpty(fabricStyle)) {
      this.setState({ fabricStyleData: fabricStyle });
      this.fabricStyleSelected(fabricStyle);
    } else {
      this.clearFabricStyleRelated();
    }
  };
  readandsetFabricStyleDetailError = (error) => {
    ShowError("readFabricStyleError:" + error);
    this.setState({
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
  };
  clearFabricStyleRelated = () => {
    let merchandiseLine = this.state.merchandiseLineData;
    merchandiseLine.fabricStyleCode = "";
    merchandiseLine.fabricStyleName = "";
    let colors = [];
    merchandiseLine.uomCode = "";
    merchandiseLine.colorCode = "";
    merchandiseLine.widthCode = "";
    this.setState({ colorList: colors, salesOrderLineData: merchandiseLine });
  };
  fabricStyleSelected = (fabricStyle) => {
    let merchandiseLine = this.state.merchandiseLineData;
    if (!isEmpty(fabricStyle) && !isEmpty(merchandiseLine)) {
      let colors = fabricStyle.colors;
      merchandiseLine.fabricStyleCode = fabricStyle.code;
      merchandiseLine.fabricStyleName = fabricStyle.description;
      merchandiseLine.widthCode = fabricStyle.width;
      merchandiseLine.uomCode = fabricStyle.inventoryUomCode;
      let finalColorList = [];
      colors.map((ent) => {
        let colorBean = new BaseBean();
        colorBean.code = ent.fabricStyleColorCode;
        colorBean.description = ent.fabricStyleColorName;
        finalColorList.push(colorBean);
      });
      this.setState({ colorLookupHandler: null });
      if (finalColorList != null) {
        let colorLookupHandler = new GenericAttributeLookupHandler(
          finalColorList,
          "Color",
        );
        this.setState({
          colorLookupHandler: colorLookupHandler,
          isShowColorLookup: true,
          merchandiseLineData: merchandiseLine,
          colorList: finalColorList,
          isopenQtyPopup: true,
        });
      }
    }
    this.setState({
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
  };
  fabricStyleColorSelected = (colorCode) => {
    let fabricStyle = this.state.fabricStyleData;
    let merchandiseLine = this.state.merchandiseLineData;
    let skuBean = new FabricStyleSKUBean();
    fabricStyle.fabricStyleSkus.map((sku) => {
      if (
        sku.fabricStyleCode == merchandiseLine.fabricStyleCode &&
        sku.fabricStyleColorCode == colorCode
      )
        skuBean = sku;
    });
    merchandiseLine.colorCode = colorCode;
    if (!isEmpty(skuBean)) {
      merchandiseLine.skuNumber = skuBean.skuNumber;
    }
    this.state.merchandiseLineData = merchandiseLine;
    this.setState({ merchandiseLineData: merchandiseLine });
  };
  onMerchandiseLineKeyPress = (e) => {};
  closeMerchandiseLineAlertModalCallBack = (isShowPopup) => {
    isShowPopup = false;
    this.setState({
      isShowMerchandiseLinePopup: isShowPopup,
      isShowMerchandiseLineAlert: isShowPopup,

      merchandiseLineData: new CreditMemoMerchandiseLineBean(),
      isShowColorLookup: false,
      colorList: [],
    });
  };
  closeNonMerchandiseLineAlertModalCallBack = (isShowPopup) => {
    isShowPopup = false;
    this.setState({
      isShowNonMerchandiseLinePopup: isShowPopup,
      isShowPopupAlertlvl1: isShowPopup,
      nonMerchandiseLineData: new CreditMemoNonMerchandiseLineBean(),
    });
  };
  hideMerchandiseLineAlertCallBack = (msgType, isDisplayed) => {
    this.setState({ isShowMerchandiseLineAlert: isDisplayed });
  };
  hideAlertCallBack = (msgType, isDisplayed) => {
    this.setState({ isShowAlert: isDisplayed });
  };
  getHistoryView() {
    return (
      <CreditMemoHistoryDetailsForm
        {...this.state}
        cmData={this.state.cmData}
        handleSortingStatusChange={this.handleSortingStatusChange}
        statusTrackList={this.state.statusTrackList}
      />
    );
  }
  getPaymentView() {
    return (
      <CreditMemoPaymentDetailsForm
        {...this.state}
        arOnClick={this.arOnClick}
        viewInvoiceModule={this.viewInvoiceModule}
        viewARModule={this.viewARModule}
        closeModalCallBack={this.closeModalCallBack}
        handleSortingCreditMemoAppliedLinesChange={
          this.handleSortingCreditMemoAppliedLinesChange
        }
        handleSortingReturnPaymentChange={this.handleSortingReturnPaymentChange}
        returnPaymentLinesList={this.state.returnPaymentLinesList}
      />
    );
  }
  loadCustomerReturn = () => {
    this.setState({ isShowCustomerReturnPopup: true });
  };
  creditMemoReportResponse = (response) => {
    this.showErrorMessage(response.data);
    if (response.data != null && response.data.reportResult != null) {
      if (!isEmptyString(response.data.reportResult.reportFileID)) {
        let reportFilePath = response.data.reportResult.reportFileID;
        window.open(this.report_url + reportFilePath);
      }
    }
    this.setState({
      isLoading: false,
      loadingText: "",
    });
  };
    creditMemoReportResponseForExcel = (response) => {
    this.showErrorMessage(response.data);
    if (response.data != null && response.data.reportResult != null) {
      if (!isEmptyString(response.data.reportResult.reportFileID)) {
        let reportFilePath = response.data.reportResult.reportFileID;
        // window.open(this.report_url + reportFilePath);
         let downloadAddress = toDownloadReportAddress(reportFilePath,true,true,this.report_url);
        window.open(downloadAddress, "_blank");
      }
    }
    this.setState({
      isLoading: false,
      loadingText: "",
    });
  };
  creditMemoReportError = (error) => {
    ShowError("Erro : " + error);
    this.setState({
      isLoading: false,
      loadingText: "",
    });
  };
    inValidAccess = (type) => {
    let errMsg = "Access Denied";
    if (type == 1) {
      errMsg = "Access Denied";
    } else if (type == 2) {
      errMsg = "PDF Access Denied";
    } else if (type == 3) {
      errMsg = "EXCEL Access Denied";
    } else if (type == 4) {
      errMsg = "Mail Access Denied";
    }
    let errList = [];
    errList.push(errMsg);
    this.setState({
      alertMessage: errList,
      alertType: "danger",
      isShowAlert: true,
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
  };
  generatePDF = () => {
    this.setState({
      isLoading: true,
      loadingText: "Generating PDF",
    });
    this.generateCreditMemoReport(1, this.state.cmData.code);
  };
  generateExcel = () => {
    this.setState({
      isLoading: true,
      loadingText: "Generating Excel",
    });
    this.generateCreditMemoReport(2, this.state.cmData.code);
  };
  generateCreditMemoReport = (reportType, code) => {
    let request = new CreditMemoPrintRequest();
    request.companyCode = this.companyCode;
    request.creditMemoNumber = code;
    if (reportType == 1) {
       if (SecurityAccessManager.CreditMemoMaintenancePDFReport_IsAccessible()) {
      ReportService.generateCreditMemoPrintReport(
        request,
        this.creditMemoReportResponse,
        this.creditMemoReportError,
      );
    }else {
      this.inValidAccess(2);
    }
    
    }else if (reportType == 2) {
       if (SecurityAccessManager.CreditMemoMaintenanceExcelReport_IsAccessible()) {
      ReportService.generateCreditMemoPrintReport(
        request,
        this.creditMemoReportResponseForExcel,
        this.creditMemoReportError,
      );
    }else {
      this.inValidAccess(3);
    }
    }
    // else {
    //   let errMsg = "Access Denied";
    //   let errList = [];
    //   errList.push(errMsg);

    //   this.setState({
    //     alertMessage: errList,
    //     alertType: "danger",
    //     isShowAlert: true,
    //   });
    // }
  };
  approveAndPrint = () => {
    let cmData = this.state.cmData;
    let request = new RestCreditMemoBeanRequest();
    request.companyCode = this.companyCode;
    request.creditMemoBean = cmData;
    request.isDirectPrint = true;
    request.isLockRequired = true;
    let isValid = false;
    this.setState({
      isShowProgressBarPopup: true,
      progressLoadingText: "Approving",
    });
    isValid = this.validateCreditMemoData(cmData);
    // console.log("cmdata...", cmData);
    if (isValid) {
      if (cmData.isFetched) {
        if (
          SecurityAccessManager.CreditMemoMaintenanceApproveAndPrintReport_IsAccessible() &&
          SecurityAccessManager.CreditMemoMaintenanceEdit_IsAccessible()
        ) {
          CreditMemoService.updateAndApproveCreditMemoThenGenerateCreditMemoReport(
            request,
            this.approveAndPrintResponse,
            this.approveAndPrintError,
          );
        } else {
          let errMsg = "Access Denied";
          let errList = [];
          errList.push(errMsg);

          this.setState({
            alertMessage: errList,
            alertType: "danger",
            isShowAlert: true,
          });
        }
      } else {
        if (
          SecurityAccessManager.CreditMemoMaintenanceApproveAndPrintReport_IsAccessible() &&
          SecurityAccessManager.CreditMemoMaintenanceAdd_IsAccessible()
        ) {
          CreditMemoService.createAndApproveCreditMemoThenGenerateCreditMemoReport(
            request,
            this.approveAndPrintResponse,
            this.approveAndPrintError,
          );
        } else {
          let errMsg = "Access Denied";
          let errList = [];
          errList.push(errMsg);

          this.setState({
            alertMessage: errList,
            alertType: "danger",
            isShowAlert: true,
          });
        }
      }
    } else {
      this.setState({
        isShowProgressBarPopup: false,
        progressLoadingText: "",
      });
    }
  };
  approveAndPrintResponse = (response) => {
    // console.log("cmdata...response", response);
    let success = this.handleApproveResponse(response.data);
    if (
      response.data != null &&
      response.data.mainOperationResponse != null &&
      success
    ) {
      let cmData = response.data.mainOperationResponse.creditMemo;
      this.setState({ cmData: cmData });
      if (
        response.data.printReportResponse != null &&
        response.data.printReportResponse.reportResult != null
      ) {
        let reportFilePath =
          response.data.printReportResponse.reportResult.reportFileID;
        window.open(this.report_url + reportFilePath);
      }
      // this.unlockCreditMemo(cmData.code);
      // this.editCreditMemo(cmData.code);
      if (!this.isLocked) {
        this.editCreditMemo(cmData.code);
      } else {
        this.code = cmData.code;
        // this.unlockCreditMemo(cmData.code);
        this.editCreditMemo(cmData.code);
      }

      this.setState({
        isShowProgressBarPopup: false,
        progressLoadingText: "",
      });
    }
    this.setState({
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
  };
  approveAndPrintError = (error) => {
    this.setState({
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
    ShowError("Error :", error);
  };
  onCommissionChange = (e) => {
    let temp_commissionData = this.state.commissionData;
    temp_commissionData[e.target.name] = e.target.value;
    this.setState({ commissionData: temp_commissionData });
  };
  validateCommission = (commission) => {
    let isValidCommission = false;
    let err_list = [];
    let errorMessage = "";
    if (commission == null) {
      let errMsg = "Invalid data ";
      errorMessage = errorMessage + errMsg;
      err_list.push(errMsg);
    } else {
      if (isEmptyString(commission.salesPersonCode)) {
        let errMsg = "salesPerson is Required";
        errorMessage = errorMessage + errMsg;
        err_list.push(errMsg);
      }
      if (isEmptyString(commission.reasonCode)) {
        let errMsg = "Reason is Required";
        errorMessage = errorMessage + errMsg;
        err_list.push(errMsg);
      }
      if (commission.commissionDeductionPercentage == 0) {
        let errMsg = "commissionDeductionPercentage is Required";
        errorMessage = errorMessage + errMsg;
        err_list.push(errMsg);
      } else if (commission.commissionDeductionPercentage <= 0) {
        let errMsg = "CommissionPercentage is inValid";
        errorMessage = errorMessage + errMsg;
        err_list.push(errMsg);
      }
    }
    if (err_list.length > 0) {
      this.setState({
        alertMessage: err_list,
        alertType: "danger",
        isShowAlert: true,
      });
      isValidCommission = false;
      this.setState({ errorList: err_list });
    } else {
      isValidCommission = true;
    }
    return isValidCommission;
  };
  getCommissionBySalesPerson = (salesPerson) => {
    let commission = null;
    if (this.state.cmData === null) return commission;
    else if (this.state.cmData.creditMemoSalesPersons === null)
      return commission;
    else {
      this.state.cmData.creditMemoSalesPersons.map((line) => {
        if (line.lineNumber === salesPerson) {
          commission = line;
          return commission;
        }
      });
    }
    return commission;
  };
  getCommissionMaxLineNumber() {
    let maxLineNumber = 0;
    let commissions = this.state.cmData.creditMemoSalesPersons;
    if (!isEmptyArray(commissions) && commissions.length > 0)
      commissions.map((line) => {
        if (line.lineNumber > maxLineNumber) {
          maxLineNumber = line.lineNumber;
        }
      });
    return maxLineNumber;
  }
  onAddorUpdateCommissionClick = (e) => {
    if (e.detail == 1) {
      const cmData = { ...this.state.cmData };
      let creditMemoSalesPersons = [];
      if (!isEmptyArray(this.state.cmData.creditMemoSalesPersons))
        creditMemoSalesPersons = [...this.state.cmData.creditMemoSalesPersons];
      const commissionData = { ...this.state.commissionData };
      commissionData.companyCode = this.companyCode;
      let isValid = false;
      isValid = this.validateCommission(commissionData);
      if (isValid) {
        let isLineFound = false;
        var lineNumber = this.getCommissionMaxLineNumber();
        if (!isEmptyArray(creditMemoSalesPersons))
          creditMemoSalesPersons.map((line, i) => {
            if (line.salesPersonCode == commissionData.salesPersonCode) {
              commissionData.lineNumber = line.lineNumber;
              commissionData.isFetched = line.isFetched;
              creditMemoSalesPersons[i] = commissionData;
              isLineFound = true;
            }
          });
        if (!isLineFound) {
          commissionData.lineNumber = ++lineNumber;
          creditMemoSalesPersons.push(commissionData);
        }
        cmData.creditMemoSalesPersons = creditMemoSalesPersons;
        this.setState({ cmData: cmData });
      }
      this.onClearCommissionClick();
    }
  };
  onAddorUpdateCommissionClick_old = () => {
    let commissionData = this.state.commissionData;
    let creditMemoCommisionList = this.state.creditMemoCommisionList;
    commissionData.currencyCode = this.state.cmData.companyCurrencyCode;
    commissionData.lineStatus = "O";
    let isValidCommission = true;
    isValidCommission = this.validateCommission(commissionData);
    if (isValidCommission) {
      let cmData = this.state.cmData;
      if (isEmptyArray(cmData.creditMemoSalesPersons))
        cmData.creditMemoSalesPersons = new Array();
      let existingLine = this.getCommissionBySalesPerson(
        commissionData.lineNumber,
      );
      if (existingLine === null) {
        var lineNumber = this.getCommissionMaxLineNumber();
        commissionData.lineNumber = ++lineNumber;
        cmData.creditMemoSalesPersons.push(commissionData);
      } else {
        const index = cmData.creditMemoSalesPersons.findIndex(
          (ln) => ln.salesPersonCode === existingLine.salesPersonCode,
        );
        if (index != -1) {
          cmData.creditMemoSalesPersons.splice(index, 1);
          cmData.creditMemoSalesPersons.push(commissionData);
        }
      }
      creditMemoCommisionList.push(commissionData);
      this.setState({
        cmData: cmData,
        creditMemoCommisionList: creditMemoCommisionList,
      });
      this.onClearCommissionClick();
    }
  };
  getCommissionLineDetails = (val, rowData) => {
    let cmData = this.state.cmData;
    let commissionData = new CreditMemoSalesPersonBean();
    commissionData = { ...rowData };
    this.setState({ commissionData: commissionData });
  };
  onClearCommissionClick = () => {
    let commissionData = new CreditMemoSalesPersonBean();
    this.setState({ commissionData: commissionData });
  };
  reArrangeCommissionLineNumbers = (LineList) => {
    let maxLineNumber = 0;
    LineList.map((line) => {
      ++maxLineNumber;
      line.lineNumber = maxLineNumber;
    });
  };
  buttonClickCallback = (rowData) => {
    let cmData = this.state.cmData;
    let lineData = cmData.creditMemoSalesPersons;
    // if (rowData.isFetched == false) {
    //   var index = lineData.indexOf(rowData);
    //   if (index > -1) {
    //     lineData.splice(index, 1);
    //   }
    // } else {
    //  this.setState({isDisableFields:true})
    // }

    for (let j = 0; j < lineData.length; j++) {
      if (lineData[j].salesPersonCode === rowData.salesPersonCode) {
        if (lineData[j].isFetched == true) {
          lineData[j].deleted = true; // Change the value at index 2
          lineData[j].isDeleted = true;
          this.setState({ disableCMFormFields: true });
        } else {
          lineData.splice(j, 1); // Change the value at index 2
          //this.state.documents.splice(j, 1);
        }
      }
    }
    this.reArrangeCommissionLineNumbers(lineData);
    this.setState({ cmData: cmData });
  };
  getCommissionView() {
    return (
      <SalesCommissionEntryForm
        {...this.state}
        buttonClickCallback={this.buttonClickCallback}
        onChange={this.onChange}
        onCommissionChange={this.onCommissionChange}
        onAddorUpdateCommissionClick={this.onAddorUpdateCommissionClick}
        onClearCommissionClick={this.onClearCommissionClick}
        isModifyPosible={this.isModifyPosible}
        getCommissionLineDetails={this.getCommissionLineDetails}
        commissionOnChange={this.commissionOnChange}
        commissionEnterKeyEvent={this.commissionEnterKeyEvent}
        displayCommissionAutoCompleteList={
          this.displayCommissionAutoCompleteList
        }
        reasonOnChange={this.reasonOnChange}
        reasonEnterKeyEvent={this.reasonEnterKeyEvent}
        displayReasonAutoCompleteList={this.displayReasonAutoCompleteList}
        handleSortingCreditMemoCommisionListChange={
          this.handleSortingCreditMemoCommisionListChange
        }
        creditMemoCommisionList={this.state.creditMemoCommisionList}
      />
    );
  }
  isModifyPosible = () => {
    let isModify = false;
    let cmData = this.state.cmData;
    if (
      cmData.creditMemoStatus == LogicConstants.CREDIT_MEMO_APPROVE_STATUS ||
      cmData.creditMemoStatus ==
        LogicConstants.CREDIT_MEMO_PARTIALLY_CLOSED_STATUS ||
      cmData.creditMemoStatus == LogicConstants.CREDIT_MEMO_FINISHED_STATUS
    ) {
      isModify = true;
    }
    return isModify;
  };
  adjustCreditMemo = () => {
    this.setState({ isShowAdjustPopup: true });
  };
  adjustOnChange = (e) => {
    let adjustNonMerchandiseData = this.state.adjustNonMerchandiseData;
    adjustNonMerchandiseData[e.target.name] = e.target.value;
    this.setState({ adjustNonMerchandiseData: adjustNonMerchandiseData });
  };
  validateAdjustment = (data) => {
    let isValid = false;
    let errorMessage = "";
    let errList = [];
    if (data == null) {
      let errMsg = "Invalid Adjustment Data ";
      errorMessage = errorMessage + errMsg;
      errList.push(errMsg);
    } else {
      if (isEmptyString(data.code)) {
        let errMsg = "Enter the Reason";
        errorMessage = errorMessage + errMsg;
        errList.push(errMsg);
      }
    }
    if (errList.length > 0) {
      isValid = false;
      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlertLvl3: true,
      });
    } else {
      isValid = true;
      this.setState({ isShowAlertLvl3: false });
    }
    return isValid;
  };
  clearAdjustment = (e) => {
    if (e.detail == 1) {
      let adjustNonMerchandiseData = new CreditMemoNonMerchandiseLineBean();
      this.setState({
        adjustNonMerchandiseData: adjustNonMerchandiseData,
      });
    }
  };
  saveAdjustment = (e) => {
    if (e.detail == 1) {
      let cmData = this.state.cmData;
      let adjustAmount = 0;
      let adjustNonMerchandiseData = this.state.adjustNonMerchandiseData;
      let isValid = false;
      isValid = this.validateAdjustment(adjustNonMerchandiseData);
      if (isValid) {
        let nonMerchandiseLineData = this.state.nonMerchandiseLineData;
        adjustNonMerchandiseData.companyCode = this.companyCode;
        adjustNonMerchandiseData.creditMemoNumber = cmData.code;
        adjustNonMerchandiseData.currencyCode = cmData.currencyCode;
        adjustNonMerchandiseData.lineStatus = nonMerchandiseLineData.lineStatus;
        cmData.nonMerchandiseLines.map((list, i) => {
          var lineNumber = list.lineNumber;
          adjustNonMerchandiseData.lineNumber = ++lineNumber;
        });
        cmData.nonMerchandiseLines.push(adjustNonMerchandiseData);
        adjustAmount =
          cmData.totalCreditAmount - adjustNonMerchandiseData.lineTotalAmount;
        cmData.totalCreditAmount = adjustAmount;
        cmData.nonMerchandiseCreditAmount = adjustAmount;
        let request = new RestCreditMemoBeanRequest();
        request.creditMemoBean = cmData;
        request.reason = adjustNonMerchandiseData.code;
        if (
          cmData.nonMerchandiseLines != null ||
          !isEmptyArray(cmData.nonMerchandiseLines)
        ) {
          if (SecurityAccessManager.CreditMemoMaintenanceAdjust_IsAccessible) {
            CreditMemoService.adjustCreditMemo(
              request,
              this.saveAdjustmentResponse,
              this.saveAdjustmentError,
            );
          } else {
            let errMsg = "Adjustment Access Denied";
            let errList = [];
            errList.push(errMsg);
            this.setState({
              alertMessage: errList,
              isShowAlertLvl3: true,
              alertType: "danger",
            });
          }
        } else {
          let errMsg = "Adjustment Amount Not Entered Correctly";
          let errList = [];
          errList.push(errMsg);
          this.setState({
            alertMessage: errList,
            isShowAlertLvl3: true,
            alertType: "danger",
          });
        }
      }
    }
  };
  saveAdjustmentResponse = (response) => {
    let success = this.handleAdjustmentResponse(response.data);
    if (response.data != null && response.data.creditMemo != null && success) {
      const cmData = response.data.creditMemo;
      this.setState({
        cmData: cmData,
        nonMerchandiseLinesList: cmData.nonMerchandiseLines,
        isShowAdjustPopup: false,
      });
      let adjustNonMerchandiseData = new CreditMemoNonMerchandiseLineBean();
      this.setState({
        adjustNonMerchandiseData: adjustNonMerchandiseData,
      });
      //this.clearAdjustment();
    }
  };
  saveAdjustmentError = (error) => {
    ShowError("error :", error);
  };
  readCustomerReturn = (code) => {
    let request = new RestReadRequest();
    request.companyCode = this.companyCode;
    request.code = code;
    if (SecurityAccessManager.CreditMemoMaintenance_IsAccessible) {
      CustomerReturnService.readCustomerReturn(
        request,
        this.readCustomerReturnResponse,
        this.readCustomerReturnError,
      );
    } else {
      let errMsg = "Access Denied";
      let errList = [];
      errList.push(errMsg);
      this.setState({
        alertMessage: errList,
        isShowAlert: true,
        alertType: "danger",
      });
    }
  };
  readCustomerReturnResponse = (response) => {
    if (response.data != null) {
      let customerReturnData = response.data.customerReturn;
      if (customerReturnData != null) {
        this.setState({
          customerReturnData: customerReturnData,
        });
      }
    }
  };
  readCustomerReturnError = (error) => {
    ShowError("Error :", error);
  };
  loadCustomerReturnData = (e) => {
    if (e.detail == 1) {
      let cmData = this.state.cmData;
      let customerReturnData = this.state.customerReturnData;
      if (!isEmptyString(customerReturnData.code)) {
        let creditData = this.toLoadCustomerReturnData(
          cmData,
          customerReturnData,
        );
        this.setState({
          cmData: creditData,
          isShowCustomerReturnPopup: false,
        });
      } else {
        let errMsg = "Load Customer Return#";
        let errList = [];
        errList.push(errMsg);
        this.setState({
          isShowAlertLvl5: true,
          alertMessage: errList,
          alertType: "danger",
        });
      }
    }
  };
  toLoadCustomerReturnData = (creditMemo, customerReturnBean) => {
    creditMemo.companyCode = customerReturnBean.companyCode;
    creditMemo.code = "NEW";
    creditMemo.creditMemoStatus = LogicConstants.CREDIT_MEMO_OPEN_STATUS;
    creditMemo.creditMemoDate = customerReturnBean.customerReturnDate;
    creditMemo.customerCode = customerReturnBean.customerCode;
    creditMemo.customerName = customerReturnBean.customerName;
    creditMemo.billToCode = customerReturnBean.billToCode;
    creditMemo.provisionalAppliedAmount =
      customerReturnBean.provisionalAppliedAmount;
    creditMemo.appliedAmount = customerReturnBean.appliedAmount;
    creditMemo.merchandiseCreditAmount =
      customerReturnBean.merchandiseReturnAmount;
    creditMemo.totalCreditAmount = customerReturnBean.totalReturnAmount;
    creditMemo.currencyExchangeRateCode =
      customerReturnBean.currencyExchangeRateCode;
    creditMemo.currencyExchangeRate = customerReturnBean.currencyExchangeRate;
    creditMemo.standardTotalCreditAmount =
      customerReturnBean.standardTotalReturnAmount;
    creditMemo.standardTotalAppliedAmount =
      customerReturnBean.standardAppliedAmount;
    creditMemo.creditType = "RETURN";
    creditMemo.invoiceNumber = customerReturnBean.invoiceNumber;
    creditMemo.createdSourceType = customerReturnBean.createdSourceType;
    creditMemo.createdSourceEntityNumber =
      customerReturnBean.createdSourceEntityNumber;
    creditMemo.isUpdateInventory = customerReturnBean.isUpdateInventory;
    creditMemo.customerCurrencyCode = customerReturnBean.customerCurrencyCode;
    creditMemo.companyCurrencyCode = customerReturnBean.companyCurrencyCode;
    creditMemo.comments = customerReturnBean.comments;
    creditMemo.autoGenenaratedAccountReceivableNumber =
      customerReturnBean.autoGeneratedARNumberForInvoiceApply;
    let lines = this.generateLinesFromCustomerReturn(
      customerReturnBean,
      creditMemo,
    );
    creditMemo.merchandiseLines = lines;
    return creditMemo;
  };
  generateLinesFromCustomerReturn = (customerReturnBean, creditMemo) => {
    let mrLines = [];
    for (let lineGroupBean of customerReturnBean.merchandiseLines) {
      let lineGroup = new CreditMemoMerchandiseLineBean();
      lineGroup.companyCode = this.companyCode;
      lineGroup.creditMemoNumber = creditMemo.code;
      lineGroup.lineNumber = lineGroupBean.lineNumber;
      lineGroup.invoiceNumber = lineGroupBean.invoiceNumber;
      lineGroup.lineStatus = lineGroupBean.lineStatus;
      lineGroup.fabricStyleCode = lineGroupBean.fabricStyleCode;
      lineGroup.fabricStyleName = lineGroupBean.fabricStyleName;
      lineGroup.colorCode = lineGroupBean.colorCode;
      lineGroup.skuNumber = lineGroupBean.skuNumber;
      lineGroup.upcCode = lineGroupBean.upcCode;
      lineGroup.uomCode = lineGroupBean.uomCode;
      lineGroup.widthCode = lineGroupBean.widthCode;
      lineGroup.currencyCode = lineGroupBean.currencyCode;
      lineGroup.price = lineGroupBean.price;
      lineGroup.lineTotalReturnQuantity = lineGroupBean.lineTotalReturnQuantity;
      lineGroup.lineTotalAmount = lineGroupBean.lineTotalAmount;
      lineGroup.isUpdateInventory = lineGroupBean.isUpdateInventory;
      lineGroup.rollNumber = lineGroupBean.rollNumber;
      lineGroup.rollSkuNumber = lineGroupBean.rollSkuNumber;
      lineGroup.boxNumber = lineGroupBean.boxNumber;
      lineGroup.batchNumber = lineGroupBean.vendorBatchNumber;
      lineGroup.locationCode = lineGroupBean.locationCode;
      lineGroup.creditSubType = "RETURN";
      lineGroup.remarks = lineGroupBean.remarks;
      mrLines.push(lineGroup);
    }
    return mrLines;
  };
  listFormOnChange = (e) => {
    let criteria = this.state.criteria;
    criteria[e.target.name] = e.target.value;
    this.setState({ criteria: criteria });
  };
  readArPaymentLinesForCM = (cmCode) => {
    let readrestInput = new RestReadRequest();
    readrestInput.companyCode = this.companyCode;
    readrestInput.code = cmCode;
    if (SecurityAccessManager.CreditMemoMaintenance_IsAccessible()) {
      AccountReceivableService.readAccountReceivablePaymentLinesForCreditMemo(
        readrestInput,
        this.readAccountReceivableCreditMemoPageResponse,
        this.readAccountReceivableCreditMemoPageError,
      );
    } else {
      let errMsg = "Access Denied";
      let errList = [];
      errList.push(errMsg);

      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
  };
  readAccountReceivableCreditMemoPageResponse = (response) => {
    if (response.data.accountReceivablePaymentDetailPageList != null) {
      if (
        response.data.accountReceivablePaymentDetailPageList
          .accountReceivablePaymentDetails != null
      ) {
        let creditMemoAppliedLines =
          response.data.accountReceivablePaymentDetailPageList
            .accountReceivablePaymentDetails;
        this.setState({ creditMemoAppliedLines: creditMemoAppliedLines });
      }
    }
  };
  readAccountReceivableCreditMemoPageError = (error) => {
    ShowError("error :" + error);
  };
  showErrorMessage = (response) => {
    if (response.errors != null) {
      let errMsg = "";
      let errList = [];
      response.errors.map(
        (err) => (
          (errMsg = errMsg + err.messageDescription),
          errList.push(err.messageDescription)
        ),
      );
      this.setState({ error_list: errList });
      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
  };
  showInfoMessage = (response) => {
    if (response.infos != null) {
      let infoMsg = "";
      let successList = [];
      response.infos.map(
        (info) => (
          (infoMsg = infoMsg + info.messageDescription),
          successList.push(info.messageDescription)
        ),
      );
      this.setState({
        alertMessage: successList,
        alertType: "success",
        isShowAlert: true,
      });
    }
  };
  viewARModule = (code) => {
    if (code !== "" && code !== undefined) {
      this.setState({
        isShowARModule: true,
        moduleForPopup: (
          <PopupARModule code={code} onModuleExit={this.onPopupModalExit} />
        ),
      });
    }
  };
  viewInvoiceModule = (e, code) => {
    if (e.detail == 1) {
      if (code !== "" && code !== undefined) {
        this.setState({
          isShowInvoiceModule: true,
          moduleForPopup: (
            <PopupInvoiceModule
              invoiceCode={code}
              onModuleExit={this.onPopupModalExit}
            />
          ),
        });
      }
    }
  };
  lnkCustomerModule = (code) => {
    let customerCode = this.state.cmData.customerCode;
    if (customerCode !== "" && customerCode !== undefined) {
      this.setState({
        isShowCustomerModule: true,
        moduleForPopup: (
          <PopupCustomerModule
            customerCode={customerCode}
            onModuleExit={this.onPopupModalExit}
          />
        ),
      });
    }
  };
  openCustomerOnOrderInq = (code) => {
    if (code !== "" && code !== undefined && code !== "NEW") {
      this.setState({
        isShowCustomerOnOrderInq: true,
        moduleForPopup: (
          <PopupCustomerOnOrderInq
            customerCode={code}
            onModuleExit={this.onPopupModalExit}
          />
        ),
      });
    }
  };
  openCustomerTransactionsInq = (code) => {
    if (code !== "" && code !== undefined && code !== "NEW") {
      this.setState({
        isShowCustomerTransactionsInq: true,
        moduleForPopup: (
          <PopupCustomerTransactionsInq
            customerCode={code}
            onModuleExit={this.onPopupModalExit}
          />
        ),
      });
    }
  };
  openCustomerStatisticsInq = (code) => {
    if (code !== "" && code !== undefined && code !== "NEW") {
      this.setState({
        isShowCustomerStatisticsInq: true,
        moduleForPopup: (
          <PopupCustomerStatisticsInq
            customerCode={code}
            onModuleExit={this.onPopupModalExit}
          />
        ),
      });
    }
  };
  openCustomerSalesHistoryInq = (code) => {
    if (code !== "" && code !== undefined && code !== "NEW") {
      this.setState({
        isShowCustomerSalesHistoryInq: true,
        moduleForPopup: (
          <PopupCustomerSalesHistoryInq
            customerCode={code}
            onModuleExit={this.onPopupModalExit}
          />
        ),
      });
    }
  };
  openCustomerMostRecentFabricsInq = (code) => {
    if (code !== "" && code !== undefined && code !== "NEW") {
      this.setState({
        isShowCustomerMostRecentFabricsInq: true,
        moduleForPopup: (
          <PopupCustomerMostRecentFabricsInq
            customerCode={code}
            onModuleExit={this.onPopupModalExit}
          />
        ),
      });
    }
  };
  openCustomerCurrentAgingInq = (code) => {
    if (code !== "" && code !== undefined && code !== "NEW") {
      this.setState({
        isCustomerCurrentAgingInq: true,
        moduleForPopup: (
          <PopupCustomerCurrentAgingInq
            customerCode={code}
            onModuleExit={this.onPopupModalExit}
          />
        ),
      });
    }
  };
  reArrangeMercLineNumbers = (lineList) => {
    let maxLineNumber = 0;
    lineList.map((line) => {
      ++maxLineNumber;
      line.lineNumber = maxLineNumber;
    });
  };
  reArrangeNonMercLineNumbers = (lineList) => {
    let maxLineNumber = 0;
    lineList.map((line) => {
      ++maxLineNumber;
      line.lineNumber = maxLineNumber;
    });
  };
  deleteMerchandiseLine = (rowData) => {
    let fetchInvoiceLines = this.state.fetchInvoiceLines;
    let invoiceLines = this.state.invoiceLines;
    let cmData = this.state.cmData;
    let mercLines = cmData.merchandiseLines;
    if (!rowData.isFetched) {
      fetchInvoiceLines.map((inv) => {
        if (
          rowData.fabricStyleCode == inv.fabricStyleCode &&
          rowData.colorCode == inv.colorCode
        ) {
          invoiceLines.push(inv);
        }
      });
      var index = mercLines.indexOf(rowData);
      if (index > -1) {
        mercLines.splice(index, 1);
      }
      this.reArrangeMercLineNumbers(mercLines);
      let merchandiseLines = mercLines;
      this.setState({
        cmData: cmData,
        invoiceLines: invoiceLines,
        merchandiseLinesList: merchandiseLines,
      });
    }
    this.calculateTotals();
  };
  deleteNonMerchandiseLine = (rowData) => {
    let cmData = this.state.cmData;
    let nonMerchandiseLinesList = this.state.nonMerchandiseLinesList;
    let nonMercLines = cmData.nonMerchandiseLines;
    if (!rowData.isFetched) {
      var index = nonMercLines.indexOf(rowData);
      if (index > -1) {
        nonMercLines.splice(index, 1);
      }
      this.reArrangeNonMercLineNumbers(nonMercLines);
      let nonMercLinesList = nonMercLines;

      this.setState({
        cmData: cmData,
        nonMerchandiseLinesList: nonMercLinesList,
      });
    } else {
      nonMercLines.map((ln) => {
        if (ln.lineNumber === rowData.lineNumber) {
          ln.lineStatus = LogicConstants.CREDIT_MEMO_LINE_CANCEL_STATUS;
        }
      });
      this.setState({ cmData: cmData });
    }
    this.calculateTotals();
  };
  deleteAppliedToInvoiceLine = (e, rowData) => {
    if (e.detail == 1) {
      let arLines = this.state.arLines;
      var index = arLines.indexOf(rowData);
      if (index > -1) {
        arLines.splice(index, 1);
      }
      this.setState({ arLines: arLines });
    }
  };
  clearcustomerReturn = () => {
    this.setState({
      customerReturnData: new CustomerReturnBean(),
      isShowAutoCompleCustomerReturnList: false,
      customerReturnPageListForAutoCompleteList: new Array(),
    });
  };
  ClearRefundDetail = (e) => {
    if (e.detail == 1) {
      let returnPaymentDetail = new CreditMemoReturnPaymentDetailBean();
      let cmData = this.state.cmData;
      returnPaymentDetail.companyCode = this.companyCode;
      returnPaymentDetail.creditMemoNumber = cmData.code;
      returnPaymentDetail.currencyCode = cmData.customerCurrencyCode;
      this.setState({
        returnPaymentDetail: returnPaymentDetail,
      });
    }
  };
  lnkOnHandQuantityDetailsClick = (e) => {
    if (e.detail == 1) {
      if (this.state.isopenQtyPopup) {
        this.setState({
          isShowOnHandQtyPopup: true,
        });
      }
    }
  };
  creditTypeOnChange = (e) => {
    let creditType = e.target.value;
    this.state.isShowAutoCompleteCreditTypeList = true;
    let tempData = this.state.cmData;
    let showAutoCompleteList = this.state.isShowAutoCompleteCreditTypeList;
    if (isEmpty(creditType)) {
      this.state.isShowAutoCompleteCreditTypeList = false;
      let showAutoCompleteList = this.state.isShowAutoCompleteCreditTypeList;
      let tempData = this.state.cmData;
      tempData.creditType = "";
      let suggestion = [];
      this.setState({
        isShowAutoCompleteList: showAutoCompleteList,
        cmData: tempData,
        creditTypePageListForAutoCompleteList: suggestion,
      });
    } else if (
      e.target.name == "creditType" &&
      showAutoCompleteList === true &&
      creditType !== ""
    ) {
      this.readCreditTypeBySearchString(e.target.value);
      this.readCreditType(e.target.value);
    }
    tempData[e.target.name] = e.target.value.toUpperCase();
    this.setState({ cmData: tempData });
  };
  creditTypeEnterKeyEvent = (e) => {
    this.readCreditType(e.target.value);
    this.state.isShowAutoCompleteCreditTypeList = false;
    let showAutoCompleteList = this.state.isShowAutoCompleteCreditTypeList;
    this.setState({
      creditTypePageListForAutoCompleteList: new Array(),
      isShowAutoCompleteList: showAutoCompleteList,
    });
  };
  displayCreditTypeAutoCompleteList = (isShowAutoCompleteList) => {
    this.setState({
      isShowAutoCompleteCreditTypeList: isShowAutoCompleteList,
    });
  };
  readCreditTypeBySearchString = (searchString) => {
    let creditTypeData = this.state.creditMemoTypes;
    let simpleAutoCompleteList = new Array();
    if (creditTypeData.length > 0 && creditTypeData != null) {
      creditTypeData.map((obj) => {
        let creditTypeBean = {
          code: obj.code,
          description: obj.description,
        };
        simpleAutoCompleteList.push(creditTypeBean);
      });
    }
    let userInput = searchString;
    let filteredSuggestions = new Array();
    filteredSuggestions = simpleAutoCompleteList.filter(
      (list) => list.code.toLowerCase().indexOf(userInput.toLowerCase()) > -1,
    );
    this.setState({
      creditTypePageListForAutoCompleteList: filteredSuggestions,
    });
  };
  readCreditType = (creditType) => {
    let tempData = this.state.cmData;
    let creditTypeBean = null;
    let creditTypeData = null;
    this.state.creditMemoTypes.map((ln) => {
      if (ln.code === creditType) {
        creditTypeBean = ln;
        creditTypeData = new BaseBean();
        creditTypeData.code = ln.code;
        creditTypeData.description = ln.description;
      }
    });
    if (!isEmpty(creditTypeBean)) {
      tempData.creditType = creditTypeBean.code;
      this.state.isShowAutoCompleteCreditTypeList = false;
      let showAutoCompleteList = this.state.isShowAutoCompleteCreditTypeList;
      this.setState({
        cmData: tempData,
        isShowAutoCompleteCreditTypeList: showAutoCompleteList,
      });
    }
  };
  creditSubTypeOnChange = (e) => {
    let creditSubType = e.target.value;
    this.state.isShowAutoCompleteCreditSubTypeList = true;
    let tempData = this.state.merchandiseLineData;
    let showAutoCompleteList = this.state.isShowAutoCompleteCreditSubTypeList;
    if (isEmpty(creditSubType)) {
      this.state.isShowAutoCompleteCreditSubTypeList = false;
      let showAutoCompleteList = this.state.isShowAutoCompleteCreditSubTypeList;
      let tempData = this.state.merchandiseLineData;
      tempData.creditSubType = "";
      let suggestion = [];
      this.setState({
        isShowAutoCompleteList: showAutoCompleteList,
        merchandiseLineData: tempData,
        creditSubTypePageListForAutoCompleteList: suggestion,
      });
    } else if (
      e.target.name == "creditSubType" &&
      showAutoCompleteList === true &&
      creditSubType !== ""
    ) {
      this.readCreditSubTypeBySearchString(e.target.value);
      this.readCreditSubType(e.target.value);
    }
    tempData[e.target.name] = e.target.value.toUpperCase();
    this.setState({ merchandiseLineData: tempData });
  };
  creditSubTypeEnterKeyEvent = (e) => {
    this.readCreditSubType(e.target.value);
    this.state.isShowAutoCompleteCreditSubTypeList = false;
    let showAutoCompleteList = this.state.isShowAutoCompleteCreditSubTypeList;
    this.setState({
      creditSubTypePageListForAutoCompleteList: new Array(),
      isShowAutoCompleteList: showAutoCompleteList,
    });
  };
  displayCreditSubTypeAutoCompleteList = (isShowAutoCompleteList) => {
    this.setState({
      isShowAutoCompleteCreditSubTypeList: isShowAutoCompleteList,
    });
  };
  readCreditSubTypeBySearchString = (searchString) => {
    let creditSubTypeData = this.state.creditSubTypes;
    let simpleAutoCompleteList = new Array();
    if (creditSubTypeData.length > 0 && creditSubTypeData != null) {
      creditSubTypeData.map((obj) => {
        let creditSubTypeBean = {
          code: obj.code,
          description: obj.description,
        };
        simpleAutoCompleteList.push(creditSubTypeBean);
      });
    }
    let userInput = searchString;
    let filteredSuggestions = new Array();
    filteredSuggestions = simpleAutoCompleteList.filter(
      (list) => list.code.toLowerCase().indexOf(userInput.toLowerCase()) > -1,
    );
    this.setState({
      creditSubTypePageListForAutoCompleteList: filteredSuggestions,
    });
  };
  readCreditSubType = (creditSubType) => {
    let tempData = this.state.merchandiseLineData;
    let creditSubTypeBean = null;
    let creditSubTypeData = null;
    this.state.creditSubTypes.map((ln) => {
      if (ln.code === creditSubType) {
        creditSubTypeBean = ln;
        creditSubTypeData = new BaseBean();
        creditSubTypeData.code = ln.code;
        creditSubTypeData.description = ln.description;
      }
    });
    if (!isEmpty(creditSubTypeBean)) {
      tempData.creditSubType = creditSubTypeBean.code;
      this.state.isShowAutoCompleteCreditSubTypeList = false;
      let showAutoCompleteList = this.state.isShowAutoCompleteCreditSubTypeList;
      this.setState({
        merchandiseLineData: tempData,
        isShowAutoCompleteCreditSubTypeList: showAutoCompleteList,
      });
    }
  };
  locationOnChange = (e) => {
    let locationCode = e.target.value;
    this.state.isShowAutoCompleteLocationList = true;
    let tempData = this.state.merchandiseLineData;
    let showAutoCompleteList = this.state.isShowAutoCompleteLocationList;
    if (isEmpty(locationCode)) {
      this.state.isShowAutoCompleteLocationList = false;
      let showAutoCompleteList = this.state.isShowAutoCompleteLocationList;
      let tempData = this.state.merchandiseLineData;
      tempData.locationCode = "";
      let suggestion = [];
      this.setState({
        isShowAutoCompleteList: showAutoCompleteList,
        merchandiseLineData: tempData,
        locationPageListForAutoCompleteList: suggestion,
      });
    } else if (
      e.target.name == "locationCode" &&
      showAutoCompleteList === true &&
      locationCode !== ""
    ) {
      this.readLocationBySearchString(e.target.value);
      this.readLocation(e.target.value);
    }
    tempData[e.target.name] = e.target.value.toUpperCase();
    this.setState({ merchandiseLineData: tempData });
  };
  locationEnterKeyEvent = (e) => {
    this.readLocation(e.target.value);
    this.state.isShowAutoCompleteLocationList = false;
    let showAutoCompleteList = this.state.isShowAutoCompleteLocationList;
    this.setState({
      locationPageListForAutoCompleteList: new Array(),
      isShowAutoCompleteList: showAutoCompleteList,
    });
  };
  displayLocationAutoCompleteList = (isShowAutoCompleteList) => {
    this.setState({
      isShowAutoCompleteLocationList: isShowAutoCompleteList,
    });
  };
  readLocationBySearchString = (searchString) => {
    let locationData = this.state.warehouses;
    let simpleAutoCompleteList = new Array();
    if (locationData.length > 0 && locationData != null) {
      locationData.map((obj) => {
        let locationBean = {
          code: obj.code,
          description: obj.description,
        };
        simpleAutoCompleteList.push(locationBean);
      });
    }
    let userInput = searchString;
    let filteredSuggestions = new Array();
    filteredSuggestions = simpleAutoCompleteList.filter(
      (list) => list.code.toLowerCase().indexOf(userInput.toLowerCase()) > -1,
    );
    this.setState({
      locationPageListForAutoCompleteList: filteredSuggestions,
    });
  };
  readLocation = (locationCode) => {
    let tempData = this.state.merchandiseLineData;
    let locationBean = null;
    let locationData = null;
    this.state.warehouses.map((ln) => {
      if (ln.code === locationCode) {
        locationBean = ln;
        locationData = new BaseBean();
        locationData.code = ln.code;
        locationData.description = ln.description;
      }
    });
    if (!isEmpty(locationBean)) {
      tempData.locationCode = locationBean.code;
      this.state.isShowAutoCompleteLocationList = false;
      let showAutoCompleteList = this.state.isShowAutoCompleteLocationList;
      this.setState({
        merchandiseLineData: tempData,
        isShowAutoCompleteLocationList: showAutoCompleteList,
      });
    }
  };
  creditsubTypeOnChange = (e) => {
    let creditSubType = e.target.value;
    this.state.isShowAutoCompleteCreditsubTypeList = true;
    let tempData = this.state.nonMerchandiseLineData;
    let showAutoCompleteList = this.state.isShowAutoCompleteCreditsubTypeList;
    if (isEmpty(creditSubType)) {
      this.state.isShowAutoCompleteCreditsubTypeList = false;
      let showAutoCompleteList = this.state.isShowAutoCompleteCreditsubTypeList;
      let tempData = this.state.nonMerchandiseLineData;
      tempData.creditSubType = "";
      let suggestion = [];
      this.setState({
        isShowAutoCompleteList: showAutoCompleteList,
        nonMerchandiseLineData: tempData,
        creditsubTypePageListForAutoCompleteList: suggestion,
      });
    } else if (
      e.target.name == "creditSubType" &&
      showAutoCompleteList === true &&
      creditSubType !== ""
    ) {
      this.readCreditsubTypeBySearchString(e.target.value);
      this.readCreditsubType(e.target.value);
    }
    tempData[e.target.name] = e.target.value.toUpperCase();
    this.setState({ nonMerchandiseLineData: tempData });
  };
  creditsubTypeEnterKeyEvent = (e) => {
    this.readCreditsubType(e.target.value);
    this.state.isShowAutoCompleteCreditsubTypeList = false;
    let showAutoCompleteList = this.state.isShowAutoCompleteCreditsubTypeList;
    this.setState({
      creditsubTypePageListForAutoCompleteList: new Array(),
      isShowAutoCompleteList: showAutoCompleteList,
    });
  };
  displayCreditsubTypeAutoCompleteList = (isShowAutoCompleteList) => {
    this.setState({
      isShowAutoCompleteCreditsubTypeList: isShowAutoCompleteList,
    });
  };
  readCreditsubTypeBySearchString = (searchString) => {
    let creditsubTypeData = this.state.creditSubTypes;
    let simpleAutoCompleteList = new Array();
    if (creditsubTypeData.length > 0 && creditsubTypeData != null) {
      creditsubTypeData.map((obj) => {
        let creditsubTypeBean = {
          code: obj.code,
          description: obj.description,
        };
        simpleAutoCompleteList.push(creditsubTypeBean);
      });
    }
    let userInput = searchString;
    let filteredSuggestions = new Array();
    filteredSuggestions = simpleAutoCompleteList.filter(
      (list) => list.code.toLowerCase().indexOf(userInput.toLowerCase()) > -1,
    );
    this.setState({
      creditsubTypePageListForAutoCompleteList: filteredSuggestions,
    });
  };
  readCreditsubType = (creditSubType) => {
    let tempData = this.state.nonMerchandiseLineData;
    let creditsubTypeBean = null;
    let creditsubTypeData = null;
    this.state.creditSubTypes.map((ln) => {
      if (ln.code === creditSubType) {
        creditsubTypeBean = ln;
        creditsubTypeData = new BaseBean();
        creditsubTypeData.code = ln.code;
        creditsubTypeData.description = ln.description;
      }
    });
    if (!isEmpty(creditsubTypeBean)) {
      tempData.creditSubType = creditsubTypeBean.code;
      this.state.isShowAutoCompleteCreditsubTypeList = false;
      let showAutoCompleteList = this.state.isShowAutoCompleteCreditsubTypeList;
      this.setState({
        nonMerchandiseLineData: tempData,
        isShowAutoCompleteCreditsubTypeList: showAutoCompleteList,
      });
    }
  };
  creditsubtypeOnChange = (e) => {
    let creditSubType = e.target.value;
    this.state.isShowAutoCompleteCreditsubtypeList = true;
    let tempData = this.state.adjustNonMerchandiseData;
    let showAutoCompleteList = this.state.isShowAutoCompleteCreditsubtypeList;
    if (isEmpty(creditSubType)) {
      this.state.isShowAutoCompleteCreditsubtypeList = false;
      let showAutoCompleteList = this.state.isShowAutoCompleteCreditsubtypeList;
      let tempData = this.state.adjustNonMerchandiseData;
      tempData.creditSubType = "";
      let suggestion = [];
      this.setState({
        isShowAutoCompleteList: showAutoCompleteList,
        adjustNonMerchandiseData: tempData,
        creditsubtypePageListForAutoCompleteList: suggestion,
      });
    } else if (
      e.target.name == "creditSubType" &&
      showAutoCompleteList === true &&
      creditSubType !== ""
    ) {
      this.readCreditsubtypeBySearchString(e.target.value);
      this.readCreditsubtype(e.target.value);
    }
    tempData[e.target.name] = e.target.value.toUpperCase();
    this.setState({ adjustNonMerchandiseData: tempData });
  };
  creditsubtypeEnterKeyEvent = (e) => {
    this.readCreditsubtype(e.target.value);
    this.state.isShowAutoCompleteCreditsubtypeList = false;
    let showAutoCompleteList = this.state.isShowAutoCompleteCreditsubtypeList;
    this.setState({
      creditsubtypePageListForAutoCompleteList: new Array(),
      isShowAutoCompleteList: showAutoCompleteList,
    });
  };
  displayCreditsubtypeAutoCompleteList = (isShowAutoCompleteList) => {
    this.setState({
      isShowAutoCompleteCreditsubtypeList: isShowAutoCompleteList,
    });
  };
  readCreditsubtypeBySearchString = (searchString) => {
    let creditsubTypeData = this.state.creditSubTypes;
    let simpleAutoCompleteList = new Array();
    if (creditsubTypeData.length > 0 && creditsubTypeData != null) {
      creditsubTypeData.map((obj) => {
        let creditsubTypeBean = {
          code: obj.code,
          description: obj.description,
        };
        simpleAutoCompleteList.push(creditsubTypeBean);
      });
    }
    let userInput = searchString;
    let filteredSuggestions = new Array();
    filteredSuggestions = simpleAutoCompleteList.filter(
      (list) => list.code.toLowerCase().indexOf(userInput.toLowerCase()) > -1,
    );
    this.setState({
      creditsubtypePageListForAutoCompleteList: filteredSuggestions,
    });
  };
  readCreditsubTypeBySearchString = (searchString) => {
    let creditsubTypeData = this.state.creditSubTypes;
    let simpleAutoCompleteList = new Array();
    if (creditsubTypeData.length > 0 && creditsubTypeData != null) {
      creditsubTypeData.map((obj) => {
        let creditsubTypeBean = {
          code: obj.code,
          description: obj.description,
        };
        simpleAutoCompleteList.push(creditsubTypeBean);
      });
    }
    let userInput = searchString;
    let filteredSuggestions = new Array();
    filteredSuggestions = simpleAutoCompleteList.filter(
      (list) => list.code.toLowerCase().indexOf(userInput.toLowerCase()) > -1,
    );
    this.setState({
      creditsubTypePageListForAutoCompleteList: filteredSuggestions,
    });
  };
  readCreditsubtype = (creditSubType) => {
    let tempData = this.state.adjustNonMerchandiseData;
    let creditsubTypeBean = null;
    let creditsubTypeData = null;
    this.state.creditSubTypes.map((ln) => {
      if (ln.code === creditSubType) {
        creditsubTypeBean = ln;
        creditsubTypeData = new BaseBean();
        creditsubTypeData.code = ln.code;
        creditsubTypeData.description = ln.description;
      }
    });
    if (!isEmpty(creditsubTypeBean)) {
      tempData.creditSubType = creditsubTypeBean.code;
      this.state.isShowAutoCompleteCreditsubtypeList = false;
      let showAutoCompleteList = this.state.isShowAutoCompleteCreditsubtypeList;
      this.setState({
        adjustNonMerchandiseData: tempData,
        isShowAutoCompleteCreditsubtypeList: showAutoCompleteList,
      });
    }
  };
  applyInvoiceOnChange = (e) => {
    let invoiceNumber = e.target.value;
    this.state.isShowAutoCompleteapplyInvoiceList = true;
    let tempData = this.state.currentARLine;
    let showAutoCompleteList = this.state.isShowAutoCompleteapplyInvoiceList;
    if (isEmpty(invoiceNumber)) {
      this.state.isShowAutoCompleteapplyInvoiceList = false;
      let showAutoCompleteList = this.state.isShowAutoCompleteapplyInvoiceList;
      let tempData = this.state.currentARLine;
      tempData.invoiceNumber = "";
      let suggestion = [];
      this.setState({
        isShowAutoCompleteList: showAutoCompleteList,
        currentARLine: tempData,
        applyInvoicePageListForAutoCompleteList: suggestion,
      });
    } else if (
      e.target.name == "invoiceNumber" &&
      showAutoCompleteList === true &&
      invoiceNumber !== ""
    ) {
      // this.readInvoiceandSetARLine(e.target.value);
    }
    tempData[e.target.name] = e.target.value.toUpperCase();
    this.setState({ currentARLine: tempData });
  };
  applyInvoiceEnterKeyEvent = (e) => {
    this.readInvoiceandSetARLine(e.target.value);
    this.state.isShowAutoCompleteapplyInvoiceList = false;
    let showAutoCompleteList = this.state.isShowAutoCompleteapplyInvoiceList;
    this.setState({
      applyInvoicePageListForAutoCompleteList: new Array(),
      isShowAutoCompleteList: showAutoCompleteList,
    });
  };
  displayapplyInvoiceAutoCompleteList = (isShowAutoCompleteList) => {
    this.setState({
      isShowAutoCompleteapplyInvoiceList: isShowAutoCompleteList,
    });
  };
  readapplyInvoiceBySearchString = (searchString) => {
    let inv_criteria = new InvoiceSearchCriteria();
    inv_criteria.companyCode = this.companyCode;
    inv_criteria.customerCode = this.state.cmData.customerCode;
    inv_criteria.invoiceNumberStartsWith = searchString;
    inv_criteria.invoiceNumberContains = searchString;
    let inv_pageList = new RestPageListBean();
    inv_pageList.pageSize = 100;
    let inv_requestInput = new RestInvoiceListRequest();
    inv_requestInput.pageInput = inv_pageList;
    inv_requestInput.searchCriteria = inv_criteria;
    if (SecurityAccessManager.CreditMemoMaintenance_IsAccessible()) {
      InvoiceService.getInvoicePageList(
        inv_requestInput,
        this.loadApplyInvoicesResponse,
        this.loadApplyInvoiceError,
      );
    } else {
      let errMsg = "Access Denied";
      let errList = [];
      errList.push(errMsg);

      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
  };
  loadApplyInvoicesResponse = (response) => {
    let InvoiceData = response.data.invoicePageList.invoices;
    let simpleAutoCompleteList = new Array();
    if (InvoiceData.length > 0 && InvoiceData != null) {
      InvoiceData.map((obj) => {
        let simpleItemBean = {
          code: obj.code,
          description: "",
        };
        simpleAutoCompleteList.push(simpleItemBean);
      });
    }
    this.setState({
      applyInvoicePageListForAutoCompleteList: simpleAutoCompleteList,
    });
  };
  loadApplyInvoiceError = (error) => {};
  commissionOnChange = (e) => {
    let salesPersonCode = e.target.value;
    this.state.isShowAutoCompleCommissionList = true;
    let tempData = this.state.commissionData;
    let showAutoCompleteList = this.state.isShowAutoCompleCommissionList;
    if (isEmpty(salesPersonCode)) {
      this.state.isShowAutoCompleCommissionList = false;
      let showAutoCompleteList = this.state.isShowAutoCompleCommissionList;
      let tempData = this.state.commissionData;
      tempData.salesPersonCode = "";
      let suggestion = [];
      this.setState({
        isShowAutoCompleteList: showAutoCompleteList,
        commissionData: tempData,
        commissionPageListForAutoCompleteList: suggestion,
      });
    } else if (
      e.target.name == "salesPersonCode" &&
      showAutoCompleteList === true &&
      salesPersonCode !== ""
    ) {
      this.readCommissionBySearchString(e.target.value);
      this.readCommission(e.target.value);
    }
    tempData[e.target.name] = e.target.value.toUpperCase();
    this.setState({ commissionData: tempData });
  };
  commissionEnterKeyEvent = (e) => {
    this.readCommission(e.target.value);
    this.state.isShowAutoCompleCommissionList = false;
    let showAutoCompleteList = this.state.isShowAutoCompleCommissionList;
    this.setState({
      commissionPageListForAutoCompleteList: new Array(),
      isShowAutoCompleteList: showAutoCompleteList,
    });
  };
  displayCommissionAutoCompleteList = (isShowAutoCompleteList) => {
    this.setState({
      isShowAutoCompleCommissionList: isShowAutoCompleteList,
    });
  };
  readCommissionBySearchString = (searchString) => {
    let commissionData = this.state.salesPersonList;
    let simpleAutoCompleteList = new Array();
    if (commissionData.length > 0 && commissionData != null) {
      commissionData.map((obj) => {
        let commissionBean = {
          code: obj.code,
          description: obj.description,
        };
        simpleAutoCompleteList.push(commissionBean);
      });
    }
    let userInput = searchString;
    let filteredSuggestions = new Array();
    filteredSuggestions = simpleAutoCompleteList.filter(
      (list) => list.code.toLowerCase().indexOf(userInput.toLowerCase()) > -1,
    );
    this.setState({
      commissionPageListForAutoCompleteList: filteredSuggestions,
    });
  };
  readCommission = (salesPersonCode) => {
    let tempData = this.state.commissionData;
    let commissionBean = null;
    let commissionData = null;
    this.state.salesPersonList.map((ln) => {
      if (ln.code === salesPersonCode) {
        commissionBean = ln;
        commissionData = new BaseBean();
        commissionData.code = ln.code;
        commissionData.description = ln.description;
      }
    });
    if (!isEmpty(commissionBean)) {
      tempData.salesPersonCode = commissionBean.code;
      this.state.isShowAutoCompleCommissionList = false;
      let showAutoCompleteList = this.state.isShowAutoCompleCommissionList;
      this.setState({
        commissionData: tempData,
        isShowAutoCompleCommissionList: showAutoCompleteList,
      });
    }
  };
  reasonOnChange = (e) => {
    let reasonCode = e.target.value;
    this.state.isShowAutoCompleReasonList = true;
    let tempData = this.state.commissionData;
    let showAutoCompleteList = this.state.isShowAutoCompleReasonList;
    if (isEmpty(reasonCode)) {
      this.state.isShowAutoCompleReasonList = false;
      let showAutoCompleteList = this.state.isShowAutoCompleReasonList;
      let tempData = this.state.commissionData;
      tempData.reasonCode = "";
      let suggestion = [];
      this.setState({
        isShowAutoCompleteList: showAutoCompleteList,
        commissionData: tempData,
        reasonPageListForAutoCompleteList: suggestion,
      });
    } else if (
      e.target.name == "reasonCode" &&
      showAutoCompleteList === true &&
      reasonCode !== ""
    ) {
      this.readReasonBySearchString(e.target.value);
      this.readReason(e.target.value);
    }
    tempData[e.target.name] = e.target.value.toUpperCase();
    this.setState({ commissionData: tempData });
  };
  reasonEnterKeyEvent = (e) => {
    this.readReason(e.target.value);
    this.state.isShowAutoCompleReasonList = false;
    let showAutoCompleteList = this.state.isShowAutoCompleReasonList;
    this.setState({
      reasonPageListForAutoCompleteList: new Array(),
      isShowAutoCompleteList: showAutoCompleteList,
    });
  };
  displayReasonAutoCompleteList = (isShowAutoCompleteList) => {
    this.setState({
      isShowAutoCompleReasonList: isShowAutoCompleteList,
    });
  };
  readReasonBySearchString = (searchString) => {
    let commissionData = this.state.creditReasons;
    let simpleAutoCompleteList = new Array();
    if (commissionData.length > 0 && commissionData != null) {
      commissionData.map((obj) => {
        let commissionBean = {
          code: obj.code,
          description: obj.description,
        };
        simpleAutoCompleteList.push(commissionBean);
      });
    }
    let userInput = searchString;
    let filteredSuggestions = new Array();
    filteredSuggestions = simpleAutoCompleteList.filter(
      (list) => list.code.toLowerCase().indexOf(userInput.toLowerCase()) > -1,
    );
    this.setState({
      reasonPageListForAutoCompleteList: filteredSuggestions,
    });
  };
  readReason = (reasonCode) => {
    let tempData = this.state.commissionData;
    let commissionBean = null;
    let commissionData = null;
    this.state.creditReasons.map((ln) => {
      if (ln.code === reasonCode) {
        commissionBean = ln;
        commissionData = new BaseBean();
        commissionData.code = ln.code;
        commissionData.description = ln.description;
      }
    });
    if (!isEmpty(commissionBean)) {
      tempData.reasonCode = commissionBean.code;
      this.state.isShowAutoCompleReasonList = false;
      let showAutoCompleteList = this.state.isShowAutoCompleReasonList;
      this.setState({
        commissionData: tempData,
        isShowAutoCompleReasonList: showAutoCompleteList,
      });
    }
  };
  customerReturnOnChange = (e) => {
    let code = e.target.value;
    this.state.isShowAutoCompleCustomerReturnList = true;
    let tempData = this.state.customerReturnData;
    let showAutoCompleteList = this.state.isShowAutoCompleCustomerReturnList;
    if (isEmpty(code)) {
      this.state.isShowAutoCompleCustomerReturnList = false;
      let showAutoCompleteList = this.state.isShowAutoCompleCustomerReturnList;
      let tempData = this.state.customerReturnData;
      tempData.code = "";
      let suggestion = [];
      this.setState({
        isShowAutoCompleteList: showAutoCompleteList,
        customerReturnData: tempData,
        customerReturnPageListForAutoCompleteList: suggestion,
      });
    } else if (
      e.target.name == "code" &&
      showAutoCompleteList === true &&
      code !== ""
    ) {
      this.readCustomerReturnBySearchString(e.target.value);
      this.readCustomerReturn(e.target.value);
    }
    tempData[e.target.name] = e.target.value.toUpperCase();
    this.setState({ customerReturnData: tempData });
  };
  customerReturnEnterKeyEvent = (e) => {
    this.readCustomerReturn(e.target.value);
    this.state.isShowAutoCompleCustomerReturnList = false;
    let showAutoCompleteList = this.state.isShowAutoCompleCustomerReturnList;
    this.setState({
      customerReturnPageListForAutoCompleteList: new Array(),
      isShowAutoCompleteList: showAutoCompleteList,
    });
  };
  displayCustomerReturnAutoCompleteList = (isShowAutoCompleteList) => {
    this.setState({
      isShowAutoCompleCustomerReturnList: isShowAutoCompleteList,
    });
  };
  readCustomerReturnBySearchString = (searchString) => {
    let cust_criteria = new CustomerReturnSearchCriteria();
    cust_criteria.companyCode = this.companyCode;
    cust_criteria.customerReturnNumberContains = searchString;
    cust_criteria.customerReturnNumberStartsWith = searchString;
    let cust_pageList = new PageListBean();
    cust_pageList.pageSize = 50;
    let cust_requestInput = new RestCustomerReturnListRequest();
    cust_requestInput.pageInput = cust_pageList;
    cust_requestInput.searchCriteria = cust_criteria;
    if (SecurityAccessManager.CreditMemoMaintenance_IsAccessible()) {
      CustomerReturnService.getCustomerReturnPageList(
        cust_requestInput,
        this.loadCustomerReturnResponse,
        this.loadCustomerError,
      );
    } else {
      let errMsg = "Access Denied";
      let errList = [];
      errList.push(errMsg);

      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
  };
  loadCustomerReturnResponse = (response) => {
    let custReturnData = response.data.customerReturnPageList.customerReturns;
    let simpleAutoCompleteList = new Array();
    if (custReturnData.length > 0 && custReturnData != null) {
      custReturnData.map((obj) => {
        let simpleItemBean = {
          code: obj.code,
          description: "",
        };
        simpleAutoCompleteList.push(simpleItemBean);
      });
    }
    this.setState({
      customerReturnPageListForAutoCompleteList: simpleAutoCompleteList,
    });
  };
  loadCustomerError = (error) => {};
  onBillToChange = (e) => {
    let billToCode = e.target.value;
    this.state.isShowAutoCompleteBillToList = true;
    let tempData = this.state.cmData;
    let showAutoCompleteList = this.state.isShowAutoCompleteBillToList;
    if (isEmpty(billToCode)) {
      let tempData = this.state.cmData;
      tempData.billToCode = "";
      let suggestion = [];
      this.setState({
        isShowAutoCompleteBillToList: false,
        cmData: tempData,
        billToPageListForAutoCompleteList: suggestion,
      });
    } else if (
      e.target.name == "billToCode" &&
      showAutoCompleteList === true &&
      billToCode !== ""
    ) {
      this.readCustomerBillToBySearchString(e.target.value);
    }
    tempData[e.target.name] = e.target.value.toUpperCase();
    this.setState({ cmData: tempData });
  };
  billToToEnterKeyEvent = (e) => {
    let tempData = this.state.cmData;
    this.state.isShowAutoCompleteBillToList = true;
    let showAutoCompleteList = this.state.isShowAutoCompleteBillToList;
    let billToCode = e.target.value;
    tempData["billToCode"] = e.target.value;
    let billToCodeList = this.state.billTos;
    let billToCodeBean = null;
    billToCodeList.map((billToCode) => {
      if (billToCodeList.code == e.target.value) {
        billToCodeBean = billToCode;
      }
    });
    if (!isEmpty(billToCodeBean)) {
      let tempData = this.state.cmData;
      tempData.billToCode = billToCodeBean.code;
      this.setState({
        cmData: tempData,
        billToPageListForAutoCompleteList: new Array(),
        isShowAutoCompleteBillToList: false,
      });
    }
  };

  readCustomerBillToBySearchString(searchString) {
    let customerData = this.state.billTos;
    let simpleAutoCompleteList = new Array();
    if (customerData.length > 0 && customerData != null) {
      customerData.map((customer) => {
        let simpleItemBean = {
          code: customer.code,
          description: customer.description,
        };
        simpleAutoCompleteList.push(simpleItemBean);
      });
    }
    let userInput = searchString;
    let filteredSuggestions = new Array();
    filteredSuggestions = simpleAutoCompleteList.filter(
      (list) => list.code.toLowerCase().indexOf(userInput.toLowerCase()) > -1,
    );
    this.setState({
      billToPageListForAutoCompleteList: filteredSuggestions,
    });
  }
  loadCustomerBillToListError = (error) => {
    ShowError("Error : " + error);
  };
  displayAutoCompleteBillToList = (showAutoCompleteList) => {
    this.setState({ isShowAutoCompleteBillToList: showAutoCompleteList });
  };
  setUpdateInventory = (e) => {
    let cmData = this.state.cmData;
    let merchandiseLinesList = this.state.merchandiseLinesList;
    cmData[e.target.name] = e.target.value;
    cmData.merchandiseLines.map((ln) => {
      ln.isUpdateInventory = e.target.value;
    });
    merchandiseLinesList.map((ln) => {
      ln.isUpdateInventory = e.target.value;
    }); 
    this.setState({
      cmData: cmData,
      merchandiseLinesList: merchandiseLinesList,
    });
  };
  onPopupModalExit = () => {
    this.closeModalCallBack(false);
  };
  closeModalCallBack = (isOpen) => {
    this.setState({
      isShowInvoiceModule: isOpen,
      isShowARModule: isOpen,
      isShowCustomerModule: isOpen,
      isShowCustomerOnOrderInq: isOpen,
      isShowCustomerTransactionsInq: isOpen,
      isShowCustomerStatisticsInq: isOpen,
      isShowCustomerSalesHistoryInq: isOpen,
      isShowCustomerMostRecentFabricsInq: isOpen,
      isCustomerCurrentAgingInq: isOpen,
      moduleForPopup: [],
    });
  };
  hideAlertCallBackLvl3 = (msgType, isDisplayed) => {
    this.setState({ isShowAlertLvl3: isDisplayed });
  };
  hideAlertCallBackLvl2 = (msgType, isDisplayed) => {
    this.setState({ isShowAlertLvl2: isDisplayed });
  };
  hideAlertCallBackLvl5 = (msgType, isDisplayed) => {
    this.setState({ isShowAlertLvl5: isDisplayed });
  };
  handleSortingChange = (accessor) => {
    let sortField = accessor;
    let order = this.state.order;
    let sortOrder = accessor === sortField && order === "asc" ? "desc" : "asc";
    this.setState({
      order: sortOrder,
      sortField: sortField,
    });
    this.handleSorting(sortField, sortOrder);
  };
  handleSorting = (sortField, sortOrder) => {
    let creditMemo_list = this.state.creditMemo_list;
    if (sortField && !isEmptyArray(creditMemo_list)) {
      const sorted = [...creditMemo_list].sort((a, b) => {
        if (a[sortField] === null) return 1;
        if (b[sortField] === null) return -1;
        if (a[sortField] === null && b[sortField] === null) return 0;
        return (
          a[sortField].toString().localeCompare(b[sortField].toString(), "en", {
            numeric: true,
          }) * (sortOrder === "asc" ? 1 : -1)
        );
      });
      this.setState({ creditMemo_list: sorted });
    }
  };

  handleSortingRollLineChange = (e, accessor) => {
    if (e.detail === 1) {
      let sortField = accessor;
      let order = this.state.order;
      let sortOrder =
        accessor === sortField && order === "asc" ? "desc" : "asc";
      this.setState({
        order: sortOrder,
        sortField: sortField,
      });
      this.handleSortingRollLine(sortField, sortOrder);
    }
  };
  handleSortingRollLine = (sortField, sortOrder) => {
    let list = this.state.rollLines;
    if (sortField && !isEmptyArray(list)) {
      const sorted = [...list].sort((a, b) => {
        if (a[sortField] === null) return 1;
        if (b[sortField] === null) return -1;
        if (a[sortField] === null && b[sortField] === null) return 0;
        return (
          a[sortField].toString().localeCompare(b[sortField].toString(), "en", {
            numeric: true,
          }) * (sortOrder === "asc" ? 1 : -1)
        );
      });
      this.setState({ rollLines: sorted });
    }
  };
  handleSortingArLinesChange = (e, accessor) => {
    if (e.detail === 1) {
      let sortField = accessor;
      let order = this.state.order;
      let sortOrder =
        accessor === sortField && order === "asc" ? "desc" : "asc";
      this.setState({
        order: sortOrder,
        sortField: sortField,
      });
      this.handleSortingArLines(sortField, sortOrder);
    }
  };
  handleSortingArLines = (sortField, sortOrder) => {
    let list = this.state.arLines;
    if (sortField && !isEmptyArray(list)) {
      const sorted = [...list].sort((a, b) => {
        if (a[sortField] === null) return 1;
        if (b[sortField] === null) return -1;
        if (a[sortField] === null && b[sortField] === null) return 0;
        return (
          a[sortField].toString().localeCompare(b[sortField].toString(), "en", {
            numeric: true,
          }) * (sortOrder === "asc" ? 1 : -1)
        );
      });
      this.setState({ arLines: sorted });
    }
  };

  handleSortingStatusChange = (accessor) => {
    let sortField = accessor;
    let order = this.state.order;
    let sortOrder = accessor === sortField && order === "asc" ? "desc" : "asc";
    this.setState({
      order: sortOrder,
      sortField: sortField,
    });
    this.handleSortingStatus(sortField, sortOrder);
  };
  handleSortingStatus = (sortField, sortOrder) => {
    let list = this.state.statusTrackList;
    if (sortField && !isEmptyArray(list)) {
      const sorted = [...list].sort((a, b) => {
        if (a[sortField] === null) return 1;
        if (b[sortField] === null) return -1;
        if (a[sortField] === null && b[sortField] === null) return 0;
        return (
          a[sortField].toString().localeCompare(b[sortField].toString(), "en", {
            numeric: true,
          }) * (sortOrder === "asc" ? 1 : -1)
        );
      });
      this.setState({ statusTrackList: sorted });
    }
  };
  handleSortingCreditMemoAppliedLinesChange = (accessor) => {
    let sortField = accessor;
    let order = this.state.order;
    let sortOrder = accessor === sortField && order === "asc" ? "desc" : "asc";
    this.setState({
      order: sortOrder,
      sortField: sortField,
    });
    this.handleSortingCreditMemoAppliedLines(sortField, sortOrder);
  };
  handleSortingCreditMemoAppliedLines = (sortField, sortOrder) => {
    let list = this.state.creditMemoAppliedLines;
    if (sortField && !isEmptyArray(list)) {
      const sorted = [...list].sort((a, b) => {
        if (a[sortField] === null) return 1;
        if (b[sortField] === null) return -1;
        if (a[sortField] === null && b[sortField] === null) return 0;
        return (
          a[sortField].toString().localeCompare(b[sortField].toString(), "en", {
            numeric: true,
          }) * (sortOrder === "asc" ? 1 : -1)
        );
      });
      this.setState({ creditMemoAppliedLines: sorted });
    }
  };

  handleSortingMerchandiseLinesChange = (accessor) => {
    let sortField = accessor;
    let order = this.state.order;
    let sortOrder = accessor === sortField && order === "asc" ? "desc" : "asc";
    this.setState({
      order: sortOrder,
      sortField: sortField,
    });
    this.handleSortingMerchandiseLines(sortField, sortOrder);
  };
  handleSortingMerchandiseLines = (sortField, sortOrder) => {
    let list = this.state.merchandiseLinesList;
    if (sortField && !isEmptyArray(list)) {
      const sorted = [...list].sort((a, b) => {
        if (a[sortField] === null) return 1;
        if (b[sortField] === null) return -1;
        if (a[sortField] === null && b[sortField] === null) return 0;
        return (
          a[sortField].toString().localeCompare(b[sortField].toString(), "en", {
            numeric: true,
          }) * (sortOrder === "asc" ? 1 : -1)
        );
      });
      this.setState({ merchandiseLinesList: sorted });
    }
  };

  handleSortingNonMerchandiseLinesChange = (accessor) => {
    let sortField = accessor;
    let order = this.state.order;
    let sortOrder = accessor === sortField && order === "asc" ? "desc" : "asc";
    this.setState({
      order: sortOrder,
      sortField: sortField,
    });
    this.handleSortingNonMerchandiseLines(sortField, sortOrder);
  };
  handleSortingNonMerchandiseLines = (sortField, sortOrder) => {
    let list = this.state.nonMerchandiseLinesList;
    if (sortField && !isEmptyArray(list)) {
      const sorted = [...list].sort((a, b) => {
        if (a[sortField] === null) return 1;
        if (b[sortField] === null) return -1;
        if (a[sortField] === null && b[sortField] === null) return 0;
        return (
          a[sortField].toString().localeCompare(b[sortField].toString(), "en", {
            numeric: true,
          }) * (sortOrder === "asc" ? 1 : -1)
        );
      });
      this.setState({ nonMerchandiseLinesList: sorted });
    }
  };

  handleSortingCreditMemoCommisionListChange = (accessor) => {
    let sortField = accessor;
    let order = this.state.order;
    let sortOrder = accessor === sortField && order === "asc" ? "desc" : "asc";
    this.setState({
      order: sortOrder,
      sortField: sortField,
    });
    this.handleSortingCreditMemoCommisionList(sortField, sortOrder);
  };
  handleSortingCreditMemoCommisionList = (sortField, sortOrder) => {
    let list = this.state.creditMemoCommisionList;
    if (sortField && !isEmptyArray(list)) {
      const sorted = [...list].sort((a, b) => {
        if (a[sortField] === null) return 1;
        if (b[sortField] === null) return -1;
        if (a[sortField] === null && b[sortField] === null) return 0;
        return (
          a[sortField].toString().localeCompare(b[sortField].toString(), "en", {
            numeric: true,
          }) * (sortOrder === "asc" ? 1 : -1)
        );
      });
      this.setState({ creditMemoCommisionList: sorted });
    }
  };
  handleSortingReturnPaymentChange = (accessor) => {
    let sortField = accessor;
    let order = this.state.order;
    let sortOrder = accessor === sortField && order === "asc" ? "desc" : "asc";
    this.setState({
      order: sortOrder,
      sortField: sortField,
    });
    this.handleSortingReturnPayment(sortField, sortOrder);
  };
  handleSortingReturnPayment = (sortField, sortOrder) => {
    let list = this.state.returnPaymentLinesList;
    if (sortField && !isEmptyArray(list)) {
      const sorted = [...list].sort((a, b) => {
        if (a[sortField] === null) return 1;
        if (b[sortField] === null) return -1;
        if (a[sortField] === null && b[sortField] === null) return 0;
        return (
          a[sortField].toString().localeCompare(b[sortField].toString(), "en", {
            numeric: true,
          }) * (sortOrder === "asc" ? 1 : -1)
        );
      });
      this.setState({ returnPaymentLinesList: sorted });
    }
  };
  render() {
    let criteria = this.state.criteria;
    let cmData = this.state.cmData;
    let merchandiseLineData = this.state.merchandiseLineData;
    let rollLines = this.state.rollLines;
    let customerReturnData = this.state.customerReturnData;
    let adjustNonMerchandiseData = this.state.adjustNonMerchandiseData;
    let returnPaymentDetail = this.state.returnPaymentDetail;
    let returnAmount = 0;
    let payment_width = "50%";
    if (isEmpty(cmData.returnPaymentDetails)) {
      cmData.returnPaymentDetails = [];
    }
    cmData.returnPaymentDetails.map((cm) => {
      let paidReturnAmount = cm.cashAmount + cm.cardAmount + cm.checkAmount;
      returnAmount = returnAmount + paidReturnAmount;
    });
    let arLines = this.state.arLines;
    let currentARLine = this.state.currentARLine;
    let reasonData = this.state.reasonData;
    let openAmount =
      cmData.totalCreditAmount - cmData.provisionalAppliedAmount - returnAmount;
    let lines = this.state.invoiceLines;
    var dataTableStyles = {
      header: {
        style: {
          minHeight: "0px",
        },
      },
      table: {
        style: {
          minHeight: "350px",
          maxHeight: "350px",
          overflowY: "auto",
        },
      },
    };
    let moduleOrderStatus = "";

    if (
      this.state.cmData.creditMemoStatus != null ||
      !isEmptyString(this.state.cmData.creditMemoStatus) ||
      this.state.cmData.creditMemoStatus != "undefined"
    ) {
      let orderStatus = ModuleUtils.getCreditMemoStatusCaption(
        this.state.cmData.creditMemoStatus,
      );
      if (orderStatus !== undefined && orderStatus !== null) {
        moduleOrderStatus = orderStatus;
      }
    }
    let already_AppliedAmount_Total_Calc =
      cmData.appliedAmount + cmData.provisionalAppliedAmount;
    let currently_Applied_Amount = 0;
    let amount = 0;
    arLines.map((ln) => {
      if (ln.accountReceivableNumber == "NEW") {
        amount += parseFloat(ln.creditMemoAppliedAmount);
      }
    });
    currently_Applied_Amount = amount;
    let remaingAmount_Calc =
      cmData.totalCreditAmount -
      already_AppliedAmount_Total_Calc -
      currently_Applied_Amount;
    // let refundTo_Customer = 0;
    // refundTo_Customer =
    //   returnPaymentDetail.cashAmount +
    //   returnPaymentDetail.checkAmount +
    //   returnPaymentDetail.cardAmount;
    let refundTo_Customer =
      Number(returnPaymentDetail.cashAmount || 0) +
      Number(returnPaymentDetail.checkAmount || 0) +
      Number(returnPaymentDetail.cardAmount || 0);
    let returnPaymentDetails = cmData.returnPaymentDetails;
    // let previous_Refunds = 0;
    // let returnPaymentAmount = 0;
    // returnPaymentDetails.map((ln) => {
    //   returnPaymentAmount += ln.cashAmount + ln.checkAmount + ln.cardAmount;
    //   previous_Refunds = returnPaymentAmount;
    // });
    // let remaining_Credit = 0;
    // remaining_Credit =
    // cmData.totalCreditAmount - previous_Refunds - refundTo_Customer;

    let previous_Refunds = 0;

    let returnPaymentAmount = 0;

    returnPaymentDetails.forEach((ln) => {
      returnPaymentAmount +=
        Number(ln.cashAmount || 0) +
        Number(ln.checkAmount || 0) +
        Number(ln.cardAmount || 0);
    });

    previous_Refunds = returnPaymentAmount;

    let remaining_Credit = 0;

    remaining_Credit =
      Number(cmData.totalCreditAmount || 0) -
      previous_Refunds -
      Number(refundTo_Customer || 0);
    const textAreaStyle = {
      height: "20em",
      width: "100em",
      resize: "none",
      padding: "10px",
      boxSizing: "border-box",
      fontSize: "15px",
    };
    const textArea_Style = {
      height: "15em",
      width: "60em",
      resize: "none",
      padding: "10px",
      boxSizing: "border-box",
      fontSize: "15px",
    };
    const text_Area_Style = {
      height: "10em",
      width: "38em",
      resize: "none",
      padding: "10px",
      boxSizing: "border-box",
      fontSize: "15px",
    };
    let is3PL = this.state.is3PL;
    return (
      <div>
        <MessageBoxComponent
          isShowPopup={this.state.isShowWarningMsgPopup}
          ref={this.warningMessageDialogRef}
          warningMesage={this.state.invoiceWarningMessage}
          title="Warning Message"
          onYesButtonClick={this.onYesButtonClick}
          onNoButtonClick={this.onNoButtonClick}
          closeMessageModelCallBack={this.closeMessageModelCallBack}
        />
        <ProgressBar
          progressLoadingText={this.state.progressLoadingText}
          isShowPopup={this.state.isShowProgressBarPopup}
        />
        {!this.state.isSpecialViewMode ? (
          <AlertToolBox
            alertMsgList={this.state.alertMessage}
            alertErrorType={this.state.alertType}
            isShowAlert={this.state.isShowAlert}
            hideAlertCallBack={this.hideAlertCallBack}
          />
        ) : null}
        <div>
          <ModuleToolBar
            isShowNewButton={false}
            onNewEntry={() => this.addNewEntry()}
            onModuleExit={() => this.moduleExit()}
            pageTitle={this.state.pageTitle}
            resetView={() => this.resetView()}
            loadingText={this.state.loadingText}
            isLoading={this.state.isLoading}
            isShowModuleSearchContainer={this.state.isShowModuleSearchContainer}
            isMaintenanceMode={this.state.isMaintenanceMode}
            onModuleKeyContainerButtonClick={this.editCreditMemo}
            moduleKeyCode={this.state.moduleKeyCode}
            onModuleKeyCodeChange={this.onModuleKeyCodeChange}
            getModuleListView={this.getModuleListView}
            lookupRequired={true} //for f2 lookup
            lookupHandler={this.state.creditMemoLookupHandler} //for f2 lookup
            showCriteriaDialog={true} //for f2 lookup
            onModuleKeyCodeWithCriteriaOnChange={
              this.onModuleKeyCodeWithCriteriaOnChange
            }
            selectButtonClick={this.selectButtonClick}
            disabled={this.state.disabled}
            isSpecialViewMode={this.state.isSpecialViewMode}
            isResetView={this.state.isResetView}
            isFocusLookup={this.state.isFocusLookup}
          />
        </div>
        {!this.state.isCreditMemoListFormOpen &&
          this.state.isSpecialViewMode == false &&
          this.state.isViewMode == false && (
            <BaseToolBar
              extend_toolbar={
                <CreditMemoModuleToolBar
                  cancelCreditMemo={this.cancelCreditMemo}
                  approveCreditMemo={this.approveCreditMemo}
                  unApproveCreditMemo={this.unApproveCreditMemo}
                  adjustCreditMemo={this.adjustCreditMemo}
                  applyToInvoice={this.applyToInvoice}
                  returnToCustomer={this.returnToCustomer}
                  approveAndPrint={this.approveAndPrint}
                  loadCustomerReturn={this.loadCustomerReturn}
                  generateExcel={this.generateExcel}
                  isShowApproveButton={this.state.isShowApproveButton}
                  isShowApprovePrintButton={this.state.isShowApprovePrintButton}
                  isShowUnApproveButton={this.state.isShowUnApproveButton}
                  isShowCancelButton={this.state.isShowCancelButton}
                  isShowAdjustButton={this.state.isShowAdjustButton}
                  isShowLoadCustomerReturnButton={
                    this.state.isShowLoadCustomerReturnButton
                  }
                  isShowApplyToInvoiceButton={
                    this.state.isShowApplyToInvoiceButton
                  }
                  isShowRefundButton={this.state.isShowRefundButton}
                  isShowExcelButton={this.state.isShowExcelButton}
                />
              }
              save={this.save}
              clearError={this.clearError}
              generatePDF={this.generatePDF}
              isShowSaveButton={this.state.isShowSaveButton}
              isShowClearCriteriaButton={this.state.isShowClearCriteriaButton}
              isShowClearErrorButton={this.state.isShowClearErrorButton}
              isShowPDFButton={this.state.isShowPDFButton}
              pageTitle={this.state.pageTitle}
            />
          )}
        {this.state.isShowNodes && (
          <BaseNodeBar
            nodeList={this.state.nodeList}
            selectedModuleKey={this.state.selectedNodeKey}
            nodeOnSelect={this.nodeOnSelect}
            moduleStatus={moduleOrderStatus}
          />
        )}
        {!this.state.isShowNodes &&
          !this.state.isCreditMemoListFormOpen &&
          !this.state.isCreditMemoHistoryFormOpened &&
          this.state.isCreditMemoEntryFormOpen &&
          !this.state.isCreditMemoPaymentFormOpened &&
          !this.state.isCommissionFormOpened &&
          !this.state.isCommentsAndNotesFormOpened}
        {this.state.isShowNodes &&
          !this.state.isCreditMemoListFormOpen &&
          !this.state.isCreditMemoHistoryFormOpened &&
          this.state.isCreditMemoEntryFormOpen &&
          !this.state.isCreditMemoPaymentFormOpened &&
          !this.state.isCommissionFormOpened &&
          !this.state.isCommentsAndNotesFormOpened}
        {this.state.isShowNodes &&
          !this.state.isCreditMemoListFormOpen &&
          this.state.isCreditMemoHistoryFormOpened &&
          !this.state.isCreditMemoEntryFormOpen &&
          !this.state.isCreditMemoPaymentFormOpened &&
          !this.state.isCommissionFormOpened &&
          !this.state.isCommentsAndNotesFormOpened &&
          this.getHistoryView()}
        {this.state.isShowNodes &&
          !this.state.isCreditMemoListFormOpen &&
          !this.state.isCreditMemoHistoryFormOpened &&
          !this.state.isCreditMemoEntryFormOpen &&
          this.state.isCreditMemoPaymentFormOpened &&
          !this.state.isCommissionFormOpened &&
          !this.state.isCommentsAndNotesFormOpened &&
          this.getPaymentView()}
        {this.state.isShowNodes &&
          !this.state.isCreditMemoListFormOpen &&
          !this.state.isCreditMemoHistoryFormOpened &&
          !this.state.isCreditMemoEntryFormOpen &&
          !this.state.isCreditMemoPaymentFormOpened &&
          this.state.isCommissionFormOpened &&
          !this.state.isCommentsAndNotesFormOpened &&
          this.getCommissionView()}
        {this.state.isShowNodes &&
          !this.state.isCreditMemoListFormOpen &&
          !this.state.isCreditMemoHistoryFormOpened &&
          !this.state.isCreditMemoEntryFormOpen &&
          !this.state.isCreditMemoPaymentFormOpened &&
          !this.state.isCommissionFormOpened &&
          this.state.isCommentsAndNotesFormOpened && (
            <div>
              <Row>
                <FormLabel className="label_head">Comments</FormLabel>
              </Row>
              <Row>
                <Col>
                  <textarea
                    style={textAreaStyle}
                    className="form-control"
                    type="text"
                    name="comments"
                    onChange={this.onChange}
                    value={cmData.comments}
                    disabled={this.state.disableCMFormFields}
                  />
                </Col>
              </Row>
            </div>
          )}
        {this.state.isCreditMemoListFormOpen &&
          this.state.isSpecialViewMode == false && (
            <CreditMemoListForm
              {...this.state}
              loadFirst={this.loadFirst}
              loadNext={this.loadNext}
              loadPrevious={this.loadPrevious}
              loadLast={this.loadLast}
              editCreditMemo={this.editCreditMemo}
              filter={this.filter}
              resetFilteredCM={this.resetFilteredCM}
              resetFilter={this.resetFilter}
              advanceSearch={this.advanceSearch}
              listFormOnChange={this.listFormOnChange}
              handleSortingChange={this.handleSortingChange}
            />
          )}
        {this.state.isCreditMemoEntryFormOpen && (
          <CreditMemoEntryForm
            {...this.state}
            ref={this.creditMemoEntryFormRef}
            closeEntryFrom={this.closeEntryFrom}
            setUpdateInventory={this.setUpdateInventory}
            onChange={this.onChange}
            onCustomerCodeChange={this.onCustomerCodeChange}
            customerCodeEnterKeyEventHandler={
              this.customerCodeEnterKeyEventHandler
            }
            displayAutoCustomerCompleteList={
              this.displayAutoCustomerCompleteList
            }
            onCMChange={this.onCMChange}
            fetchInvoiceOnClick={this.fetchInvoiceOnClick}
            onAddNonMerchandiseLineClick={this.onAddNonMerchandiseLineClick}
            getNonMerchandiseLineDetails={this.getNonMerchandiseLineDetails}
            getMerchandiseLineDetails={this.getMerchandiseLineDetails}
            openNonMerchandiseLineDetailDialog={
              this.openNonMerchandiseLineDetailDialog
            }
            openMerchandiseLineDetailDialog={
              this.openMerchandiseLineDetailDialog
            }
            viewARModule={this.viewARModule}
            viewInvoiceModule={this.viewInvoiceModule}
            closeModalCallBack={this.closeModalCallBack}
            lnkCustomerModule={this.lnkCustomerModule}
            openCustomerOnOrderInq={this.openCustomerOnOrderInq}
            openCustomerTransactionsInq={this.openCustomerTransactionsInq}
            openCustomerStatisticsInq={this.openCustomerStatisticsInq}
            openCustomerSalesHistoryInq={this.openCustomerSalesHistoryInq}
            openCustomerMostRecentFabricsInq={
              this.openCustomerMostRecentFabricsInq
            }
            openCustomerCurrentAgingInq={this.openCustomerCurrentAgingInq}
            deleteMerchandiseLine={this.deleteMerchandiseLine}
            deleteNonMerchandiseLine={this.deleteNonMerchandiseLine}
            hideAlertCallBack={this.hideAlertCallBack}
            creditTypeOnChange={this.creditTypeOnChange}
            creditTypeEnterKeyEvent={this.creditTypeEnterKeyEvent}
            displayCreditTypeAutoCompleteList={
              this.displayCreditTypeAutoCompleteList
            }
            onBillToChange={this.onBillToChange}
            billToToEnterKeyEvent={this.billToToEnterKeyEvent}
            displayAutoCompleteBillToList={this.displayAutoCompleteBillToList}
            invoiceCodeEnterKeyEventHandler={
              this.invoiceCodeEnterKeyEventHandler
            }
            handleSortingMerchandiseLinesChange={
              this.handleSortingMerchandiseLinesChange
            }
            handleSortingNonMerchandiseLinesChange={
              this.handleSortingNonMerchandiseLinesChange
            }
            merchandiseLinesList={this.state.merchandiseLinesList}
            nonMerchandiseLinesList={this.state.nonMerchandiseLinesList}
          />
        )}
        <ReasonCaptureComponent
          ref={this.unapproveReasonDialogRef}
          reasons={this.state.creditReasons}
          reasonData={this.state.reasonData}
          title="CreditMemo UnApprove"
          onChange={this.onReasonChange}
          onClick={this.onUnApproveReasonContinue}
          isShowPopup={this.state.isShowUnApproveReasonPopup}
          closeReasonModelCallBack={this.closeReasonModelCallBack}
          reasonEnterKeyEventHandler={this.reasonEnterKeyEventHandler}
          reasonPageListForAutoCompleteList={
            this.state.reasonPageListForAutoCompleteList
          }
          displayAutoCompleteReasonList={this.displayAutoCompleteReasonList}
          showAutoCompleteReasonList={this.state.showAutoCompleteReasonList}
          onReasonDescChange={this.onReasonDescChange}
        />
        <ReasonCaptureComponent
          ref={this.cancelReasonDialogRef}
          reasons={this.state.creditReasons}
          reasonData={this.state.reasonData}
          title="CreditMemo Cancel"
          onChange={this.onReasonChange}
          onClick={this.onCancelReasonContinue}
          isShowPopup={this.state.isShowCancelReasonPopup}
          closeReasonModelCallBack={this.closeReasonModelCallBack}
          reasonEnterKeyEventHandler={this.reasonEnterKeyEventHandler}
          reasonPageListForAutoCompleteList={
            this.state.reasonPageListForAutoCompleteList
          }
          displayAutoCompleteReasonList={this.displayAutoCompleteReasonList}
          showAutoCompleteReasonList={this.state.showAutoCompleteReasonList}
          onReasonDescChange={this.onReasonDescChange}
        />
        <div>
          {" "}
          <MultiViewPopup
            popupLvlClass={"popupSizeLevel5"}
            isModulePopup={false}
            isShowPopup={this.state.isShowCustomerReturnPopup}
            closeOnEsc={true}
            closeAlertModalCallBack={this.closeAlertModalCallBack}
            title={"Load Customer Return"}
            closeOnDocumentClick={false}
            lineFunctionalityForm={this.lineFunctionalityForm}
            alertContainerBox={
              <AlertToolBox
                alertMsgList={this.state.alertMessage}
                alertErrorType={this.state.alertType}
                isShowAlert={this.state.isShowAlertLvl5}
                hideAlertCallBack={this.hideAlertCallBackLvl5}
              />
            }
            headerButtonContainer={
              <div className="floatLeft">
                <Button
                  className="header_buttons enterFocus"
                  size="sm"
                  onClick={(e) => this.loadCustomerReturnData(e)}
                >
                  Load
                </Button>
              </div>
            }
            content={
              <div>
                <Row>
                  <Col sm="2">
                    <FormLabel>Customer Return#</FormLabel>
                  </Col>
                  <Col sm="6">
                    <InputTextbox
                      onChange={this.customerReturnOnChange}
                      placeholder="code"
                      name="code"
                      value={customerReturnData.code}
                      lookupRequired={true}
                      lookupHandler={this.state.customerReturnLookupHandler}
                      showCriteriaDialog={true}
                      enterKeyEventHandler={this.customerReturnEnterKeyEvent}
                      autoCompleteListData={
                        this.state.customerReturnPageListForAutoCompleteList
                      }
                      enableAutoCompleteTextBox={true}
                      displayAutoCompleteList={
                        this.displayCustomerReturnAutoCompleteList
                      }
                      showAutoCompleteList={
                        this.state.isShowAutoCompleCustomerReturnList
                      }
                      isMandatory={true}
                    />
                  </Col>
                </Row>
              </div>
            }
          />
          <MultiViewPopup
            popupLvlClass={"popupSizeLevel3"}
            isModulePopup={false}
            isShowPopup={this.state.isShowOnHandQtyPopup}
            closeOnEsc={true}
            closeAlertModalCallBack={this.closeAlertModalCallBack}
            title={"OnHand Qty Details"}
            closeOnDocumentClick={false}
            lineFunctionalityForm={this.lineFunctionalityForm}
            alertContainerBox={
              <AlertToolBox
                alertMsgList={this.state.alertMessage}
                alertErrorType={this.state.alertType}
                isShowAlert={this.state.isShowAlertLvl3}
                hideAlertCallBack={this.hideAlertCallBackLvl3}
              />
            }
            content={
              <div>
                <div>
                  <Row>
                    <Col sm="1">
                      <FormLabel>Company Code</FormLabel>
                    </Col>
                    <Col sm="3">
                      <InputTextbox
                        value={merchandiseLineData.companyCode}
                        className="text-right"
                        name={"companyCode"}
                        disabled={true}
                      />
                    </Col>
                    <Col sm="1">
                      <FormLabel>Credit Memo</FormLabel>
                    </Col>
                    <Col sm="3">
                      <InputTextbox
                        value={merchandiseLineData.creditMemoNumber}
                        className="text-right"
                        name={"creditMemoNumber"}
                        disabled={true}
                      />
                    </Col>
                    <Col sm="1">
                      <FormLabel>Line</FormLabel>
                    </Col>
                    <Col sm="3">
                      <InputTextbox
                        value={merchandiseLineData.lineNumber}
                        className="text-right"
                        name={"lineNumber"}
                        disabled={true}
                      />
                    </Col>
                  </Row>
                  <Row>
                    <Col sm="1">
                      <FormLabel>Location</FormLabel>
                    </Col>
                    <Col sm="3">
                      <InputTextbox
                        value={merchandiseLineData.locationCode}
                        className="text-right"
                        name={"locationCode"}
                        disabled={true}
                      />
                    </Col>
                    <Col sm="1">
                      <FormLabel>{is3PL ? "Item" : "FabricStyle"}</FormLabel>
                    </Col>
                    <Col sm="3">
                      <InputTextbox
                        value={merchandiseLineData.fabricStyleCode}
                        className="text-right"
                        name={"fabricStyleCode"}
                        disabled={true}
                      />
                    </Col>
                    <Col sm="4">
                      <InputTextbox
                        value={merchandiseLineData.fabricStyleName}
                        className="text-right"
                        name={"fabricStyleName"}
                        disabled={true}
                      />
                    </Col>
                  </Row>
                  <Row>
                    <Col sm="1">
                      {" "}
                      <FormLabel>Color</FormLabel>
                    </Col>
                    <Col sm="3">
                      <InputTextbox
                        value={merchandiseLineData.colorCode}
                        className="text-right"
                        name={"colorCode"}
                        disabled={true}
                      />
                    </Col>
                    <Col sm="1">
                      {" "}
                      <FormLabel>Width</FormLabel>
                    </Col>
                    <Col sm="3">
                      <InputTextbox
                        value={merchandiseLineData.widthCode}
                        className="text-right"
                        name={"widthCode"}
                        disabled={true}
                      />
                    </Col>
                  </Row>
                </div>
                <div className="div_Custom_3">
                  <Table id="fabrics_tables_default">
                    <thead>
                      <tr>
                        <th
                          onClick={(e) =>
                            this.handleSortingRollLineChange(e, "locationCode")
                          }
                        >
                          Location
                          {this.state.order === "desc" &&
                          this.state.sortField === "locationCode" ? (
                            <span className="drp-dwn-cntr">
                              <DropDwnUp />
                            </span>
                          ) : (
                            <span className="drp-dwn-cntr">
                              <DropDwnDown />
                            </span>
                          )}
                        </th>
                        <th
                          onClick={(e) =>
                            this.handleSortingRollLineChange(e, "boxNumber")
                          }
                        >
                          Box
                          {this.state.order === "desc" &&
                          this.state.sortField === "boxNumber" ? (
                            <span className="drp-dwn-cntr">
                              <DropDwnUp />
                            </span>
                          ) : (
                            <span className="drp-dwn-cntr">
                              <DropDwnDown />
                            </span>
                          )}
                        </th>
                        <th
                          onClick={(e) =>
                            this.handleSortingRollLineChange(
                              e,
                              "vendorBatchNumber",
                            )
                          }
                        >
                          VendorLot
                          {this.state.order === "desc" &&
                          this.state.sortField === "vendorBatchNumber" ? (
                            <span className="drp-dwn-cntr">
                              <DropDwnUp />
                            </span>
                          ) : (
                            <span className="drp-dwn-cntr">
                              <DropDwnDown />
                            </span>
                          )}
                        </th>
                        <th
                          onClick={(e) =>
                            this.handleSortingRollLineChange(e, "rollNumber")
                          }
                        >
                          Roll
                          {this.state.order === "desc" &&
                          this.state.sortField === "rollNumber" ? (
                            <span className="drp-dwn-cntr">
                              <DropDwnUp />
                            </span>
                          ) : (
                            <span className="drp-dwn-cntr">
                              <DropDwnDown />
                            </span>
                          )}
                        </th>
                        <th
                          onClick={(e) =>
                            this.handleSortingRollLineChange(e, "rollSkuNumber")
                          }
                        >
                          {this.state.is3PL ? "Inventory#" : "RollSKU#"}

                          {this.state.order === "desc" &&
                          this.state.sortField === "rollSkuNumber" ? (
                            <span className="drp-dwn-cntr">
                              <DropDwnUp />
                            </span>
                          ) : (
                            <span className="drp-dwn-cntr">
                              <DropDwnDown />
                            </span>
                          )}
                        </th>
                        <th
                          onClick={(e) =>
                            this.handleSortingRollLineChange(
                              e,
                              "onHandQuantity",
                            )
                          }
                        >
                          OnHandQty
                          {this.state.order === "desc" &&
                          this.state.sortField === "onHandQuantity" ? (
                            <span className="drp-dwn-cntr">
                              <DropDwnUp />
                            </span>
                          ) : (
                            <span className="drp-dwn-cntr">
                              <DropDwnDown />
                            </span>
                          )}
                        </th>
                      </tr>
                    </thead>
                    {rollLines != null ? (
                      <tbody>
                        {rollLines.map((ln, index) => (
                          <tr key={index}>
                            <td>{ln.locationCode}</td>
                            <td>{ln.boxNumber}</td>
                            <td>{ln.vendorBatchNumber}</td>
                            <td>{ln.rollNumber}</td>
                            <td>{ln.rollSkuNumber}</td>
                            <td>{ln.onHandQuantity}</td>
                          </tr>
                        ))}
                      </tbody>
                    ) : null}
                  </Table>
                  {rollLines.length != 0 ? null : (
                    <div className="no_Data">{"NO DATA"}</div>
                  )}
                </div>
              </div>
            }
          />
          <MultiViewPopup
            popupLvlClass={"popupSizeLevel3"}
            isModulePopup={false}
            isShowPopup={this.state.isShowAdjustPopup}
            closeOnEsc={true}
            closeAlertModalCallBack={this.closeAlertModalCallBack}
            title={"Adjustment"}
            closeOnDocumentClick={false}
            lineFunctionalityForm={this.lineFunctionalityForm}
            alertContainerBox={
              <AlertToolBox
                alertMsgList={this.state.alertMessage}
                alertErrorType={this.state.alertType}
                isShowAlert={this.state.isShowAlertLvl3}
                hideAlertCallBack={this.hideAlertCallBackLvl3}
              />
            }
            headerButtonContainer={
              <div className="floatLeft">
                <Button
                  className="header_buttons enterFocus"
                  size="sm"
                  onClick={(e) => this.saveAdjustment(e)}
                >
                  Save Adjustment
                </Button>

                <Button
                  className="header_buttons enterFocus"
                  size="sm"
                  onClick={(e) => this.clearAdjustment(e)}
                >
                  Clear
                </Button>
              </div>
            }
            content={
              <div>
                <Row>
                  <Col sm="1">
                    <FormLabel>Date</FormLabel>
                  </Col>
                  <Col sm="3">
                    <DatePickerComponent_adv
                      value={cmData.creditMemoDate}
                      disabled={true}
                    />
                  </Col>
                  <Col sm="1">
                    <FormLabel>Customer</FormLabel>
                  </Col>
                  <Col sm="3">
                    <InputTextbox value={cmData.customerCode} disabled={true} />
                  </Col>
                  <Col sm="4">
                    <InputTextbox value={cmData.customerName} disabled={true} />
                  </Col>
                </Row>
                <Row>
                  <Col sm="1">
                    <FormLabel>Type</FormLabel>
                  </Col>
                  <Col sm="3">
                    <InputTextbox value={cmData.creditType} disabled={true} />
                  </Col>
                  <Col sm="1">
                    <FormLabel>Bill TO</FormLabel>
                  </Col>
                  <Col sm="3">
                    <InputTextbox value={cmData.billToCode} disabled={true} />
                  </Col>
                  <Col sm="1">
                    <FormLabel>Invoice</FormLabel>
                  </Col>
                  <Col sm="3">
                    <InputTextbox
                      value={cmData.invoiceNumber}
                      disabled={true}
                    />
                  </Col>
                </Row>
                <Row>
                  <Col sm="1">
                    <FormLabel>Created Source</FormLabel>
                  </Col>
                  <Col sm="3">
                    <InputTextbox
                      value={cmData.createdSourceType}
                      disabled={true}
                    />
                  </Col>
                  <Col sm="1">
                    <FormLabel>Currency</FormLabel>
                  </Col>
                  <Col sm="3">
                    <InputTextbox
                      className="summary_input text-right"
                      value={cmData.customerCurrencyCode}
                      disabled={true}
                    />
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <FormLabel>Non Merchandise Line Detail</FormLabel>
                  </Col>
                </Row>
                <Row>
                  <Col sm="2">
                    <FormLabel>SubType</FormLabel>
                  </Col>
                  <Col sm="4">
                    <InputTextbox
                      onChange={this.creditsubtypeOnChange}
                      placeholder="creditSubType"
                      name="creditSubType"
                      value={adjustNonMerchandiseData.creditSubType}
                      lookupRequired={true}
                      lookupHandler={this.state.creditSubTypeLookupHandler}
                      showCriteriaDialog={true}
                      enterKeyEventHandler={this.creditsubtypeEnterKeyEvent}
                      autoCompleteListData={
                        this.state.creditsubtypePageListForAutoCompleteList
                      }
                      enableAutoCompleteTextBox={true}
                      displayAutoCompleteList={
                        this.displayCreditsubtypeAutoCompleteList
                      }
                      showAutoCompleteList={
                        this.state.isShowAutoCompleteCreditsubtypeList
                      }
                    />
                  </Col>
                  <Col sm="2">
                    <FormLabel>Amount</FormLabel>
                  </Col>
                  <Col sm="4">
                    <NumberFormatInputbox
                      name="lineTotalAmount"
                      className="summary_input text-right"
                      value={adjustNonMerchandiseData.lineTotalAmount}
                      onChange={this.adjustOnChange}
                      decimalScale={2}
                    />
                  </Col>
                </Row>
                <Row>
                  <Col sm="2">
                    <FormLabel>Doc.Type</FormLabel>
                  </Col>
                  <Col sm="4">
                    <InputTextbox
                      name="documentType"
                      value={adjustNonMerchandiseData.documentType}
                      onChange={this.adjustOnChange}
                    />
                  </Col>

                  <Col sm="2">
                    <FormLabel>Document#</FormLabel>
                  </Col>
                  <Col sm="4">
                    <InputTextbox
                      name="documentNumber"
                      value={adjustNonMerchandiseData.documentNumber}
                      onChange={this.adjustOnChange}
                    />
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <FormLabel>Adjustment reason</FormLabel>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <textarea
                      style={textArea_Style}
                      className="form-control"
                      type="text"
                      name="code"
                      value={adjustNonMerchandiseData.code}
                      onChange={this.adjustOnChange}
                    />
                  </Col>
                </Row>
              </div>
            }
          />
          <MultiViewPopup
            popupLvlClass={"popupSizeLevel3"}
            isModulePopup={false}
            isShowPopup={this.state.isShowAdvanceSearchPopup}
            closeOnEsc={false}
            closeAlertModalCallBack={this.closeAlertModalCallBack}
            title={"Advance Search"}
            closeOnDocumentClick={false}
            lineFunctionalityForm={this.lineFunctionalityForm}
            alertContainerBox={
              <AlertToolBox
                alertMsgList={this.state.alertMessage}
                alertErrorType={this.state.alertType}
                isShowAlert={this.state.isShowAlertLvl3}
                hideAlertCallBack={this.hideAlertCallBackLvl3}
              />
            }
            headerButtonContainer={
              <div className="floatLeft">
                <Button
                  className="header_buttons enterFocus"
                  size="sm"
                  onClick={(e) => this.onAdvanceSearchClick(e)}
                >
                  Search
                </Button>
              </div>
            }
            content={
              <div className="criteria header_div ">
                <Row>
                  <Col sm="2">
                    <FormLabel>CM#</FormLabel>
                  </Col>
                  <Col sm="3">
                    <InputTextbox
                      name="creditMemoNumber"
                      type="text"
                      placeholder="Enter CMNumber"
                      value={criteria.creditMemoNumber}
                      onChange={this.onCriteriaChange}
                    />
                  </Col>
                </Row>
                <Row>
                  <Col sm="2">
                    <FormLabel>CM# StartsWith</FormLabel>
                  </Col>
                  <Col sm="3">
                    <InputTextbox
                      name="creditMemoNumberStartsWith"
                      type="text"
                      placeholder="Enter CMNumberStartsWith"
                      value={criteria.creditMemoNumberStartsWith}
                      onChange={this.onCriteriaChange}
                    />
                  </Col>
                </Row>
                <Row>
                  <Col sm="2">
                    <FormLabel>CM# Contains</FormLabel>
                  </Col>

                  <Col sm="3">
                    <InputTextbox
                      name="creditMemoNumberContains"
                      type="text"
                      placeholder="Enter CMNumberContains"
                      value={criteria.creditMemoNumberContains}
                      onChange={this.onCriteriaChange}
                    />
                  </Col>
                </Row>
                <Row>
                  <Col sm="2">
                    <FormLabel>Customer</FormLabel>
                  </Col>
                  <Col sm="3">
                    <InputTextbox
                      name="customerCode"
                      placeholder="Select customer"
                      onChange={this.onAdvSearchChange}
                      value={criteria.customerCode}
                      lookupRequired={true}
                      lookupHandler={this.state.customerLookupHandler}
                      isLoading={this.state.isCustomerDataLoding}
                    />
                  </Col>
                </Row>
                <Row>
                  <Col sm="2">
                    <FormLabel>CreditType</FormLabel>
                  </Col>
                  <Col sm="3">
                    <InputTextbox
                      name="creditMemoType"
                      placeholder="Select creditMemo"
                      onChange={this.onAdvSearchChange}
                      value={criteria.creditMemoType}
                      lookupRequired={true}
                      lookupHandler={this.state.creditMemoTypeLookupHandler}
                    />
                  </Col>
                </Row>
                <Row>
                  <Col sm="2">
                    <FormLabel>Invoice#</FormLabel>
                  </Col>
                  <Col sm="3">
                    <InputTextbox
                      name="invoiceNumber"
                      type="text"
                      placeholder="Enter Invoice#"
                      value={criteria.invoiceNumber}
                      onChange={this.onCriteriaChange}
                    />
                  </Col>
                </Row>
              </div>
            }
          />
          <MultiViewPopup
            popupLvlClass={"popupSizeLevel5"}
            isModulePopup={false}
            isShowPopup={this.state.isShowNonMerchandiseLinePopup}
            closeOnEsc={false}
            closeAlertModalCallBack={
              this.closeNonMerchandiseLineAlertModalCallBack
            }
            title={"Non_Merchandise_Line_Detail"}
            closeOnDocumentClick={false}
            lineFunctionalityForm={this.lineFunctionalityForm}
            alertContainerBox={
              <AlertToolBox
                alertMsgList={this.state.alertMessage}
                alertErrorType={this.state.alertType}
                isShowAlert={this.state.isShowAlertLvl5}
                hideAlertCallBack={this.hideAlertCallBackLvl5}
              />
            }
            content={
              <div>
                <Row>
                  <Col sm="2">
                    <FormLabel>SubType</FormLabel>{" "}
                  </Col>
                  <Col sm="4">
                    <InputTextbox
                      onChange={this.creditsubTypeOnChange}
                      placeholder="creditSubType"
                      name="creditSubType"
                      value={this.state.nonMerchandiseLineData.creditSubType}
                      lookupRequired={true}
                      lookupHandler={this.state.creditSubTypeLookupHandler}
                      showCriteriaDialog={true}
                      enterKeyEventHandler={this.creditsubTypeEnterKeyEvent}
                      autoCompleteListData={
                        this.state.creditsubTypePageListForAutoCompleteList
                      }
                      enableAutoCompleteTextBox={true}
                      displayAutoCompleteList={
                        this.displayCreditsubTypeAutoCompleteList
                      }
                      showAutoCompleteList={
                        this.state.isShowAutoCompleteCreditsubTypeList
                      }
                      readOnly={this.state.disableCMFormFields}
                      disabled={this.state.disableCMFormFields}
                      isMandatory={true}
                    />
                  </Col>
                  <Col sm="2">
                    <FormLabel>Amount</FormLabel>{" "}
                  </Col>
                  <Col sm="4">
                    <NumberFormatInputbox
                      name="lineTotalAmount"
                      className="summary_input text-right"
                      onChange={this.onNonMerchandiseChange}
                      value={this.state.nonMerchandiseLineData.lineTotalAmount}
                      disabled={this.state.disableCMFormFields}
                      decimalScale={2}
                    />
                  </Col>
                </Row>
                <Row>
                  <Col sm="2">
                    <FormLabel>Doc.Type</FormLabel>{" "}
                  </Col>
                  <Col sm="4">
                    <InputTextbox
                      name="documentType"
                      placeholder="Enter DocumentType"
                      onChange={this.onNonMerchandiseChange}
                      value={this.state.nonMerchandiseLineData.documentType}
                      readOnly={this.state.disableCMFormFields}
                      disabled={this.state.disableCMFormFields}
                    />
                  </Col>
                  <Col sm="2">
                    <FormLabel>Doc#</FormLabel>{" "}
                  </Col>
                  <Col sm="4">
                    <InputTextbox
                      name="documentNumber"
                      placeholder="Enter DocumentNumber"
                      onChange={this.onNonMerchandiseChange}
                      value={this.state.nonMerchandiseLineData.documentNumber}
                      readOnly={this.state.disableCMFormFields}
                      disabled={this.state.disableCMFormFields}
                    />
                  </Col>
                </Row>
                <Row>
                  <Col className="text-center">
                    <Button
                      id="fabric_Add_Button"
                      className="header_buttons enterFocus"
                      size="sm"
                      disabled={this.state.disableCMFormFields}
                      onClick={(e) => this.addorUpdateNonMerchandiseLine(e)}
                    >
                      Add/Update
                    </Button>
                    <Button
                      id="fabric_Add_Button"
                      size="sm"
                      disabled={this.state.disableCMFormFields}
                      onClick={(e) => this.clearNonMerchandiseLineValues(e)}
                    >
                      Clear
                    </Button>
                  </Col>
                </Row>
              </div>
            }
          />
        </div>
        <div>
          {" "}
          <MultiViewPopup
            popupLvlClass={"popupSizeLevelX5"}
            isModulePopup={false}
            isShowPopup={this.state.isShowMerchandiseLinePopup}
            closeOnEsc={false}
            closeAlertModalCallBack={
              this.closeMerchandiseLineAlertModalCallBack
            }
            title={"MERCHANDISE LINE"}
            closeOnDocumentClick={false}
            lineFunctionalityForm={this.lineFunctionalityForm}
            alertContainerBox={
              <AlertToolBox
                alertMsgList={this.state.alertMessage}
                alertErrorType={this.state.alertType}
                isShowAlert={this.state.isShowAlertLvl5}
                hideAlertCallBack={this.hideAlertCallBackLvl5}
              />
            }
            headerButtonContainer={
              <div className="floatLeft">
                <Button
                  className="header_buttons enterFocus"
                  size="sm"
                  onClick={(e) => this.addorUpdateMerchandiseLine(e)}
                  disabled={this.state.disableCMFormFields}
                >
                  Add/Update
                </Button>
                <Button
                  className="header_buttons enterFocus"
                  size="sm"
                  disabled={this.state.disableCMFormFields}
                  onClick={(e) => this.clearMerchandiseLineValues(e)}
                >
                  Clear
                </Button>
              </div>
            }
            content={
              <div>
                <Row>
                  <Col sm="2">
                    {" "}
                    <FormLabel>{is3PL ? "Item" : "FabricStyle"}</FormLabel>{" "}
                  </Col>
                  <Col sm="4">
                    <InputTextbox
                      name="fabricStyleCode"
                      onChange={this.onFabricCodeChange}
                      value={this.state.merchandiseLineData.fabricStyleCode}
                      lookupRequired={true}
                      lookupHandler={this.state.fabricLookupHandler}
                      readOnly={true}
                      disabled={true}
                      enterKeyEventHandler={this.fabricCodeEnterKeyEventHandler}
                      autoCompleteListData={
                        this.state.fabricPageListForAutoCompleteList
                      }
                      enableAutoCompleteTextBox={true}
                      displayAutoCompleteList={
                        this.displayAutoFabricCompleteList
                      }
                      showAutoCompleteList={
                        this.state.isShowAutoCompleteFabricList
                      }
                    />{" "}
                  </Col>
                  <Col sm="6">
                    <InputTextbox
                      name="fabricStyleName"
                      type="text"
                      onChange={this.onMerchandiseChange}
                      readOnly={true}
                      value={this.state.merchandiseLineData.fabricStyleName}
                    />{" "}
                  </Col>
                </Row>
                <Row>
                  <Col sm="2">
                    {" "}
                    <FormLabel>Color</FormLabel>{" "}
                  </Col>
                  <Col sm="4">
                    <InputTextbox
                      name="colorCode"
                      onChange={this.onMerchandiseChange}
                      value={this.state.merchandiseLineData.colorCode}
                      lookupRequired={this.state.isShowColorLookup}
                      lookupHandler={this.state.colorLookupHandler}
                      showCriteriaDialog={true}
                      readOnly={true}
                      disabled={true}
                    />{" "}
                  </Col>
                  <Col sm="2">
                    {" "}
                    <FormLabel>Invoice#</FormLabel>{" "}
                  </Col>
                  <Col sm="4">
                    <InputTextbox
                      name="invoiceNumber"
                      type="text"
                      onChange={this.onMerchandiseChange}
                      readOnly={true}
                      value={this.state.merchandiseLineData.invoiceNumber}
                    />{" "}
                  </Col>
                </Row>
                <Row>
                  <Col sm="2">
                    {" "}
                    <FormLabel>Price</FormLabel>{" "}
                  </Col>
                  <Col sm="4">
                    <NumberFormatInputbox
                      value={this.state.merchandiseLineData.price}
                      onChange={this.onMerchandiseChange}
                      className=" text-right"
                      decimalScale={2}
                      name={"price"}
                      disabled={this.state.disableCMFormFields}
                      isMandatory={true}
                    />
                  </Col>{" "}
                  <Col sm="2">
                    {" "}
                    <FormLabel>Width</FormLabel>{" "}
                  </Col>
                  <Col sm="4">
                    <InputTextbox
                      name="widthCode"
                      type="text"
                      onChange={this.onMerchandiseChange}
                      readOnly={true}
                      value={this.state.merchandiseLineData.widthCode}
                    />{" "}
                  </Col>
                </Row>
                <Row>
                  <Col sm="2">
                    <FormLabel>SubType</FormLabel>{" "}
                  </Col>
                  <Col sm="4">
                    <InputTextbox
                      onChange={this.creditSubTypeOnChange}
                      placeholder="creditSubType"
                      name="creditSubType"
                      value={this.state.merchandiseLineData.creditSubType}
                      lookupRequired={true}
                      lookupHandler={this.state.creditSubTypeLookupHandler}
                      showCriteriaDialog={true}
                      enterKeyEventHandler={this.creditSubTypeEnterKeyEvent}
                      autoCompleteListData={
                        this.state.creditSubTypePageListForAutoCompleteList
                      }
                      enableAutoCompleteTextBox={true}
                      displayAutoCompleteList={
                        this.displayCreditSubTypeAutoCompleteList
                      }
                      showAutoCompleteList={
                        this.state.isShowAutoCompleteCreditSubTypeList
                      }
                      readOnly={this.state.disableCMFormFields}
                      disabled={this.state.disableCMFormFields}
                      isMandatory={true}
                    />
                  </Col>
                  <Col sm="2">
                    <FormLabel
                      className="hyperlinklabel"
                      onClick={(e) => this.lnkOnHandQuantityDetailsClick(e)}
                    >
                      TotQty
                    </FormLabel>
                  </Col>
                  <Col sm="4">
                    <NumberFormatInputbox
                      value={
                        this.state.merchandiseLineData.lineTotalReturnQuantity
                      }
                      onChange={this.onMerchandiseChange}
                      className="text-right"
                      decimalScale={2}
                      name={"lineTotalReturnQuantity"}
                      disabled={this.state.disableCMFormFields}
                      isMandatory={true}
                    />
                  </Col>
                </Row>
                <Row>
                  <Col sm="2">
                    {" "}
                    <FormLabel>UOM</FormLabel>{" "}
                  </Col>
                  <Col sm="4">
                    <InputTextbox
                      name="uomCode"
                      type="text"
                      onChange={this.onMerchandiseChange}
                      readOnly={true}
                      value={this.state.merchandiseLineData.uomCode}
                    />{" "}
                  </Col>
                  <Col sm="2">
                    <FormLabel>Location</FormLabel>{" "}
                  </Col>
                  <Col sm="4">
                    <InputTextbox
                      onChange={this.locationOnChange}
                      placeholder="locationCode"
                      name="locationCode"
                      value={this.state.merchandiseLineData.locationCode}
                      lookupRequired={true}
                      lookupHandler={this.state.warehouseLookupHandler}
                      showCriteriaDialog={true}
                      enterKeyEventHandler={this.locationEnterKeyEvent}
                      autoCompleteListData={
                        this.state.locationPageListForAutoCompleteList
                      }
                      enableAutoCompleteTextBox={true}
                      displayAutoCompleteList={
                        this.displayLocationAutoCompleteList
                      }
                      showAutoCompleteList={
                        this.state.isShowAutoCompleteLocationList
                      }
                      readOnly={this.state.disableCMFormFields}
                      disabled={this.state.disableCMFormFields}
                      isMandatory={true}
                    />
                  </Col>
                </Row>
                <Row>
                  <Col sm="2">
                    <FormLabel>Roll Sku</FormLabel>
                    {this.state.is3PL ? (
                      <FormLabel>Inventory#</FormLabel>
                    ) : (
                      <FormLabel>Roll SKU#</FormLabel>
                    )}
                  </Col>
                  <Col sm="4">
                    <InputTextbox
                      name="rollSkuNumber"
                      type="text"
                      placeholder={
                        this.state.is3PL ? " Inventory#" : "Enter Roll SKU#"
                      }
                      value={this.state.merchandiseLineData.rollSkuNumber}
                      onChange={this.onMerchandiseChange}
                      readOnly={true}
                    />
                  </Col>
                  <Col sm="2">
                    <FormLabel>Roll#</FormLabel>
                  </Col>
                  <Col sm="4">
                    <InputTextbox
                      name="rollNumber"
                      type="text"
                      placeholder="Enter rollNumber"
                      value={this.state.merchandiseLineData.rollNumber}
                      onChange={this.onMerchandiseChange}
                      disabled={this.state.disableCMFormFields}
                      isMandatory={true}
                    />
                  </Col>
                </Row>
                <Row>
                  <Col sm="2">
                    <FormLabel>VendorBatch#</FormLabel>
                  </Col>
                  <Col sm="4">
                    <InputTextbox
                      name="vendorBatchNumber"
                      type="text"
                      placeholder="Enter vendorBatchNumber"
                      value={this.state.merchandiseLineData.vendorBatchNumber}
                      onChange={this.onMerchandiseChange}
                      disabled={this.state.disableCMFormFields}
                    />
                  </Col>
                  <Col sm="2">
                    <FormLabel>Box#</FormLabel>
                  </Col>
                  <Col sm="4">
                    <InputTextbox
                      name="boxNumber"
                      type="text"
                      placeholder="Enter boxNumber"
                      value={this.state.merchandiseLineData.boxNumber}
                      onChange={this.onMerchandiseChange}
                      disabled={this.state.disableCMFormFields}
                    />
                  </Col>
                </Row>
                <Row>
                  <Col sm="2">
                    <FormLabel>Amount </FormLabel>{" "}
                  </Col>
                  <Col sm="4">
                    <NumberFormatInputbox
                      value={this.state.merchandiseLineData.lineTotalAmount}
                      onChange={this.onMerchandiseChange}
                      className="summary_input text-right"
                      decimalScale={2}
                      name={"lineTotalAmount"}
                      disabled={true}
                    />
                  </Col>
                  <Col sm="2">
                    <FormLabel>Update Inventory</FormLabel>
                  </Col>
                  <Col sm="3">
                    <InputCheckbox
                      name="isUpdateInventory"
                      type="checkbox"
                      checked={this.state.merchandiseLineData.isUpdateInventory}
                      onChange={this.onMerchandiseChange}
                      disabled={this.state.disableCMFormFields}
                    />
                  </Col>
                </Row>
              </div>
            }
          />
        </div>
        <div>
          {" "}
          <MultiViewPopup
            popupLvlClass={"popupSizeLevel3"}
            isModulePopup={false}
            isShowPopup={this.state.isShowFetchInvoicePopup}
            closeOnEsc={false}
            closeAlertModalCallBack={this.closeAlertModalCallBack}
            title={"Fetch Invoice"}
            closeOnDocumentClick={false}
            lineFunctionalityForm={this.lineFunctionalityForm}
            alertContainerBox={
              <AlertToolBox
                alertMsgList={this.state.alertMessage}
                alertErrorType={this.state.alertType}
                isShowAlert={this.state.isShowAlertLvl3}
                hideAlertCallBack={this.hideAlertCallBackLvl3}
              />
            }
            headerButtonContainer={
              <div className="floatLeft">
                <Button
                  className="header_buttons enterFocus"
                  size="sm"
                  onClick={(e) => this.addInvoiceLinesToReturn(e)}
                >
                  Add Lines
                </Button>
              </div>
            }
            content={
              <div className="popup_inquiry_load_table_body">
                {" "}
                <EditableDataGrid
                  columnsList={this.getInvoiceLinecolumnDefinitions()}
                  dataList={lines}
                  isLoading={false}
                  selectableRows={true}
                  onCheckBoxClick={this.onCheckBoxClick}
                  customStyles={dataTableStyles}
                  fixedHeader={true}
                />
              </div>
            }
          />
        </div>
        <div>
          <MultiViewPopup
            popupLvlClass={"popupSizeLevel2"}
            isModulePopup={false}
            isShowPopup={this.state.isShowRefundPopup}
            closeOnEsc={false}
            closeAlertModalCallBack={this.closeAlertModalCallBack}
            title={"Refund To Customer"}
            closeOnDocumentClick={false}
            lineFunctionalityForm={this.lineFunctionalityForm}
            alertContainerBox={
              <AlertToolBox
                alertMsgList={this.state.alertMessage}
                alertErrorType={this.state.alertType}
                isShowAlert={this.state.isShowAlertLvl2}
                hideAlertCallBack={this.hideAlertCallBackLvl2}
              />
            }
            headerButtonContainer={
              <div className="floatLeft">
                <Button
                  className="header_buttons enterFocus"
                  size="sm"
                  onClick={(e) => this.onRefundClick(e)}
                >
                  Refund
                </Button>
                <Button
                  className="header_buttons enterFocus"
                  size="sm"
                  onClick={(e) => this.ClearRefundDetail(e)}
                >
                  clear
                </Button>
              </div>
            }
            content={
              <div>
                <div>
                  <Row>
                    <Col sm="1">
                      <FormLabel>Credit Memo</FormLabel>
                    </Col>
                    <Col sm="3">
                      <InputTextbox
                        value={cmData.code}
                        onChange={this.onReturnPaymentDetailsChange}
                        className="text-right"
                        name={"code"}
                        disabled={true}
                      />
                    </Col>
                    <Col sm="1">
                      <FormLabel>Customer</FormLabel>
                    </Col>
                    <Col sm="3">
                      <InputTextbox
                        value={cmData.customerCode}
                        onChange={this.onReturnPaymentDetailsChange}
                        className="text-right"
                        name={"customerCode"}
                        disabled={true}
                      />
                    </Col>
                    <Col sm="1">
                      <FormLabel>Grand TotalAmt</FormLabel>
                    </Col>
                    <Col sm="3">
                      <NumberFormatInputbox
                        value={cmData.totalCreditAmount}
                        onChange={this.onReturnPaymentDetailsChange}
                        className="summary_input text-right"
                        decimalScale={2}
                        name={"totalCreditAmount"}
                        disabled={true}
                      />
                    </Col>
                  </Row>
                  <Row>
                    <Col sm="1">
                      <FormLabel>Remaining Credit</FormLabel>
                    </Col>
                    <Col sm="3">
                      <NumberFormatInputbox
                        value={remaining_Credit}
                        onChange={this.onReturnPaymentDetailsChange}
                        className="summary_input text-right"
                        decimalScale={2}
                        name={"remaining_Credit"}
                        disabled={true}
                      />
                    </Col>
                    <Col sm="1">
                      <FormLabel>Previous Refunds</FormLabel>
                    </Col>
                    <Col sm="3">
                      <NumberFormatInputbox
                        value={previous_Refunds}
                        onChange={this.onReturnPaymentDetailsChange}
                        className="summary_input text-right"
                        decimalScale={2}
                        name={"previous_Refunds"}
                        disabled={true}
                      />
                    </Col>
                    <Col sm="1">
                      <FormLabel>RefundTo Customer</FormLabel>
                    </Col>
                    <Col sm="3">
                      <NumberFormatInputbox
                        value={refundTo_Customer}
                        onChange={this.onReturnPaymentDetailsChange}
                        className="summary_input text-right"
                        decimalScale={2}
                        name={"refundTo_Customer"}
                        disabled={true}
                      />
                    </Col>
                  </Row>
                  <Row>
                    <Col sm="1">
                      <FormLabel>Refund Date</FormLabel>
                    </Col>
                    <Col sm="3">
                      <DatePickerComponent_adv
                        name="creditMemoReturnPaymentDate"
                        value={returnPaymentDetail.creditMemoReturnPaymentDate}
                        onChange={this.onReturnPaymentDetailsChange}
                      />
                    </Col>
                  </Row>
                </div>
                <div>
                  <Row>
                    <Col sm="2">
                      <FormLabel className="label_head">Card Details</FormLabel>
                    </Col>
                  </Row>
                  <Row>
                    <Col sm="1">
                      <FormLabel>Card#</FormLabel>
                    </Col>
                    <Col sm="3">
                      <InputTextbox
                        name="cardNumber"
                        type="text"
                        placeholder="Enter Card Number"
                        value={returnPaymentDetail.cardNumber}
                        onChange={this.onReturnPaymentDetailsChange}
                      />
                    </Col>
                    <Col sm="1">
                      <FormLabel>CardAmt</FormLabel>
                    </Col>
                    <Col sm="3">
                      <NumberFormatInputbox
                        name={"cardAmount"}
                        onChange={this.onReturnPaymentDetailsChange}
                        placeholder="Enter CardAmount"
                        value={returnPaymentDetail.cardAmount}
                        className="text-right"
                        decimalScale={2}
                      />
                    </Col>
                    <Col sm="1">
                      <FormLabel>CardHolder Name</FormLabel>
                    </Col>
                    <Col sm="3">
                      <InputTextbox
                        name={"cardHolderName"}
                        onChange={this.onReturnPaymentDetailsChange}
                        value={returnPaymentDetail.cardHolderName}
                        className="text-right"
                      />
                    </Col>
                  </Row>
                  <Row>
                    <Col sm="1">
                      <FormLabel>CardType</FormLabel>
                    </Col>
                    <Col sm="3">
                      <InputTextbox
                        name="cardType"
                        onChange={this.onReturnPaymentDetailsChange}
                        value={returnPaymentDetail.cardType}
                        // readOnly={this.state.isDisableFields}
                        // disabled={this.state.isDisableFields}
                      />
                    </Col>
                    <Col sm="1">
                      <FormLabel>Month / Year</FormLabel>
                    </Col>
                    <Col sm="2">
                      <InputTextbox
                        name="cardExpiryMonth"
                        type="text"
                        placeholder="Enter Expire Month"
                        value={returnPaymentDetail.cardExpiryMonth}
                        onChange={this.onReturnPaymentDetailsChange}
                      />
                    </Col>
                    {/* <Col sm="0.5">
                      <FormLabel>/</FormLabel>
                    </Col> */}
                    <Col sm="2">
                      <InputTextbox
                        name="cardExpiryYear"
                        type="text"
                        placeholder="Enter Expire Year"
                        value={returnPaymentDetail.cardExpiryYear}
                        onChange={this.onReturnPaymentDetailsChange}
                      />
                    </Col>
                  </Row>
                </div>
                <div>
                  <Row>
                    <Col>
                      <FormLabel className="label_head">Cash Details</FormLabel>
                    </Col>
                  </Row>
                  <Row>
                    {" "}
                    <Col sm="1">
                      <FormLabel>Cash Amt</FormLabel>
                    </Col>
                    <Col sm="3">
                      <NumberFormatInputbox
                        name={"cashAmount"}
                        onChange={this.onReturnPaymentDetailsChange}
                        value={returnPaymentDetail.cashAmount}
                        className="text-right"
                        decimalScale={2}
                      />
                    </Col>
                  </Row>
                </div>
                <div>
                  <Row>
                    <Col>
                      <FormLabel className="label_head">
                        Check Details
                      </FormLabel>
                    </Col>
                  </Row>
                  <Row>
                    <Col sm="1">
                      <FormLabel>Check#</FormLabel>
                    </Col>
                    <Col sm="3">
                      <InputTextbox
                        name="checkNumber"
                        type="text"
                        placeholder="Enter Check Number"
                        value={returnPaymentDetail.checkNumber}
                        onChange={this.onReturnPaymentDetailsChange}
                      />
                    </Col>
                    <Col sm="1">
                      <FormLabel>CheckAmt</FormLabel>
                    </Col>
                    <Col sm="3">
                      <NumberFormatInputbox
                        name={"checkAmount"}
                        onChange={this.onReturnPaymentDetailsChange}
                        placeholder="Enter CheckAmount"
                        value={returnPaymentDetail.checkAmount}
                        className="text-right"
                        decimalScale={2}
                      />
                    </Col>
                    <Col sm="1">
                      <FormLabel>CheckDate</FormLabel>
                    </Col>
                    <Col sm="3">
                      <DatePickerComponent_adv
                        name="checkDate"
                        value={returnPaymentDetail.checkDate}
                        onChange={this.onReturnPaymentDetailsChange}
                      />
                    </Col>
                  </Row>
                  <Row>
                    <Col sm="1">
                      <FormLabel>BankName</FormLabel>
                    </Col>
                    <Col sm="3">
                      <InputTextbox
                        name="bankName"
                        type="text"
                        placeholder="Enter BankName"
                        value={returnPaymentDetail.bankName}
                        onChange={this.onReturnPaymentDetailsChange}
                      />
                    </Col>
                  </Row>
                  <Row>
                    <Col sm="1">
                      <FormLabel>Remarks</FormLabel>
                    </Col>
                  </Row>
                  <Row>
                    {" "}
                    <Col>
                      <textarea
                        style={text_Area_Style}
                        className="form-control"
                        type="text"
                        name="remarks"
                        value={returnPaymentDetail.remarks}
                        onChange={this.onReturnPaymentDetailsChange}
                      />
                    </Col>
                  </Row>
                </div>
              </div>
            }
          />
        </div>
        <div>
          <MultiViewPopup
            popupLvlClass={"popupSizeLevel2"}
            isModulePopup={false}
            isShowPopup={this.state.isShowApplyInvoicePopup}
            closeOnEsc={false}
            closeAlertModalCallBack={this.closeAlertModalCallBack}
            title={"Apply To Invoice"}
            closeOnDocumentClick={false}
            lineFunctionalityForm={this.lineFunctionalityForm}
            alertContainerBox={
              <AlertToolBox
                alertMsgList={this.state.alertMessage}
                alertErrorType={this.state.alertType}
                isShowAlert={this.state.isShowAlertLvl2}
                hideAlertCallBack={this.hideAlertCallBackLvl2}
              />
            }
            headerButtonContainer={
              <div className="floatLeft">
                <Button
                  size="sm"
                  className="header_buttons enterFocus"
                  onClick={(e) => this.onPostALLClick(e)}
                >
                  PostALL
                </Button>
              </div>
            }
            content={
              <div>
                <div>
                  <Row>
                    <Col sm="1">
                      <FormLabel>Credit Memo</FormLabel>{" "}
                    </Col>
                    <Col sm="3">
                      <InputTextbox
                        value={cmData.code}
                        name={"code"}
                        disabled={true}
                      />
                    </Col>
                    <Col sm="1">
                      <FormLabel>Customer</FormLabel>{" "}
                    </Col>
                    <Col sm="3">
                      <InputTextbox
                        value={cmData.customerCode}
                        name={"customerCode"}
                        disabled={true}
                      />
                    </Col>
                    <Col sm="4">
                      <InputTextbox
                        value={cmData.customerName}
                        name={"customerName"}
                        disabled={true}
                      />
                    </Col>
                  </Row>
                  <Row>
                    <Col sm="1">
                      <FormLabel>TotCredit Amt</FormLabel>{" "}
                    </Col>
                    <Col sm="3">
                      <NumberFormatInputbox
                        value={cmData.totalCreditAmount}
                        className="summary_input text-right"
                        decimalScale={2}
                        name={"totalCreditAmount"}
                        disabled={true}
                      />
                    </Col>
                    <Col sm="1">
                      <FormLabel>Already Applied</FormLabel>{" "}
                    </Col>
                    <Col sm="3">
                      <NumberFormatInputbox
                        value={already_AppliedAmount_Total_Calc}
                        name="already_AppliedAmount_Total_Calc"
                        onChange={this.onChange}
                        className="summary_input text-right"
                        decimalScale={2}
                        disabled={true}
                      />
                    </Col>
                    <Col sm="1">
                      <FormLabel>Current Applied</FormLabel>{" "}
                    </Col>
                    <Col sm="3">
                      <NumberFormatInputbox
                        value={currently_Applied_Amount}
                        name="currently_Applied_Amount"
                        onChange={this.onChange}
                        className="summary_input text-right"
                        decimalScale={2}
                        disabled={true}
                      />
                    </Col>
                  </Row>
                  <Row>
                    <Col sm="1">
                      <FormLabel>Open Amt</FormLabel>{" "}
                    </Col>
                    <Col sm="3">
                      <NumberFormatInputbox
                        value={remaingAmount_Calc}
                        name="remaingAmount_Calc"
                        onChange={this.onChange}
                        className="summary_input text-right"
                        decimalScale={2}
                        disabled={true}
                      />
                    </Col>
                    <Col sm="1">
                      <FormLabel>Currency</FormLabel>{" "}
                    </Col>
                    <Col sm="3">
                      <NumberFormatInputbox
                        value={cmData.companyCurrencyCode}
                        decimalScale={2}
                        disabled={true}
                      />
                    </Col>
                  </Row>
                </div>

                <div className="div_Custom_1">
                  <Table id="fabrics_tables_default">
                    <thead>
                      <tr>
                        <th
                          onClick={(e) =>
                            this.handleSortingArLinesChange(
                              e,
                              "accountReceivableNumber",
                            )
                          }
                        >
                          Ar#
                          {this.state.order === "desc" &&
                          this.state.sortField === "accountReceivableNumber" ? (
                            <span className="drp-dwn-cntr">
                              <DropDwnUp />
                            </span>
                          ) : (
                            <span className="drp-dwn-cntr">
                              <DropDwnDown />
                            </span>
                          )}
                        </th>
                        <th
                          onClick={(e) =>
                            this.handleSortingArLinesChange(e, "arDate")
                          }
                        >
                          ARDate
                          {this.state.order === "desc" &&
                          this.state.sortField === "arDate" ? (
                            <span className="drp-dwn-cntr">
                              <DropDwnUp />
                            </span>
                          ) : (
                            <span className="drp-dwn-cntr">
                              <DropDwnDown />
                            </span>
                          )}
                        </th>
                        <th
                          onClick={(e) =>
                            this.handleSortingArLinesChange(e, "invoiceNumber")
                          }
                        >
                          Invoice
                          {this.state.order === "desc" &&
                          this.state.sortField === "invoiceNumber" ? (
                            <span className="drp-dwn-cntr">
                              <DropDwnUp />
                            </span>
                          ) : (
                            <span className="drp-dwn-cntr">
                              <DropDwnDown />
                            </span>
                          )}
                        </th>
                        <th
                          onClick={(e) =>
                            this.handleSortingArLinesChange(e, "invoiceDate")
                          }
                        >
                          InvoiceDate
                          {this.state.order === "desc" &&
                          this.state.sortField === "invoiceDate" ? (
                            <span className="drp-dwn-cntr">
                              <DropDwnUp />
                            </span>
                          ) : (
                            <span className="drp-dwn-cntr">
                              <DropDwnDown />
                            </span>
                          )}
                        </th>
                        <th
                          onClick={(e) =>
                            this.handleSortingArLinesChange(
                              e,
                              "customerPurchaseOrderNumber",
                            )
                          }
                        >
                          CustomerPo
                          {this.state.order === "desc" &&
                          this.state.sortField ===
                            "customerPurchaseOrderNumber" ? (
                            <span className="drp-dwn-cntr">
                              <DropDwnUp />
                            </span>
                          ) : (
                            <span className="drp-dwn-cntr">
                              <DropDwnDown />
                            </span>
                          )}
                        </th>
                        <th
                          onClick={(e) =>
                            this.handleSortingArLinesChange(
                              e,
                              "grantTotalAmount",
                            )
                          }
                        >
                          GrantTotalAmt
                          {this.state.order === "desc" &&
                          this.state.sortField === "grantTotalAmount" ? (
                            <span className="drp-dwn-cntr">
                              <DropDwnUp />
                            </span>
                          ) : (
                            <span className="drp-dwn-cntr">
                              <DropDwnDown />
                            </span>
                          )}
                        </th>
                        <th
                          onClick={(e) =>
                            this.handleSortingArLinesChange(
                              e,
                              "openInvoiceAmount",
                            )
                          }
                        >
                          openAmount
                          {this.state.order === "desc" &&
                          this.state.sortField === "openInvoiceAmount" ? (
                            <span className="drp-dwn-cntr">
                              <DropDwnUp />
                            </span>
                          ) : (
                            <span className="drp-dwn-cntr">
                              <DropDwnDown />
                            </span>
                          )}
                        </th>
                        <th
                          onClick={(e) =>
                            this.handleSortingArLinesChange(e, "paidAmount")
                          }
                        >
                          PaidAmt
                          {this.state.order === "desc" &&
                          this.state.sortField === "paidAmount" ? (
                            <span className="drp-dwn-cntr">
                              <DropDwnUp />
                            </span>
                          ) : (
                            <span className="drp-dwn-cntr">
                              <DropDwnDown />
                            </span>
                          )}
                        </th>
                        <th
                          onClick={(e) =>
                            this.handleSortingArLinesChange(
                              e,
                              "creditMemoAppliedAmount",
                            )
                          }
                        >
                          CreditApplied
                          {this.state.order === "desc" &&
                          this.state.sortField === "creditMemoAppliedAmount" ? (
                            <span className="drp-dwn-cntr">
                              <DropDwnUp />
                            </span>
                          ) : (
                            <span className="drp-dwn-cntr">
                              <DropDwnDown />
                            </span>
                          )}
                        </th>
                        <th></th>
                      </tr>
                    </thead>
                    {arLines != null ? (
                      <tbody>
                        {arLines.map((ln, index) => (
                          <tr key={index}>
                            <td>
                              <Button
                                variant="secondry"
                                className="hyperLinkText"
                                onClick={(e) =>
                                  this.handleARHyperLinkClick(
                                    e,
                                    ln.accountReceivableNumber,
                                    ln,
                                  )
                                }
                              >
                                {ln.accountReceivableNumber}
                              </Button>
                            </td>
                            <td>{ln.arDate}</td>
                            <td>
                              <Button
                                size="sm"
                                variant="secondry"
                                className="hyperLinkText"
                                onClick={(e) =>
                                  this.viewInvoiceModule(e, ln.invoiceNumber)
                                }
                              >
                                {ln.invoiceNumber}
                              </Button>
                            </td>
                            <td>{ln.invoiceDate}</td>
                            <td>{ln.customerPurchaseOrderNumber}</td>
                            <td className="text-end">{ln.grantTotalAmount}</td>
                            <td className="text-end">{ln.openInvoiceAmount}</td>
                            <td className="text-end">{ln.paidAmount}</td>
                            <td className="text-end">
                              {ln.creditMemoAppliedAmount}
                            </td>
                            {ln.accountReceivableNumber === "NEW" && (
                              <td>
                                <Button
                                  onClick={(e) =>
                                    this.deleteAppliedToInvoiceLine(e, ln)
                                  }
                                >
                                  <DeleteIcon />
                                </Button>
                              </td>
                            )}
                          </tr>
                        ))}
                      </tbody>
                    ) : null}
                  </Table>
                  {arLines.length != 0 ? null : (
                    <div className="no_Data_small">{"NO DATA"}</div>
                  )}
                </div>
                <div>
                  <Row>
                    <Col>
                      <FormLabel>Credit Applied To Invoice</FormLabel>{" "}
                    </Col>
                  </Row>
                  <Row>
                    <Col sm="1">
                      <FormLabel
                        className="hyperLinkText"
                        onClick={(e) =>
                          this.viewInvoiceModule(e, currentARLine.invoiceNumber)
                        }
                      >
                        Invoice
                      </FormLabel>{" "}
                    </Col>
                    <Col sm="3">
                      <InputTextbox
                        onChange={this.applyInvoiceOnChange}
                        placeholder="invoiceNumber"
                        name="invoiceNumber"
                        ref={this.applytoInvoiceNumberRef}
                        value={currentARLine.invoiceNumber}
                        lookupRequired={true}
                        lookupHandler={this.state.invoiceLookupHandler}
                        showCriteriaDialog={true}
                        enterKeyEventHandler={this.applyInvoiceEnterKeyEvent}
                        autoCompleteListData={
                          this.state.applyInvoicePageListForAutoCompleteList
                        }
                        enableAutoCompleteTextBox={true}
                        displayAutoCompleteList={
                          this.displayapplyInvoiceAutoCompleteList
                        }
                        showAutoCompleteList={
                          this.state.isShowAutoCompleteapplyInvoiceList
                        }
                        isMandatory={true}
                      />
                    </Col>
                    <Col sm="1">
                      <FormLabel>PO#</FormLabel>{" "}
                    </Col>
                    <Col sm="3">
                      <InputTextbox
                        name="customerPurchaseOrderNumber"
                        type="text"
                        placeholder=""
                        onChange={this.currentARLineChange}
                        readOnly={true}
                        value={currentARLine.customerPurchaseOrderNumber}
                      />
                    </Col>
                    <Col sm="1">
                      <FormLabel>PaymentDate</FormLabel>{" "}
                    </Col>
                    <Col sm="3">
                      <DatePickerComponent_adv
                        name="arDate"
                        value={currentARLine.arDate}
                        onChange={this.currentARLineChange}
                        isMandatory={true}
                      />
                    </Col>
                  </Row>
                  <Row>
                    <Col sm="1">
                      <FormLabel>Open InvoiceAmt</FormLabel>{" "}
                    </Col>
                    <Col sm="3">
                      <NumberFormatInputbox
                        name="openInvoiceAmount"
                        placeholder="OpenInvoiceAmount"
                        onChange={this.currentARLineChange}
                        value={currentARLine.openInvoiceAmount}
                        disabled={true}
                        className="text-right"
                        decimalScale={2}
                      />
                    </Col>
                    <Col sm="1">
                      <FormLabel>GrantTotal Amt</FormLabel>{" "}
                    </Col>
                    <Col sm="3">
                      <NumberFormatInputbox
                        name="grantTotalAmount"
                        onChange={this.currentARLineChange}
                        value={currentARLine.grantTotalAmount}
                        disabled={true}
                        className="text-right"
                        decimalScale={2}
                      />
                    </Col>
                    <Col sm="1">
                      <FormLabel>AppliedAmt</FormLabel>{" "}
                    </Col>
                    <Col sm="3">
                      <NumberFormatInputbox
                        name="creditAppliedAmount"
                        placeholder="creditAppliedAmount"
                        onChange={this.currentARLineChange}
                        value={currentARLine.creditAppliedAmount}
                        className="text-right"
                        decimalScale={2}
                        isMandatory={true}
                      />
                    </Col>
                  </Row>
                  <Row>
                    <Col className="text-center">
                      <Button
                        id="fabric_Add_Button"
                        size="sm"
                        onClick={(e) => this.onAddorUpdateArLineClick(e)}
                      >
                        Add/Update
                      </Button>
                      <Button
                        id="fabric_Add_Button"
                        size="sm"
                        onClick={(e) => this.onClearArLineClick(e)}
                      >
                        Clear
                      </Button>
                    </Col>
                  </Row>
                </div>
              </div>
            }
          />
        </div>
      </div>
    );
  }
}
class CreditMemoListForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      //
    };
    this.searchRef = React.createRef();
  }
  componentDidMount() {
    if (this.searchRef.current != null) {
      this.searchRef.current.focus();
    }
  }
  listFormOnChange = (e) => {
    this.props.listFormOnChange(e);
  };
  advanceSearch = (e) => {
    if (e.detail == 1) this.props.advanceSearch();
  };
  filter = (e) => {
    if (e.detail == 1) this.props.filter();
  };
  resetFilter = (e) => {
    if (e.detail == 1) this.props.resetFilter();
  };
  loadFirst = (e) => {
    if (e.detail == 1) this.props.loadFirst();
  };
  loadNext = (e) => {
    if (e.detail == 1) this.props.loadNext();
  };
  loadPrevious = (e) => {
    if (e.detail == 1) this.props.loadPrevious();
  };
  loadLast = (e) => {
    if (e.detail == 1) this.props.loadLast();
  };
  editCreditMemo = (e, val) => {
    if (e.detail == 1) this.props.editCreditMemo(val);
  };
  handleSortingChange = (e, accessor) => {
    if (e.detail == 1) this.props.handleSortingChange(accessor);
  };
  onKeyDown = (e) => {
    if (e.keyCode == 13) {
      this.props.filter();
    }
  };
  render() {
    let creditMemo_list = new Array();
    creditMemo_list = this.props.creditMemo_list;
    let criteria = this.props.criteria;
    let pageList = this.props.pageList;
    let totalPages = 0;
    let pageSize = pageList.pageSize;
    let totalCount = pageList.totalCount;
    totalPages = totalCount / pageSize;
    totalPages += totalCount % pageSize == 0 ? 0 : 1;
    return (
      <div>
        <div className="secondary_module_header">
          {/* <div className="secondary_module_header_title">
            <FormLabel className="secondary_module_search_color">
              Search
            </FormLabel>
            <span className="secondary_module_header_title_2">
              <InputTextbox
                ref={this.searchRef}
                name="creditMemoNumberContains"
                type="text"
                value={criteria.creditMemoNumberContains}
                placeholder="Enter Value to Filter.."
                onChange={this.listFormOnChange}
                onKeyDown={this.onKeyDown}
              />
            </span>
            <span className="px-2"></span>
            <span className="px-2"></span>
            <Button size="sm" onClick={(e) => this.filter(e)}>
              Filter
            </Button>
            <span className="px-2"></span>
            <Button size="sm" onClick={(e) => this.resetFilter(e)}>
              Reset
            </Button>
          </div> */}
          <div className="mdle-criteria-wrap">
            <div className="">
              <FormLabel className="criteria-labl">Status</FormLabel>
            </div>
            <div className="criteria-val">
              <FormControl
                as="select"
                custom
                onChange={this.listFormOnChange}
                name="creditMemoStatus"
                value={criteria.creditMemoStatus}
              >
                <option value={""}>All</option>
                <option value={"O"}>Open</option>
                <option value={"A"}>Approved</option>
                <option value={"U"}>UnApproved</option>
                <option value={"F"}>Finished</option>
                <option value={"P"}>Partially Closed</option>
                <option value={"C"}>Partially Used && Approved</option>
                <option value={"X"}>Cancelled</option>
              </FormControl>
            </div>
            <div className="">
              <FormLabel className="criteria-labl">Search</FormLabel>
            </div>
            <div className="criteria-val">
              <InputTextbox
                ref={this.searchRef}
                name="creditMemoNumberContains"
                type="text"
                value={criteria.creditMemoNumberContains}
                placeholder="Enter Value to Filter.."
                onChange={this.listFormOnChange}
                onKeyDown={this.onKeyDown}
              />
            </div>
            <div className="criteria-btn-wrap ">
              <Button
                className="header_buttons secondary"
                size="sm"
                onClick={(e) => this.filter(e)}
              >
                Filter
              </Button>
              <Button
                className="header_buttons secondary"
                size="sm"
                onClick={(e) => this.resetFilter(e)}
              >
                Reset
              </Button>
            </div>
          </div>
          <div className="module_header_secondary_buttons">
            <span>
              PAGE - {pageList.currentPage} OF {parseInt(totalPages)}
            </span>
            <Button
              size="sm"
              className="secondary_header_buttons"
              onClick={(e) => this.loadFirst(e)}
            >
              First
            </Button>
            <Button
              size="sm"
              className="secondary_header_buttons"
              onClick={(e) => this.loadPrevious(e)}
            >
              Previous
            </Button>
            <Button
              size="sm"
              className="secondary_header_buttons"
              onClick={(e) => this.loadNext(e)}
            >
              Next
            </Button>
            <Button
              size="sm"
              className="secondary_header_buttons"
              onClick={(e) => this.loadLast(e)}
            >
              Last
            </Button>
          </div>
        </div>
        <div className="div_default">
          <Table id="fabrics_tables_default">
            <thead>
              <tr>
                <th onClick={(e) => this.handleSortingChange(e, "code")}>
                  CM#
                  {this.props.order === "desc" &&
                  this.props.sortField === "code" ? (
                    <span className="drp-dwn-cntr">
                      <DropDwnUp />
                    </span>
                  ) : (
                    <span className="drp-dwn-cntr">
                      <DropDwnDown />
                    </span>
                  )}
                </th>
                <th
                  onClick={(e) => this.handleSortingChange(e, "customerCode")}
                >
                  CustomerCode
                  {this.props.order === "desc" &&
                  this.props.sortField === "customerCode" ? (
                    <span className="drp-dwn-cntr">
                      <DropDwnUp />
                    </span>
                  ) : (
                    <span className="drp-dwn-cntr">
                      <DropDwnDown />
                    </span>
                  )}
                </th>
                <th
                  onClick={(e) => this.handleSortingChange(e, "customerName")}
                >
                  CustomerName
                  {this.props.order === "desc" &&
                  this.props.sortField === "customerName" ? (
                    <span className="drp-dwn-cntr">
                      <DropDwnUp />
                    </span>
                  ) : (
                    <span className="drp-dwn-cntr">
                      <DropDwnDown />
                    </span>
                  )}
                </th>
                <th onClick={(e) => this.handleSortingChange(e, "creditType")}>
                  CreditType
                  {this.props.order === "desc" &&
                  this.props.sortField === "creditType" ? (
                    <span className="drp-dwn-cntr">
                      <DropDwnUp />
                    </span>
                  ) : (
                    <span className="drp-dwn-cntr">
                      <DropDwnDown />
                    </span>
                  )}
                </th>
                <th
                  onClick={(e) => this.handleSortingChange(e, "invoiceNumber")}
                >
                  Invoice
                  {this.props.order === "desc" &&
                  this.props.sortField === "invoiceNumber" ? (
                    <span className="drp-dwn-cntr">
                      <DropDwnUp />
                    </span>
                  ) : (
                    <span className="drp-dwn-cntr">
                      <DropDwnDown />
                    </span>
                  )}
                </th>
                <th
                  onClick={(e) => this.handleSortingChange(e, "creditMemoDate")}
                >
                  CMDate
                  {this.props.order === "desc" &&
                  this.props.sortField === "creditMemoDate" ? (
                    <span className="drp-dwn-cntr">
                      <DropDwnUp />
                    </span>
                  ) : (
                    <span className="drp-dwn-cntr">
                      <DropDwnDown />
                    </span>
                  )}
                </th>
                <th
                  onClick={(e) =>
                    this.handleSortingChange(e, "customerCurrencyCode")
                  }
                >
                  Currency
                  {this.props.order === "desc" &&
                  this.props.sortField === "customerCurrencyCode" ? (
                    <span className="drp-dwn-cntr">
                      <DropDwnUp />
                    </span>
                  ) : (
                    <span className="drp-dwn-cntr">
                      <DropDwnDown />
                    </span>
                  )}
                </th>
                <th
                  onClick={(e) =>
                    this.handleSortingChange(e, "totalCreditAmount")
                  }
                >
                  CreditAmt
                  {this.props.order === "desc" &&
                  this.props.sortField === "totalCreditAmount" ? (
                    <span className="drp-dwn-cntr">
                      <DropDwnUp />
                    </span>
                  ) : (
                    <span className="drp-dwn-cntr">
                      <DropDwnDown />
                    </span>
                  )}
                </th>
                <th
                  onClick={(e) => this.handleSortingChange(e, "appliedAmount")}
                >
                  AppliedAmt
                  {this.props.order === "desc" &&
                  this.props.sortField === "appliedAmount" ? (
                    <span className="drp-dwn-cntr">
                      <DropDwnUp />
                    </span>
                  ) : (
                    <span className="drp-dwn-cntr">
                      <DropDwnDown />
                    </span>
                  )}
                </th>
                <th
                  onClick={(e) =>
                    this.handleSortingChange(e, "creditMemoStatus")
                  }
                >
                  Status
                  {this.props.order === "desc" &&
                  this.props.sortField === "creditMemoStatus" ? (
                    <span className="drp-dwn-cntr">
                      <DropDwnUp />
                    </span>
                  ) : (
                    <span className="drp-dwn-cntr">
                      <DropDwnDown />
                    </span>
                  )}
                </th>
              </tr>
            </thead>
            {creditMemo_list != null ? (
              <tbody>
                {creditMemo_list.map((ln, index) => (
                  <tr key={index}>
                    <td className="hyperLinkText">
                      <Button
                        variant="secondry"
                        className="hyperLinkText"
                        onClick={(e) => this.editCreditMemo(e, ln.code)}
                      >
                        {ln.code}
                      </Button>
                    </td>
                    <td>{ln.customerCode}</td>
                    <td>{ln.customerName}</td>
                    <td>{ln.creditType}</td>
                    <td>{ln.invoiceNumber}</td>
                    <td>{ModuleUtils.getDateFormat_v1(ln.creditMemoDate)}</td>
                    <td>{ln.customerCurrencyCode}</td>
                    <td className="text-end">
                      {toCommaSeperatedAmount(ln.totalCreditAmount)}
                    </td>
                    <td className="text-end">
                      {toCommaSeperatedAmount(ln.appliedAmount)}
                    </td>
                    <td>
                      {ModuleUtils.getCreditMemoStatusCaption(
                        ln.creditMemoStatus,
                      )}
                    </td>
                  </tr>
                ))}
              </tbody>
            ) : null}
          </Table>
          {creditMemo_list.length != 0 ? null : (
            <div className="no_Data">{"NO DATA"}</div>
          )}
        </div>
      </div>
    );
  }
}
class CreditMemoEntryForm extends React.Component {
  static contextType = AppContext;
  constructor(props) {
    super(props);
    this.custCodeRef = React.createRef();
    this.invCodeRef = React.createRef();
    this.state = {
      //
    };
  }
  componentDidMount() {
    const { appData } = this.context;
    this.companyCode = appData.companyCode;
    this.setInputFocus();
    this.initLookupHandlers();
  }
  setInputFocus = () => {
    if (this.props.isFocus == true) this.custCodeRef.current.focus();
  };
  initLookupHandlers = () => {
    let creditTypeLookupHandler = new GenericAttributeLookupHandler(
      this.props.creditMemoTypes,
      "Credit Memo Type",
    );
    this.setState({ creditTypeLookupHandler: creditTypeLookupHandler });
    let customerLookupHandler = new CustomerLookupHandler(
      this.companyCode,
      "Customer",
    );
    this.setState({
      customerLookupHandler: customerLookupHandler,
    });
  };
  onChange = (e) => {
    this.props.onChange(e);
  };
  onCustomerCodeChange = (e) => {
    this.props.onCustomerCodeChange(e);
  };
  customerCodeEnterKeyEventHandler = (e) => {
    this.props.customerCodeEnterKeyEventHandler(e);
  };
  displayAutoCustomerCompleteList = (list) => {
    this.props.displayAutoCustomerCompleteList(list);
  };
  fetchInvoiceOnClick = (e) => {
    if (e.detail == 1) this.props.fetchInvoiceOnClick();
  };
  onAddNonMerchandiseLineClick = (e) => {
    if (e.detail == 1) this.props.onAddNonMerchandiseLineClick();
  };
  openNonMerchandiseLineDetailDialog = (e) => {
    if (e.detail == 1) this.props.openNonMerchandiseLineDetailDialog(e);
  };
  openMerchandiseLineDetailDialog = (e) => {
    if (e.detail == 1) this.props.openMerchandiseLineDetailDialog(e);
  };
  getNonMerchandiseLineDetails = (rowData) => {
    this.props.getNonMerchandiseLineDetails(rowData);
    this.props.openNonMerchandiseLineDetailDialog();
  };
  handleNonMerchandiseLineClick = (e, val, rowData) => {
    if (e.detail == 1) this.getNonMerchandiseLineDetails(rowData);
  };
  getMerchandiseLineDetails = (rowData) => {
    this.props.getMerchandiseLineDetails(rowData);
    this.props.openMerchandiseLineDetailDialog();
  };
  handleMerchandiseLineClick = (e, val, rowData) => {
    if (e.detail == 1) this.getMerchandiseLineDetails(rowData);
  };
  viewInvoiceModule = (rowData) => {
    this.props.viewInvoiceModule(rowData);
  };
  viewARModule = (rowData) => {
    this.props.viewARModule(rowData);
  };
  closeModalCallBack = (isShowPopup) => {
    this.props.closeModalCallBack(isShowPopup);
  };
  closeAlertModalCallBack = (isShowPopup) => {
    this.setState({
      isShowUnApprovePopup: isShowPopup,
      isShowAlert: isShowPopup,
    });
  };
  lnkCustomerModule = (e, code) => {
    if (e.detail == 1) this.props.lnkCustomerModule(code);
  };
  openCustomerOnOrderInq = (e, code) => {
    if (e.detail == 1) this.props.openCustomerOnOrderInq(code);
  };
  openCustomerTransactionsInq = (e, code) => {
    if (e.detail == 1) this.props.openCustomerTransactionsInq(code);
  };
  openCustomerStatisticsInq = (e, code) => {
    if (e.detail == 1) this.props.openCustomerStatisticsInq(code);
  };
  openCustomerSalesHistoryInq = (e, code) => {
    if (e.detail == 1) this.props.openCustomerSalesHistoryInq(code);
  };
  openCustomerMostRecentFabricsInq = (e, code) => {
    if (e.detail == 1) this.props.openCustomerMostRecentFabricsInq(code);
  };
  openCustomerCurrentAgingInq = (e, code) => {
    if (e.detail == 1) this.props.openCustomerCurrentAgingInq(code);
  };
  deleteMerchandiseLine = (e, rowData) => {
    if (e.detail == 1) this.props.deleteMerchandiseLine(rowData);
  };
  deleteNonMerchandiseLine = (e, rowData) => {
    if (e.detail == 1) this.props.deleteNonMerchandiseLine(rowData);
  };
  hideAlertCallBack = (msgType, isDisplayed) => {
    this.props.hideAlertCallBack(msgType, isDisplayed);
  };
  creditTypeOnChange = (e) => {
    this.props.creditTypeOnChange(e);
  };
  creditTypeEnterKeyEvent = (e) => {
    this.props.creditTypeEnterKeyEvent(e);
  };
  displayCreditTypeAutoCompleteList = (showAutoCompleteList) => {
    this.props.displayCreditTypeAutoCompleteList(showAutoCompleteList);
  };
  setUpdateInventory = (e) => {
    this.props.setUpdateInventory(e);
  };
  onBillToChange = (e) => {
    this.props.onBillToChange(e);
  };
  billToToEnterKeyEvent = (e) => {
    this.props.billToToEnterKeyEvent(e);
  };
  displayAutoCompleteBillToList = (showAutoCompleteList) => {
    this.props.displayAutoCompleteBillToList(showAutoCompleteList);
  };

  handleSortingMerchandiseLinesChange = (e, accessor) => {
    if (e.detail === 1)
      this.props.handleSortingMerchandiseLinesChange(accessor);
  };

  handleSortingNonMerchandiseLinesChange = (e, accessor) => {
    if (e.detail === 1)
      this.props.handleSortingNonMerchandiseLinesChange(accessor);
  };

  render() {
    // let cmData = null;
    let disableCMFormFields = this.props.disableCMFormFields;
    let isDisableHeaderFields = this.props.isDisableHeaderFields;
    let cmData = this.props.cmData;
    let merchandiseLines = [];
    merchandiseLines = cmData.merchandiseLines;
    let merchandiseLinesList = this.props.merchandiseLinesList;
    let nonMerchandiseLines = [];
    nonMerchandiseLines = cmData.nonMerchandiseLines;
    let nonMerchandiseLinesList = this.props.nonMerchandiseLinesList;
    const textAreaStyle = {
      height: "12em",
      width: "65em",
      resize: "none",
      padding: "2px",
      boxSizing: "border-box",
      fontSize: "15px",
    };
    let isDisableInvoice = false;
    if (
      cmData.creditMemoStatus == LogicConstants.CREDIT_MEMO_FINISHED_STATUS ||
      cmData.creditMemoStatus == LogicConstants.CREDIT_MEMO_CANCEL_STATUS
    ) {
      isDisableInvoice = true;
    }
    if (this.props.isViewMode) {
      isDisableInvoice = true;
    }
    let is3PL = this.props.is3PL;
    return (
      <div>
        <MultiViewPopup
          isModulePopup={true}
          id="modulePopup"
          popupLvlClass={"popupSizeLevel0"}
          isShowPopup={this.props.isShowARModule}
          closeModalCallBack={this.closeModalCallBack}
          module={this.props.moduleForPopup}
        ></MultiViewPopup>
        <MultiViewPopup
          isModulePopup={true}
          id="modulePopup"
          popupLvlClass={"popupSizeLevel0"}
          isShowPopup={this.props.isShowInvoiceModule}
          closeModalCallBack={this.closeModalCallBack}
          module={this.props.moduleForPopup}
        ></MultiViewPopup>
        <MultiViewPopup
          isModulePopup={true}
          id="modulePopup"
          isShowPopup={this.props.isShowCustomerModule}
          closeModalCallBack={this.closeModalCallBack}
          module={this.props.moduleForPopup}
        ></MultiViewPopup>
        <MultiViewPopup
          popupLvlClass={"popupSizeLevel0"}
          isModulePopup={true}
          id="modulePopup"
          isShowPopup={this.props.isShowCustomerOnOrderInq}
          closeModalCallBack={this.closeModalCallBack}
          module={this.props.moduleForPopup}
        ></MultiViewPopup>
        <MultiViewPopup
          popupLvlClass={"popupSizeLevel0"}
          isModulePopup={true}
          id="modulePopup"
          isShowPopup={this.props.isShowCustomerTransactionsInq}
          closeModalCallBack={this.closeModalCallBack}
          module={this.props.moduleForPopup}
        ></MultiViewPopup>
        <MultiViewPopup
          popupLvlClass={"popupSizeLevel0"}
          isModulePopup={true}
          id="modulePopup"
          isShowPopup={this.props.isShowCustomerStatisticsInq}
          closeModalCallBack={this.closeModalCallBack}
          module={this.props.moduleForPopup}
        ></MultiViewPopup>
        <MultiViewPopup
          popupLvlClass={"popupSizeLevel0"}
          isModulePopup={true}
          id="modulePopup"
          isShowPopup={this.props.isShowCustomerSalesHistoryInq}
          closeModalCallBack={this.closeModalCallBack}
          module={this.props.moduleForPopup}
        ></MultiViewPopup>
        <MultiViewPopup
          popupLvlClass={"popupSizeLevel0"}
          isModulePopup={true}
          id="modulePopup"
          isShowPopup={this.props.isShowCustomerMostRecentFabricsInq}
          closeModalCallBack={this.closeModalCallBack}
          module={this.props.moduleForPopup}
        ></MultiViewPopup>
        <MultiViewPopup
          popupLvlClass={"popupSizeLevel0"}
          isModulePopup={true}
          id="modulePopup"
          isShowPopup={this.props.isCustomerCurrentAgingInq}
          closeModalCallBack={this.closeModalCallBack}
          module={this.props.moduleForPopup}
        ></MultiViewPopup>
        <div className="header_div">
          <div>
            <Row>
              <Col className="align-items-left" sm="1">
                <FormLabel>Date</FormLabel>
              </Col>
              <Col sm="2">
                <DatePickerComponent_adv
                  name="creditMemoDate"
                  value={cmData.creditMemoDate}
                  onChange={this.onChange}
                  disabled={disableCMFormFields}
                  isMandatory={true}
                />
              </Col>
              <Col className="so-align-items-left" sm="1">
                <FormLabel
                  className="hyperlinklabel"
                  onClick={(e) => this.lnkCustomerModule(e)}
                >
                  Customer
                </FormLabel>{" "}
                <Col>
                  {cmData.customerCode != "" &&
                  cmData.customerCode != "NEW" &&
                  cmData.customerCode != undefined ? (
                    <ShortCutMenuPopup
                      value={cmData.customerCode}
                      menuItems={
                        <ul>
                          <li
                            className="shortcut-menu-item"
                            onClick={(e) =>
                              this.openCustomerOnOrderInq(
                                e,
                                cmData.customerCode,
                              )
                            }
                          >
                            {" "}
                            Customer On-Order{" "}
                          </li>
                          <li
                            className="shortcut-menu-item"
                            onClick={(e) =>
                              this.openCustomerTransactionsInq(
                                e,
                                cmData.customerCode,
                              )
                            }
                          >
                            {" "}
                            Customer Transactions{" "}
                          </li>
                          <li
                            className="shortcut-menu-item"
                            onClick={(e) =>
                              this.openCustomerStatisticsInq(
                                e,
                                cmData.customerCode,
                              )
                            }
                          >
                            {" "}
                            Customer Statistics{" "}
                          </li>
                          <li
                            className="shortcut-menu-item"
                            onClick={(e) =>
                              this.openCustomerSalesHistoryInq(
                                e,
                                cmData.customerCode,
                              )
                            }
                          >
                            {" "}
                            Customer Sales History{" "}
                          </li>
                          <li
                            className="shortcut-menu-item"
                            onClick={(e) =>
                              this.openCustomerMostRecentFabricsInq(
                                e,
                                cmData.customerCode,
                              )
                            }
                          >
                            {" "}
                            {is3PL
                              ? "Customer Most Recent Items"
                              : "Customer Most Recent Fabrics"}{" "}
                          </li>
                          <li
                            className="shortcut-menu-item"
                            onClick={(e) =>
                              this.openCustomerCurrentAgingInq(
                                e,
                                cmData.customerCode,
                              )
                            }
                          >
                            {" "}
                            Customer Current Aging{" "}
                          </li>
                        </ul>
                      }
                    />
                  ) : null}
                </Col>
              </Col>
              <Col sm="2">
                <InputTextbox
                  ref={this.custCodeRef}
                  onChange={this.onCustomerCodeChange}
                  name="customerCode"
                  placeholder="Customer"
                  value={cmData.customerCode}
                  lookupRequired={true}
                  lookupHandler={this.state.customerLookupHandler}
                  showCriteriaDialog={true}
                  enterKeyEventHandler={this.customerCodeEnterKeyEventHandler}
                  autoCompleteListData={
                    this.props.customerPageListForAutoCompleteList
                  }
                  enableAutoCompleteTextBox={true}
                  displayAutoCompleteList={this.displayAutoCustomerCompleteList}
                  showAutoCompleteList={
                    this.props.isShowAutoCompleteCustomerList
                  }
                  readOnly={isDisableHeaderFields}
                  disabled={isDisableHeaderFields}
                  isMandatory={true}
                />
              </Col>
              <Col sm="3">
                <InputTextbox
                  name="customerName"
                  type="text"
                  onChange={this.onChange}
                  readOnly={true}
                  value={cmData.customerName}
                />{" "}
              </Col>
              <Col className="align-items-left" sm="1">
                <FormLabel>CreditType</FormLabel>
              </Col>
              <Col sm="2">
                <InputTextbox
                  onChange={this.creditTypeOnChange}
                  placeholder="creditType"
                  name="creditType"
                  value={cmData.creditType}
                  lookupRequired={true}
                  lookupHandler={this.state.creditTypeLookupHandler}
                  showCriteriaDialog={true}
                  enterKeyEventHandler={this.creditTypeEnterKeyEvent}
                  autoCompleteListData={
                    this.props.creditTypePageListForAutoCompleteList
                  }
                  enableAutoCompleteTextBox={true}
                  displayAutoCompleteList={
                    this.displayCreditTypeAutoCompleteList
                  }
                  showAutoCompleteList={
                    this.props.isShowAutoCompleteCreditTypeList
                  }
                  readOnly={isDisableHeaderFields}
                  disabled={isDisableHeaderFields}
                  isMandatory={true}
                />
              </Col>
            </Row>
            <Row>
              <Col className="align-items-left" sm="1">
                <FormLabel>BillTo</FormLabel>
              </Col>
              {/* <Col sm="2">
                <InputTextbox
                  name="billToCode"
                  onChange={this.onChange}
                  value={cmData.billToCode}
                  lookupRequired={this.props.isShowBillToLookup}
                  lookupHandler={this.props.billToLookupHandler}
                  disabled={disableCMFormFields}
                />
              </Col> */}
              <Col sm="2">
                <InputTextbox
                  name="billToCode"
                  onChange={this.onBillToChange}
                  value={cmData.billToCode}
                  lookupRequired={this.props.isShowBillToLookup}
                  lookupHandler={this.props.billToLookupHandler}
                  showCriteriaDialog={true}
                  enterKeyEventHandler={this.billToToEnterKeyEvent}
                  autoCompleteListData={
                    this.props.billToPageListForAutoCompleteList
                  }
                  enableAutoCompleteTextBox={true}
                  displayAutoCompleteList={this.displayAutoCompleteBillToList}
                  showAutoCompleteList={this.props.isShowAutoCompleteBillToList}
                  disabled={isDisableHeaderFields}
                  isMandatory={true}
                />
              </Col>
              <Col className="align-items-left" sm="1">
                <FormLabel>Currency</FormLabel>
              </Col>
              <Col sm="2">
                <InputTextbox
                  name="customerCurrencyCode"
                  onChange={this.onChange}
                  readOnly={true}
                  value={cmData.customerCurrencyCode}
                />
              </Col>
              <Col className="align-items-left" sm="1">
                <FormLabel>CustomerSource</FormLabel>
              </Col>
              <Col sm="2">
                <InputTextbox
                  name="createdSourceType"
                  onChange={this.onChange}
                  readOnly={true}
                  value={cmData.createdSourceType}
                />
              </Col>
              <Col className="align-items-left" sm="1">
                <FormLabel>Auto Gen AR#</FormLabel>
              </Col>
              <Col sm="2">
                <InputTextbox
                  name="autoGeneratedARNumberForInvoiceApply"
                  onChange={this.onChange}
                  readOnly={true}
                  value={cmData.autoGeneratedARNumberForInvoiceApply}
                />
              </Col>
            </Row>
            <Row>
              <Col className="align-items-left" sm="1">
                <FormLabel>Invoice#</FormLabel>
              </Col>
              <Col sm="2">
                <InputTextbox
                  ref={this.invCodeRef}
                  onChange={this.onChange}
                  enterKeyEventHandler={
                    this.props.invoiceCodeEnterKeyEventHandler
                  }
                  name="invoiceNumber"
                  placeholder="Enter Invoice"
                  value={cmData.invoiceNumber}
                  lookupRequired={this.props.isShowInvoiceLookup}
                  lookupHandler={this.props.invoiceLookupHandler}
                  showCriteriaDialog={true}
                  readOnly={isDisableHeaderFields}
                  disabled={isDisableHeaderFields}
                  isMandatory={true}
                />
              </Col>
              <Col sm="2">
                <Button
                  size="sm"
                  id="fabric_Add_Button"
                  disabled={isDisableInvoice}
                  onClick={(e) => this.fetchInvoiceOnClick(e)}
                >
                  FetchInvoice
                </Button>
              </Col>{" "}
              <Col sm="1">
                <FormLabel>UpdateInventory</FormLabel>
              </Col>
              <Col sm="1">
                <InputCheckbox
                  name="isUpdateInventory"
                  type="checkbox"
                  checked={cmData.isUpdateInventory}
                  onChange={this.setUpdateInventory}
                  readOnly={disableCMFormFields}
                  disabled={disableCMFormFields}
                />
              </Col>
              <Col sm="2">
                <Button
                  onClick={(e) => this.onAddNonMerchandiseLineClick(e)}
                  hidden={true}
                >
                  Add NonMerch.
                </Button>
              </Col>
            </Row>
          </div>
          <div className="div_inline">
            <div className="div_60_no_overflow">
              <div className="div_Custom_1">
                <Table id="fabrics_tables">
                  <thead>
                    <tr>
                      <th
                        onClick={(e) =>
                          this.handleSortingMerchandiseLinesChange(
                            e,
                            "lineNumber",
                          )
                        }
                      >
                        {this.props.order === "desc" &&
                        this.props.sortField === "lineNumber" ? (
                          <span className="drp-dwn-cntr">
                            <DropDwnUp />
                          </span>
                        ) : (
                          <span className="drp-dwn-cntr">
                            <DropDwnDown />
                          </span>
                        )}
                        <Button
                          size="sm"
                          onClick={(e) =>
                            this.openMerchandiseLineDetailDialog(e)
                          }
                          disabled={true}
                          id="fabric_Add_Button"
                        >
                          <AddIcon />
                        </Button>
                      </th>
                      <th
                        onClick={(e) =>
                          this.handleSortingMerchandiseLinesChange(
                            e,
                            "fabricStyleCode",
                          )
                        }
                      >
                        {is3PL ? "Item" : "FabricStyle#"}
                        {this.props.order === "desc" &&
                        this.props.sortField === "fabricStyleCode" ? (
                          <span className="drp-dwn-cntr">
                            <DropDwnUp />
                          </span>
                        ) : (
                          <span className="drp-dwn-cntr">
                            <DropDwnDown />
                          </span>
                        )}
                      </th>
                      <th
                        onClick={(e) =>
                          this.handleSortingMerchandiseLinesChange(
                            e,
                            "fabricStyleName",
                          )
                        }
                      >
                        {is3PL ? "ItemName" : "FabricName"}
                        {this.props.order === "desc" &&
                        this.props.sortField === "fabricStyleName" ? (
                          <span className="drp-dwn-cntr">
                            <DropDwnUp />
                          </span>
                        ) : (
                          <span className="drp-dwn-cntr">
                            <DropDwnDown />
                          </span>
                        )}
                      </th>
                      <th
                        onClick={(e) =>
                          this.handleSortingMerchandiseLinesChange(
                            e,
                            "colorCode",
                          )
                        }
                      >
                        Color
                        {this.props.order === "desc" &&
                        this.props.sortField === "colorCode" ? (
                          <span className="drp-dwn-cntr">
                            <DropDwnUp />
                          </span>
                        ) : (
                          <span className="drp-dwn-cntr">
                            <DropDwnDown />
                          </span>
                        )}
                      </th>
                      <th
                        onClick={(e) =>
                          this.handleSortingMerchandiseLinesChange(e, "uomCode")
                        }
                      >
                        Uom
                        {this.props.order === "desc" &&
                        this.props.sortField === "uomCode" ? (
                          <span className="drp-dwn-cntr">
                            <DropDwnUp />
                          </span>
                        ) : (
                          <span className="drp-dwn-cntr">
                            <DropDwnDown />
                          </span>
                        )}
                      </th>
                      <th
                        onClick={(e) =>
                          this.handleSortingMerchandiseLinesChange(
                            e,
                            "lineTotalReturnQuantity",
                          )
                        }
                      >
                        TotalQty
                        {this.props.order === "desc" &&
                        this.props.sortField === "lineTotalReturnQuantity" ? (
                          <span className="drp-dwn-cntr">
                            <DropDwnUp />
                          </span>
                        ) : (
                          <span className="drp-dwn-cntr">
                            <DropDwnDown />
                          </span>
                        )}
                      </th>
                      <th
                        onClick={(e) =>
                          this.handleSortingMerchandiseLinesChange(e, "price")
                        }
                      >
                        Price
                        {this.props.order === "desc" &&
                        this.props.sortField === "price" ? (
                          <span className="drp-dwn-cntr">
                            <DropDwnUp />
                          </span>
                        ) : (
                          <span className="drp-dwn-cntr">
                            <DropDwnDown />
                          </span>
                        )}
                      </th>
                      <th
                        onClick={(e) =>
                          this.handleSortingMerchandiseLinesChange(
                            e,
                            "lineTotalAmount",
                          )
                        }
                      >
                        TotalAmt
                        {this.props.order === "desc" &&
                        this.props.sortField === "lineTotalAmount" ? (
                          <span className="drp-dwn-cntr">
                            <DropDwnUp />
                          </span>
                        ) : (
                          <span className="drp-dwn-cntr">
                            <DropDwnDown />
                          </span>
                        )}
                      </th>
                      <th
                        onClick={(e) =>
                          this.handleSortingMerchandiseLinesChange(
                            e,
                            "invoiceNumber",
                          )
                        }
                      >
                        Invoice#
                        {this.props.order === "desc" &&
                        this.props.sortField === "invoiceNumber" ? (
                          <span className="drp-dwn-cntr">
                            <DropDwnUp />
                          </span>
                        ) : (
                          <span className="drp-dwn-cntr">
                            <DropDwnDown />
                          </span>
                        )}
                      </th>
                      <th></th>
                    </tr>
                  </thead>
                  {merchandiseLinesList != null ? (
                    <tbody>
                      {merchandiseLinesList.map((ln, index) => (
                        <tr key={index}>
                          <td>
                            <Button
                              variant="secondry"
                              className="hyperLinkText"
                              onClick={(e) =>
                                this.handleMerchandiseLineClick(
                                  e,
                                  ln.lineNumber,
                                  ln,
                                )
                              }
                            >
                              {ln.lineNumber}
                            </Button>
                          </td>
                          <td>{ln.fabricStyleCode}</td>
                          <td>{ln.fabricStyleName}</td>
                          <td>{ln.colorCode}</td>
                          <td>{ln.uomCode}</td>
                          <td className="text-right">
                            {ln.lineTotalReturnQuantity}
                          </td>
                          <td className="text-right">{ln.price}</td>
                          <td className="text-right">{ln.lineTotalAmount}</td>
                          <td>{ln.invoiceNumber}</td>
                          {this.props.isShowMercDelete && (
                            <td className="text-center">
                              {/* <input type="checkbox" />
                            {ln.isUpdateInventory} */}
                              <Button
                                onClick={(e) =>
                                  this.deleteMerchandiseLine(e, ln)
                                }
                              >
                                <DeleteIcon />
                              </Button>
                            </td>
                          )}
                        </tr>
                      ))}
                    </tbody>
                  ) : null}
                </Table>
                {merchandiseLines.length != 0 ? null : (
                  <div className="no_Data_small">{"NO DATA"}</div>
                )}
              </div>
            </div>
            <div className="div_40_no_overflow">
              <div className="div_Custom_1">
                <Table id="fabrics_tables">
                  <thead>
                    <tr>
                      <th
                        onClick={(e) =>
                          this.handleSortingNonMerchandiseLinesChange(
                            e,
                            "lineNumber",
                          )
                        }
                      >
                        {this.props.order === "desc" &&
                        this.props.sortField === "lineNumber" ? (
                          <span className="drp-dwn-cntr">
                            <DropDwnUp />
                          </span>
                        ) : (
                          <span className="drp-dwn-cntr">
                            <DropDwnDown />
                          </span>
                        )}
                        <Button
                          size="sm"
                          id="fabric_Add_Button"
                          onClick={(e) =>
                            this.openNonMerchandiseLineDetailDialog(e)
                          }
                          disabled={isDisableHeaderFields}
                        >
                          <AddIcon />
                        </Button>
                      </th>
                      <th
                        onClick={(e) =>
                          this.handleSortingNonMerchandiseLinesChange(
                            e,
                            "creditSubType",
                          )
                        }
                      >
                        SubType
                        {this.props.order === "desc" &&
                        this.props.sortField === "creditSubType" ? (
                          <span className="drp-dwn-cntr">
                            <DropDwnUp />
                          </span>
                        ) : (
                          <span className="drp-dwn-cntr">
                            <DropDwnDown />
                          </span>
                        )}
                      </th>
                      <th
                        onClick={(e) =>
                          this.handleSortingNonMerchandiseLinesChange(
                            e,
                            "lineTotalAmount",
                          )
                        }
                      >
                        Total amount
                        {this.props.order === "desc" &&
                        this.props.sortField === "lineTotalAmount" ? (
                          <span className="drp-dwn-cntr">
                            <DropDwnUp />
                          </span>
                        ) : (
                          <span className="drp-dwn-cntr">
                            <DropDwnDown />
                          </span>
                        )}
                      </th>
                      <th
                        onClick={(e) =>
                          this.handleSortingNonMerchandiseLinesChange(
                            e,
                            "documentType",
                          )
                        }
                      >
                        Document Type
                        {this.props.order === "desc" &&
                        this.props.sortField === "documentType" ? (
                          <span className="drp-dwn-cntr">
                            <DropDwnUp />
                          </span>
                        ) : (
                          <span className="drp-dwn-cntr">
                            <DropDwnDown />
                          </span>
                        )}
                      </th>
                      <th
                        onClick={(e) =>
                          this.handleSortingNonMerchandiseLinesChange(
                            e,
                            "documentNumber",
                          )
                        }
                      >
                        Document#
                        {this.props.order === "desc" &&
                        this.props.sortField === "documentNumber" ? (
                          <span className="drp-dwn-cntr">
                            <DropDwnUp />
                          </span>
                        ) : (
                          <span className="drp-dwn-cntr">
                            <DropDwnDown />
                          </span>
                        )}
                      </th>
                      <th
                        onClick={(e) =>
                          this.handleSortingNonMerchandiseLinesChange(
                            e,
                            "lineStatus",
                          )
                        }
                      >
                        Status
                        {this.props.order === "desc" &&
                        this.props.sortField === "lineStatus" ? (
                          <span className="drp-dwn-cntr">
                            <DropDwnUp />
                          </span>
                        ) : (
                          <span className="drp-dwn-cntr">
                            <DropDwnDown />
                          </span>
                        )}
                      </th>
                      <th></th>
                    </tr>
                  </thead>
                  {nonMerchandiseLinesList != null ? (
                    <tbody>
                      {nonMerchandiseLinesList.map((ln, index) => (
                        <tr key={index}>
                          <td>
                            {" "}
                            <Button
                              variant="secondry"
                              className="hyperLinkText"
                              onClick={(e) =>
                                this.handleNonMerchandiseLineClick(
                                  e,
                                  ln.lineNumber,
                                  ln,
                                )
                              }
                            >
                              {ln.lineNumber}
                            </Button>
                          </td>
                          <td>{ln.creditSubType}</td>
                          <td className="text-right">{ln.lineTotalAmount}</td>
                          <td>{ln.documentType}</td>
                          <td>{ln.documentNumber}</td>
                          <td className="summary_input">
                            {" "}
                            {ModuleUtils.getCreditMemoLineStatusCaption(
                              ln.lineStatus,
                            )}
                          </td>
                          {this.props.isShowDelete && ln.lineStatus != "X" && (
                            <td className="text-center">
                              <Button
                                onClick={(e) =>
                                  this.deleteNonMerchandiseLine(e, ln)
                                }
                              >
                                <DeleteIcon />
                              </Button>
                            </td>
                          )}
                        </tr>
                      ))}
                    </tbody>
                  ) : null}
                </Table>
                {nonMerchandiseLinesList.length != 0 ? null : (
                  <div className="no_Data_small">{"NO DATA"}</div>
                )}
              </div>
            </div>
          </div>

          <div className="div_inline">
            <div className="div_70_no_overflow">
              <Row>
                <Col className="align-items-left" sm="1">
                  Remarks
                </Col>
                <Col>
                  <textarea
                    style={textAreaStyle}
                    className="form-control"
                    type="text"
                    name="comments"
                    value={cmData.comments}
                    onChange={this.onChange}
                    disabled={disableCMFormFields}
                  />
                </Col>
              </Row>
            </div>
            <div className="div_30_no_overflow header_div">
              <Row>
                <Col>
                  <FormLabel>Non-Merchandise Amt</FormLabel>{" "}
                </Col>
                <Col>
                  <NumberFormatInputbox
                    value={cmData.nonMerchandiseCreditAmount}
                    onChange={this.onChange}
                    className="summary_input text-right"
                    decimalScale={2}
                    name={"nonMerchandiseCreditAmount"}
                    disabled={true}
                  />
                </Col>
              </Row>
              <Row>
                <Col>
                  <FormLabel>Merchandise Amount</FormLabel>{" "}
                </Col>
                <Col>
                  <NumberFormatInputbox
                    value={cmData.merchandiseCreditAmount}
                    onChange={this.onChange}
                    className="summary_input text-right"
                    decimalScale={2}
                    name={"merchandiseCreditAmount"}
                    disabled={true}
                  />
                </Col>
              </Row>
              <Row>
                <Col>
                  <FormLabel>TotalCredit Amount</FormLabel>{" "}
                </Col>
                <Col>
                  <NumberFormatInputbox
                    value={cmData.totalCreditAmount}
                    className="summary_input text-right"
                    decimalScale={2}
                    name={"totalCreditAmount"}
                    onChange={this.onChange}
                    disabled={true}
                  />
                </Col>
              </Row>
              <Row>
                <Col>
                  <FormLabel>TotalApplied Amount</FormLabel>{" "}
                </Col>
                <Col>
                  <NumberFormatInputbox
                    name={"appliedAmount"}
                    onChange={this.onChange}
                    value={cmData.appliedAmount}
                    className="summary_input text-right"
                    decimalScale={2}
                    disabled={true}
                  />
                </Col>
              </Row>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
class CreditMemoHistoryDetailsForm extends React.Component {
  static contextType = AppContext;
  constructor(props) {
    super(props);
  }
  componentDidMount() {
    //
  }
  handleSortingStatusChange = (e, accessor) => {
    if (e.detail === 1) this.props.handleSortingStatusChange(accessor);
  };
  render() {
    let cmData = this.props.cmData;
    let statusTracks = new Array();
    let statusTrackList = this.props.statusTrackList;
    if (statusTrackList != null) {
      statusTracks = statusTrackList;
    }
    return (
      <div className="header_div">
        <div className="div_Custom_1">
          <Table id="fabrics_tables_default">
            <thead>
              <tr>
                <th
                  onClick={(e) =>
                    this.handleSortingStatusChange(e, "createdDate")
                  }
                >
                  Date
                  {this.props.order === "desc" &&
                  this.props.sortField === "createdDate" ? (
                    <span className="drp-dwn-cntr">
                      <DropDwnUp />
                    </span>
                  ) : (
                    <span className="drp-dwn-cntr">
                      <DropDwnDown />
                    </span>
                  )}
                </th>
                <th
                  onClick={(e) =>
                    this.handleSortingStatusChange(e, "currentStatus")
                  }
                >
                  Status
                  {this.props.order === "desc" &&
                  this.props.sortField === "currentStatus" ? (
                    <span className="drp-dwn-cntr">
                      <DropDwnUp />
                    </span>
                  ) : (
                    <span className="drp-dwn-cntr">
                      <DropDwnDown />
                    </span>
                  )}
                </th>
                <th
                  onClick={(e) =>
                    this.handleSortingStatusChange(e, "totalCreditAmount")
                  }
                >
                  CreditAmount
                  {this.props.order === "desc" &&
                  this.props.sortField === "totalCreditAmount" ? (
                    <span className="drp-dwn-cntr">
                      <DropDwnUp />
                    </span>
                  ) : (
                    <span className="drp-dwn-cntr">
                      <DropDwnDown />
                    </span>
                  )}
                </th>
                <th
                  onClick={(e) =>
                    this.handleSortingStatusChange(e, "previousStatus")
                  }
                >
                  PreviousStatus
                  {this.props.order === "desc" &&
                  this.props.sortField === "previousStatus" ? (
                    <span className="drp-dwn-cntr">
                      <DropDwnUp />
                    </span>
                  ) : (
                    <span className="drp-dwn-cntr">
                      <DropDwnDown />
                    </span>
                  )}
                </th>
                <th
                  onClick={(e) =>
                    this.handleSortingStatusChange(e, "createdBy")
                  }
                >
                  DoneBy
                  {this.props.order === "desc" &&
                  this.props.sortField === "createdBy" ? (
                    <span className="drp-dwn-cntr">
                      <DropDwnUp />
                    </span>
                  ) : (
                    <span className="drp-dwn-cntr">
                      <DropDwnDown />
                    </span>
                  )}
                </th>
              </tr>
            </thead>
            {statusTracks != null ? (
              <tbody>
                {statusTracks.map((ln, index) => (
                  <tr key={index}>
                    <td className="text-right">
                      {ModuleUtils.getDateFormat_v1(ln.createdDate)}
                    </td>
                    <td className="text-right">
                      {ModuleUtils.getCreditMemoStatusCaption(ln.currentStatus)}
                    </td>
                    <td className="text-right">{ln.totalCreditAmount}</td>
                    <td className="text-right">
                      {ModuleUtils.getCreditMemoStatusCaption(
                        ln.previousStatus,
                      )}
                    </td>
                    <td className="text-right">{ln.createdBy}</td>
                  </tr>
                ))}
              </tbody>
            ) : null}
          </Table>
          {statusTracks.length != 0 ? null : (
            <div className="no_Data">{"NO DATA"}</div>
          )}
        </div>
      </div>
    );
  }
}
class CreditMemoPaymentDetailsForm extends React.Component {
  static contextType = AppContext;
  constructor(props) {
    super(props);
  }
  componentDidMount() {
    //
  }
  viewInvoiceModule = (e, code) => {
    if (e.detail == 1) this.props.viewInvoiceModule(code);
  };
  viewARModule = (e, code) => {
    if (e.detail == 1) this.props.viewARModule(code);
  };
  handleSortingCreditMemoAppliedLinesChange = (e, accessor) => {
    if (e.detail === 1)
      this.props.handleSortingCreditMemoAppliedLinesChange(accessor);
  };
  handleSortingReturnPaymentChange = (e, accessor) => {
    if (e.detail === 1) this.props.handleSortingReturnPaymentChange(accessor);
  };
  render() {
    let returnPayment = new Array();
    let creditMemoAppliedLines = new Array();
    let cmData = this.props.cmData;
    let returnPaymentLines = this.props.returnPaymentLinesList;
    returnPayment = returnPaymentLines;
    // returnPayment = cmData.returnPaymentDetails;
    creditMemoAppliedLines = this.props.creditMemoAppliedLines;
    return (
      <div className="header_div">
        <MultiViewPopup
          isModulePopup={true}
          id="modulePopup"
          popupLvlClass={"popupSizeLevel0"}
          isShowPopup={this.props.isShowARModule}
          closeModalCallBack={this.props.closeModalCallBack}
          module={this.props.moduleForPopup}
        ></MultiViewPopup>
        <MultiViewPopup
          isModulePopup={true}
          id="modulePopup"
          popupLvlClass={"popupSizeLevel0"}
          isShowPopup={this.props.isShowInvoiceModule}
          closeModalCallBack={this.props.closeModalCallBack}
          module={this.props.moduleForPopup}
        ></MultiViewPopup>
        <div>
          <div>
            <Row>
              <Col sm="1">
                <FormLabel>Total Credit Amount</FormLabel>
              </Col>
              <Col sm="3">
                <NumberFormatInputbox
                  className="summary_input text-right"
                  value={cmData.totalCreditAmount}
                  decimalScale={2}
                  disabled={true}
                />
              </Col>
              <Col sm="1">
                <FormLabel>Applied Amount</FormLabel>
              </Col>
              <Col sm="3">
                <NumberFormatInputbox
                  className="summary_input text-right"
                  value={cmData.appliedAmount}
                  decimalScale={2}
                  disabled={true}
                />
              </Col>
              <Col sm="1">
                <FormLabel>Provisional AppliedAmt</FormLabel>
              </Col>
              <Col sm="3">
                <NumberFormatInputbox
                  className="summary_input text-right"
                  value={cmData.provisionalAppliedAmount}
                  decimalScale={2}
                  disabled={true}
                />
              </Col>
            </Row>
          </div>
          <div className="div_inline">
            {" "}
            <div class="div_Equal">
              <FormLabel className="label_head">
                {" "}
                Payment Applied Lines [Paid on Invoice]{" "}
              </FormLabel>
              <Table id="fabrics_tables_default">
                <thead>
                  <th
                    onClick={(e) =>
                      this.handleSortingCreditMemoAppliedLinesChange(
                        e,
                        "invoiceNumber",
                      )
                    }
                  >
                    Invoice
                    {this.props.order === "desc" &&
                    this.props.sortField === "invoiceNumber" ? (
                      <span className="drp-dwn-cntr">
                        <DropDwnUp />
                      </span>
                    ) : (
                      <span className="drp-dwn-cntr">
                        <DropDwnDown />
                      </span>
                    )}
                  </th>
                  <th
                    onClick={(e) =>
                      this.handleSortingCreditMemoAppliedLinesChange(
                        e,
                        "accountReceivableNumber",
                      )
                    }
                  >
                    Ar#
                    {this.props.order === "desc" &&
                    this.props.sortField === "accountReceivableNumber" ? (
                      <span className="drp-dwn-cntr">
                        <DropDwnUp />
                      </span>
                    ) : (
                      <span className="drp-dwn-cntr">
                        <DropDwnDown />
                      </span>
                    )}
                  </th>
                  <th
                    onClick={(e) =>
                      this.handleSortingCreditMemoAppliedLinesChange(
                        e,
                        "paymentAmount",
                      )
                    }
                  >
                    paymentAmount
                    {this.props.order === "desc" &&
                    this.props.sortField === "paymentAmount" ? (
                      <span className="drp-dwn-cntr">
                        <DropDwnUp />
                      </span>
                    ) : (
                      <span className="drp-dwn-cntr">
                        <DropDwnDown />
                      </span>
                    )}
                  </th>
                  <th
                    onClick={(e) =>
                      this.handleSortingCreditMemoAppliedLinesChange(
                        e,
                        "currencyCode",
                      )
                    }
                  >
                    currencyCode
                    {this.props.order === "desc" &&
                    this.props.sortField === "currencyCode" ? (
                      <span className="drp-dwn-cntr">
                        <DropDwnUp />
                      </span>
                    ) : (
                      <span className="drp-dwn-cntr">
                        <DropDwnDown />
                      </span>
                    )}
                  </th>
                </thead>
                <tbody>
                  {creditMemoAppliedLines.map((list, index) => (
                    <tr key={index}>
                      <td className="text-right">
                        <Button
                          size="sm"
                          variant="secondry"
                          className="hyperLinkText"
                          onClick={(e) =>
                            this.viewInvoiceModule(e, list.invoiceNumber)
                          }
                        >
                          {list.invoiceNumber}
                        </Button>
                      </td>
                      <td className="text-right">
                        <Button
                          size="sm"
                          variant="secondry"
                          className="hyperLinkText"
                          onClick={(e) =>
                            this.viewARModule(e, list.accountReceivableNumber)
                          }
                        >
                          {list.accountReceivableNumber}
                        </Button>
                      </td>
                      <td className="text-right">{list.paymentAmount}</td>
                      <td className="text-right">{list.currencyCode}</td>
                    </tr>
                  ))}
                </tbody>
              </Table>
              {creditMemoAppliedLines.length != 0 ? null : (
                <div className="no_Data">{"NO DATA"}</div>
              )}
            </div>
            <div class="div_Equal">
              <FormLabel className="label_head">
                {" "}
                Payment Applied Lines [Refund To Customer]{" "}
              </FormLabel>

              <Table id="fabrics_tables_default">
                <thead>
                  <th
                    onClick={(e) =>
                      this.handleSortingReturnPaymentChange(
                        e,
                        "creditMemoReturnPaymentDate",
                      )
                    }
                  >
                    creditMemoReturnPaymentDate
                    {this.props.order === "desc" &&
                    this.props.sortField === "creditMemoReturnPaymentDate" ? (
                      <span className="drp-dwn-cntr">
                        <DropDwnUp />
                      </span>
                    ) : (
                      <span className="drp-dwn-cntr">
                        <DropDwnDown />
                      </span>
                    )}
                  </th>
                  <th
                    onClick={(e) =>
                      this.handleSortingReturnPaymentChange(e, "cashAmount")
                    }
                  >
                    PaymentMode
                    {this.props.order === "desc" &&
                    this.props.sortField === "cashAmount" ? (
                      <span className="drp-dwn-cntr">
                        <DropDwnUp />
                      </span>
                    ) : (
                      <span className="drp-dwn-cntr">
                        <DropDwnDown />
                      </span>
                    )}
                  </th>
                  <th
                    onClick={(e) =>
                      this.handleSortingReturnPaymentChange(e, "remarks")
                    }
                  >
                    OtherDetails
                    {this.props.order === "desc" &&
                    this.props.sortField === "remarks" ? (
                      <span className="drp-dwn-cntr">
                        <DropDwnUp />
                      </span>
                    ) : (
                      <span className="drp-dwn-cntr">
                        <DropDwnDown />
                      </span>
                    )}
                  </th>
                  <th
                    onClick={(e) =>
                      this.handleSortingReturnPaymentChange(e, "cashAmount")
                    }
                  >
                    AmountPaidToCustomer
                    {this.props.order === "desc" &&
                    this.props.sortField === "cashAmount" ? (
                      <span className="drp-dwn-cntr">
                        <DropDwnUp />
                      </span>
                    ) : (
                      <span className="drp-dwn-cntr">
                        <DropDwnDown />
                      </span>
                    )}
                  </th>
                </thead>
                <tbody>
                  {returnPayment.map((list, index) => (
                    <tr key={index}>
                      <td>{list.creditMemoReturnPaymentDate}</td>
                      {list.cashAmount > 0 && <td>{"CASH"}</td>}
                      {list.checkAmount > 0 && <td>{"CHECK"}</td>}
                      {list.cardAmount > 0 && <td>{"CARD"}</td>}
                      <td>{list.remarks}</td>
                      {list.cashAmount > 0 && <td>{list.cashAmount}</td>}
                      {list.checkAmount > 0 && <td>{list.checkAmount}</td>}
                      {list.checkAmount > 0 && <td>{list.checkAmount}</td>}
                    </tr>
                  ))}
                </tbody>
              </Table>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
class SalesCommissionEntryForm extends React.Component {
  static contextType = AppContext;
  constructor(props) {
    super(props);
    this.salesPersonRef = React.createRef();
    this.state = {};
  }
  componentDidMount() {
    const { appData } = this.context;
    this.companyCode = appData.companyCode;
    this.initLookupHandlers();
  }
  initLookupHandlers = () => {
    let salesPersonLookupHandler = new GenericAttributeLookupHandler(
      this.props.salesPersonList,
      "Sales Person",
    );
    this.setState({ salesPersonLookupHandler: salesPersonLookupHandler });
    let reasonLookupHandler = new GenericAttributeLookupHandler(
      this.props.creditReasons,
      "Reason",
    );
    this.setState({ reasonLookupHandler: reasonLookupHandler });
  };
  onChange = (e) => {
    this.props.onChange(e);
  };
  onCommissionChange = (e) => {
    this.props.onCommissionChange(e);
  };
  onAddorUpdateCommissionClick = (e) => {
    if (e.detail == 1) this.props.onAddorUpdateCommissionClick(e);
    if (this.salesPersonRef.current != null) {
      this.salesPersonRef.current.clear();
    }
  };
  onClearCommissionClick = (e) => {
    if (e.detail == 1) this.props.onClearCommissionClick(e);
  };
  // reArrangeCommissionLineNumbers = (LineList) => {
  //   let maxLineNumber = 0;
  //   LineList.map((line) => {
  //     ++maxLineNumber;
  //     line.lineNumber = maxLineNumber;
  //   });
  // };
  buttonClickCallback = (e, val, rowData) => {
    if (e.detail == 1) {
      this.props.buttonClickCallback(rowData);
      // let cmData = this.props.cmData;
      // let lineData = cmData.creditMemoSalesPersons;
      // if (rowData.isFetched == false) {
      //   var index = lineData.indexOf(rowData);
      //   if (index > -1) {
      //     lineData.splice(index, 1);
      //   }
      // } else {

      // }
      // this.reArrangeCommissionLineNumbers(lineData);
      // this.setState({ cmData: cmData });
    }
  };
  handleLineNumberClick = (e, val, rowData) => {
    if (e.detail == 1) this.props.getCommissionLineDetails(val, rowData);
  };
  commissionOnChange = (e) => {
    this.props.commissionOnChange(e);
  };
  commissionEnterKeyEvent = (e) => {
    this.props.commissionEnterKeyEvent(e);
  };
  displayCommissionAutoCompleteList = (showAutoCompleteList) => {
    this.props.displayCommissionAutoCompleteList(showAutoCompleteList);
  };
  reasonOnChange = (e) => {
    this.props.reasonOnChange(e);
  };
  reasonEnterKeyEvent = (e) => {
    this.props.reasonEnterKeyEvent(e);
  };
  displayReasonAutoCompleteList = (showAutoCompleteList) => {
    this.props.displayReasonAutoCompleteList(showAutoCompleteList);
  };

  handleSortingCreditMemoCommisionListChange = (e, accessor) => {
    if (e.detail === 1)
      this.props.handleSortingCreditMemoCommisionListChange(accessor);
  };
  salesCommissionColumn = () => {
    const columns = new Array();
    columns.push(
      new ColumnDefinition()
        .setDetails("Ln#", "lineNumber", true)
        .setStyleDetails("left", "", "", "wt-2 ", "wt-2")
        .setClickDetails(true, false, this.handleLineNumberClick, null),
    );

    columns.push(
      new ColumnDefinition()
        .setDetails("SalesPerson", "salesPersonCode", true)
        .setStyleDetails("left", "", "", "wt-4", "wt-4"),
    );

    columns.push(
      new ColumnDefinition()
        .setDetails("SalesPersonName", "salesPersonName", true)
        .setStyleDetails("left", "", "", "wt-4 ", "wt-4 "),
    );

    columns.push(
      new ColumnDefinition()
        .setDetails("Commission%", "commissionDeductionPercentage", true)
        .setStyleDetails("left", "", "", "wt-4 ", "wt-4 "),
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("", <DeleteIcon />, false)
        // .setHeaderDetails(true, <AddIcon />, this.addNewSalesOrderLine, false)
        .setStyleDetails("", "", "", "wt-2", "wt-2")

        .setClickDetails(false, true, this.buttonClickCallback, <DeleteIcon />)
        .setDisabled(this.props.disableCMFormFields),
    );

    return columns;
  };

  render() {
    let cmData = new CreditMemoBean();
    cmData = this.props.cmData;
    let commissionData = new CreditMemoSalesPersonBean();
    commissionData = this.props.commissionData;
    let commissions = [];
    // if (!isEmpty(cmData) && !isEmpty(cmData.creditMemoSalesPersons))
    //   commissions = cmData.creditMemoSalesPersons;

    // let creditMemoCommisionList = this.props.creditMemoCommisionList;
    // if (
    //   !isEmpty(creditMemoCommisionList) &&
    //   !isEmpty(creditMemoCommisionList)
    // ) {
    //   commissions = creditMemoCommisionList;
    // }
    // let commissions = [];
    if (!isEmpty(cmData) && !isEmpty(cmData.creditMemoSalesPersons)) {
      cmData.creditMemoSalesPersons.map((line) => {
        if (!line.isDeleted) {
          commissions.push(line);
        }
      });
    }
    let isModify = this.props.isModifyPosible();
    let disableCMFormFields = this.props.disableCMFormFields;
    let disableUpdatableFields = false;
    if (disableCMFormFields) {
      if (isModify) {
        disableUpdatableFields = false;
      } else {
        disableUpdatableFields = true;
      }
    }
    if (this.props.isViewMode) {
      disableUpdatableFields = true;
    }
    const textAreaStyle = {
      height: "7em",
      width: "55em",
      resize: "none",
      padding: "2px",
      boxSizing: "border-box",
      fontSize: "15px",
    };
    return (
      <div className="header_div">
        <div className="div_Custom_3">
          <CustomTable
            data={commissions}
            columns={this.salesCommissionColumn()}
            label={"Commission"}
          />
        </div>
        {/* <div className="div_Custom_1">
          <Table id="fabrics_tables_default">
            <thead>
              <tr>
                <th
                  onClick={(e) =>
                    this.handleSortingCreditMemoCommisionListChange(
                      e,
                      "lineNumber",
                    )
                  }
                >
                  ln
                  {this.props.order === "desc" &&
                  this.props.sortField === "lineNumber" ? (
                    <span className="drp-dwn-cntr">
                      <DropDwnUp />
                    </span>
                  ) : (
                    <span className="drp-dwn-cntr">
                      <DropDwnDown />
                    </span>
                  )}
                </th>
                <th
                  onClick={(e) =>
                    this.handleSortingCreditMemoCommisionListChange(
                      e,
                      "salesPersonCode",
                    )
                  }
                >
                  SalesPerson
                  {this.props.order === "desc" &&
                  this.props.sortField === "salesPersonCode" ? (
                    <span className="drp-dwn-cntr">
                      <DropDwnUp />
                    </span>
                  ) : (
                    <span className="drp-dwn-cntr">
                      <DropDwnDown />
                    </span>
                  )}
                </th>
                <th
                  onClick={(e) =>
                    this.handleSortingCreditMemoCommisionListChange(
                      e,
                      "reasonCode",
                    )
                  }
                >
                  Reason
                  {this.props.order === "desc" &&
                  this.props.sortField === "reasonCode" ? (
                    <span className="drp-dwn-cntr">
                      <DropDwnUp />
                    </span>
                  ) : (
                    <span className="drp-dwn-cntr">
                      <DropDwnDown />
                    </span>
                  )}
                </th>
                <th
                  onClick={(e) =>
                    this.handleSortingCreditMemoCommisionListChange(
                      e,
                      "commissionDeductionPercentage",
                    )
                  }
                >
                  Commission percentage
                  {this.props.order === "desc" &&
                  this.props.sortField === "commissionDeductionPercentage" ? (
                    <span className="drp-dwn-cntr">
                      <DropDwnUp />
                    </span>
                  ) : (
                    <span className="drp-dwn-cntr">
                      <DropDwnDown />
                    </span>
                  )}
                </th>
                <th
                  onClick={(e) =>
                    this.handleSortingCreditMemoCommisionListChange(
                      e,
                      "remarks",
                    )
                  }
                >
                  Remarks
                  {this.props.order === "desc" &&
                  this.props.sortField === "remarks" ? (
                    <span className="drp-dwn-cntr">
                      <DropDwnUp />
                    </span>
                  ) : (
                    <span className="drp-dwn-cntr">
                      <DropDwnDown />
                    </span>
                  )}
                </th>
                <th></th>
              </tr>
            </thead>
            {commissions != null ? (
              <tbody>
                {commissions.map((ln, index) => (
                  <tr key={index}>
                    <td className="text-right">
                      {" "}
                      <Button
                        size="sm"
                        variant="secondry"
                        className="hyperLinkText"
                        onClick={(e) =>
                          this.handleLineNumberClick(e, ln.lineNumber, ln)
                        }
                      >
                        {ln.lineNumber}
                      </Button>
                    </td>
                    <td className="text-right">{ln.salesPersonCode}</td>
                    <td className="text-right">{ln.reasonCode}</td>
                    <td className="text-right">
                      {ln.commissionDeductionPercentage}
                    </td>
                    <td className="text-right">{ln.remarks}</td>
                    <td>
                      <Button
                        onClick={(e) => this.buttonClickCallback(e, ln)}
                        disabled={disableCMFormFields}
                      >
                        <DeleteIcon />
                      </Button>
                    </td>
                  </tr>
                ))}
              </tbody>
            ) : null}
          </Table>
          {commissions.length != 0 ? null : (
            <div className="no_Data">{"NO DATA"}</div>
          )}
        </div> */}
        <div>
          <Row>
            <Col sm="1">
              {" "}
              <FormLabel>Ln#</FormLabel>{" "}
            </Col>
            <Col sm="2">
              <InputTextbox
                name="lineNumber"
                type="text"
                onChange={this.onCommissionChange}
                readOnly={true}
                value={commissionData.lineNumber}
              />{" "}
            </Col>
            <Col sm="1">
              {" "}
              <FormLabel>SalesPerson</FormLabel>{" "}
            </Col>
            <Col sm="2">
              <InputTextbox
                onChange={this.commissionOnChange}
                placeholder="salesPersonCode"
                name="salesPersonCode"
                ref={this.salesPersonRef}
                value={commissionData.salesPersonCode}
                lookupRequired={true}
                lookupHandler={this.state.salesPersonLookupHandler}
                showCriteriaDialog={true}
                enterKeyEventHandler={this.commissionEnterKeyEvent}
                autoCompleteListData={
                  this.props.commissionPageListForAutoCompleteList
                }
                enableAutoCompleteTextBox={true}
                displayAutoCompleteList={this.displayCommissionAutoCompleteList}
                showAutoCompleteList={this.props.isShowAutoCompleCommissionList}
                isModifyView={isModify}
                disabled={disableUpdatableFields}
                isMandatory={true}
              />
            </Col>
            <Col sm="1">
              {" "}
              <FormLabel>Reason</FormLabel>{" "}
            </Col>
            <Col sm="2">
              <InputTextbox
                onChange={this.reasonOnChange}
                placeholder="reasonCode"
                name="reasonCode"
                value={commissionData.reasonCode}
                lookupRequired={true}
                lookupHandler={this.state.reasonLookupHandler}
                showCriteriaDialog={true}
                enterKeyEventHandler={this.reasonEnterKeyEvent}
                autoCompleteListData={
                  this.props.reasonPageListForAutoCompleteList
                }
                enableAutoCompleteTextBox={true}
                displayAutoCompleteList={this.displayReasonAutoCompleteList}
                showAutoCompleteList={this.props.isShowAutoCompleReasonList}
                disabled={disableUpdatableFields}
                isMandatory={true}
              />
            </Col>
            <Col sm="1">
              {" "}
              <FormLabel>Commission%</FormLabel>{" "}
            </Col>
            <Col sm="2">
              <NumberFormatInputbox
                value={commissionData.commissionDeductionPercentage}
                onChange={this.onCommissionChange}
                className="summary_input text-right"
                decimalScale={2}
                name={"commissionDeductionPercentage"}
                disabled={disableUpdatableFields}
                isModifyView={isModify}
                isMandatory={true}
              />
            </Col>
          </Row>
          <Row>
            <Col sm="1">
              {" "}
              <FormLabel>Remarks</FormLabel>{" "}
            </Col>
            <Col sm="4">
              <textarea
                style={textAreaStyle}
                className="form-control"
                type="text"
                name="remarks"
                disabled={disableUpdatableFields}
                onChange={this.onCommissionChange}
                value={commissionData.remarks}
              />
            </Col>
            <Col sm="6">
              <Button
                size="sm"
                id="fabric_Add_Button"
                disabled={disableUpdatableFields}
                onClick={(e) => this.onAddorUpdateCommissionClick(e)}
              >
                Add/Update
              </Button>
              <Button
                size="sm"
                id="fabric_Add_Button"
                disabled={disableUpdatableFields}
                onClick={(e) => this.onClearCommissionClick(e)}
              >
                Clear
              </Button>
            </Col>
          </Row>
        </div>
      </div>
    );
  }
}
function CreditMemoModule(props) {
  return (
    <div id="moduleContainer" class="module_container">
      <div id="app_container"></div>
      <CreditMemoList {...props} name="" /> <br />
    </div>
  );
}

export default CreditMemoModule;
